// ============================================================================
// JAMB Question Bank — Biology
// Auto-split from QB.js for better code organisation
// ============================================================================

export const QB_BIOLOGY = [
  
    {
      yr: 2023,
      q: "The organelle responsible for the synthesis of proteins in the cell is the:",
      o: ["Mitochondrion", "Lysosome", "Ribosome", "Golgi body"],
      a: 2,
      e: "Ribosomes are the 'protein factories' where amino acids are assembled.",
      full: "Ribosomes can be found floating free in the cytoplasm or attached to the Rough Endoplasmic Reticulum (RER). Their primary job is to translate genetic code into chains of proteins that the body needs for growth and repair.",
      h: "Is the 'Protein Factory' the Ribosome or the Mitochondrion?"
    },
    {
      yr: 2023,
      q: "The movement of water molecules from a region of higher concentration to a region of lower concentration through a semi-permeable membrane is:",
      o: ["Diffusion", "Osmosis", "Plasmolysis", "Transpiration"],
      a: 1,
      e: "Osmosis is a special type of diffusion involving water and a membrane.",
      full: "For Osmosis to occur, you MUST have a semi-permeable membrane. It is how plants absorb water from the soil through their root hairs and how the human kidney reabsorbs water into the blood.",
      h: "Does 'Water + Membrane' equal 'Diffusion' or 'Osmosis'?"
    },
    {
      yr: 2023,
      q: "A structure in the ear that is responsible for maintaining balance is the:",
      o: ["Cochlea", "Ossicles", "Semicircular canals", "Eardrum"],
      a: 2,
      e: "The semicircular canals contain fluid that moves when the head moves, helping with equilibrium.",
      full: "While the Cochlea is for 'Hearing,' the Semicircular Canals are for 'Balance.' They detect rotational movements of the head, allowing you to stay upright even when spinning or tilting.",
      h: "Is 'Balance' handled by the 'Canals' or the 'Cochlea'?"
    },
    {
      yr: 2023,
      q: "In the ABO blood group system, an individual with blood group O is regarded as a universal donor because:",
      o: ["They have antigens A and B", "They lack both antigens A and B on their red blood cells", "They have antibodies a and b", "They lack antibodies a and b"],
      a: 1,
      e: "Group O blood has no antigens on the cell surface, so it won't be attacked by the recipient's antibodies.",
      full: "Since group O lacks A and B antigens, it can be given to anyone (A, B, or AB) without causing a dangerous immune reaction (agglutination). However, group O can only *receive* blood from another group O.",
      h: "Is it because they 'Have' antigens or 'Lack' them?"
    },
    {
      yr: 2023,
      q: "The sequence of the stages in mitosis is:",
      o: ["Prophase, Metaphase, Anaphase, Telophase", "Telophase, Anaphase, Metaphase, Prophase", "Metaphase, Prophase, Telophase, Anaphase", "Anaphase, Telophase, Prophase, Metaphase"],
      a: 0,
      e: "Mitosis follows the PMAT order.",
      full: "Prophase (Preparation), Metaphase (Middle alignment), Anaphase (Away movement of chromatids), and Telophase (Two new nuclei). This process results in two identical daughter cells.",
      h: "Remember the acronym 'PMAT'. Which starts with P?"
    },
    {
      yr: 2023,
      q: "Which of the following organisms exhibits heterotrophic nutrition?",
      o: ["Spirogyra", "Mushroom", "Chlamydomonas", "Maize plant"],
      a: 1,
      e: "Mushrooms are fungi; they cannot make their own food and must absorb nutrients from organic matter.",
      full: "Unlike Spirogyra or Maize which use photosynthesis (Autotrophs), mushrooms lack chlorophyll. They are 'Saprophytes' that feed on dead and decaying matter.",
      h: "Can a 'Mushroom' photosynthesize like a green plant?"
    },
    {
      yr: 2023,
      q: "The process by which green plants lose water to the atmosphere through the stomata is:",
      o: ["Evaporation", "Guttation", "Transpiration", "Respiration"],
      a: 2,
      e: "Transpiration is the loss of water vapor specifically from the aerial parts of plants.",
      full: "This process creates a 'Transpiration Pull,' which helps the plant draw water and minerals all the way from the roots to the leaves. It also helps cool the plant down in hot weather.",
      h: "Is it 'Sweating' for plants (Transpiration) or 'Breathing' (Respiration)?"
    },
    {
      yr: 2023,
      q: "The part of the brain that controls heartbeat and breathing is the:",
      o: ["Cerebrum", "Cerebellum", "Medulla oblongata", "Thalamus"],
      a: 2,
      e: "The medulla oblongata controls involuntary actions (autonomic functions).",
      full: "While the Cerebrum is for 'Thinking' and the Cerebellum is for 'Muscle Coordination,' the Medulla is the 'Life Support' center. It works even when you are asleep to keep your heart beating and lungs moving.",
      h: "Is 'Heartbeat' controlled by the 'Thinking' part or the 'Medulla'?"
    },
    {
      yr: 2023,
      q: "In a food chain, the flow of energy is always:",
      o: ["Cyclic", "Multidirectional", "Unidirectional", "Reversible"],
      a: 2,
      e: "Energy moves in one direction: from Producers to Consumers.",
      full: "Energy is lost as heat at every level (Trophic level). This is why energy cannot 'cycle' back to the sun; once it is used by an organism or lost as heat, it's gone from the chain.",
      h: "Does energy 'Cycle' back to the sun or move 'One Way'?"
    },
    {
      yr: 2023,
      q: "The dental formula of an adult human is:",
      o: ["i 2/2, c 1/1, pm 2/2, m 2/2", "i 2/2, c 1/1, pm 2/2, m 3/3", "i 3/3, c 1/1, pm 4/4, m 2/2", "i 2/2, c 0/0, pm 3/3, m 3/3"],
      a: 1,
      e: "The formula represents half of the upper and lower jaw: 2 Incisors, 1 Canine, 2 Premolars, 3 Molars.",
      full: "Multiplying (2+1+2+3) by 2 for the upper jaw and the same for the lower jaw gives a total of 32 teeth. This includes the 'wisdom teeth' (the 3rd molars).",
      h: "How many Molars does an adult have on 'One Side' of a jaw?"
    },
    {
      yr: 2023,
      q: "The theory of use and disuse was propounded by:",
      o: ["Charles Darwin", "Jean-Baptiste Lamarck", "Gregor Mendel", "Alfred Wallace"],
      a: 1,
      e: "Lamarck suggested that organs used frequently become more developed, while those not used wither away.",
      full: "A classic example used by Lamarck was the giraffe's neck. He believed giraffes stretched their necks to reach high leaves, and this 'acquired trait' was passed to their children. Darwin later corrected this with 'Natural Selection.'",
      h: "Was it 'Darwin' or 'Lamarck'?"
    },
    {
      yr: 2023,
      q: "A deficiency of Vitamin K in the diet leads to:",
      o: ["Night blindness", "Beri-beri", "Poor blood clotting", "Rickets"],
      a: 2,
      e: "Vitamin K is essential for the production of prothrombin, a protein used in blood clotting.",
      full: "Without enough Vitamin K, a small cut could lead to excessive bleeding because the 'clotting cascade' cannot complete. It is often found in green leafy vegetables.",
      h: "Is Vitamin K for 'Eyes' or for 'Blood Clotting'?"
    },
    {
      yr: 2023,
      q: "The functional unit of the kidney is the:",
      o: ["Ureter", "Nephron", "Bladder", "Pelvis"],
      a: 1,
      e: "The nephron is where the actual filtration and reabsorption of blood occurs.",
      full: "Each human kidney contains about one million nephrons. Each nephron consists of a Bowman’s capsule, a glomerulus, and a long tubule that balances water and salts in the body.",
      h: "Is the 'Worker' in the kidney called a 'Neuron' or a 'Nephron'?"
    },
    {
      yr: 2023,
      q: "Which of the following is an example of a vestigial organ in humans?",
      o: ["Heart", "Appendix", "Kidney", "Liver"],
      a: 1,
      e: "Vestigial organs are structures that have lost their original function through evolution.",
      full: "The appendix is thought to have helped our ancestors digest tough plant fibers (cellulose). Today, it is small and has no major digestive role, though it may have some immune function.",
      h: "Which organ is 'Useless' but still in the body?"
    },
    {
      yr: 2023,
      q: "The process of anaerobic respiration in yeast produces:",
      o: ["Carbon dioxide and water", "Ethanol and carbon dioxide", "Lactic acid and energy", "Oxygen and glucose"],
      a: 1,
      e: "This process is also known as fermentation.",
      full: "In the absence of oxygen, yeast breaks down glucose into ethanol (alcohol) and CO2. This is the biological basis for baking bread (CO2 makes it rise) and brewing beer.",
      h: "Does yeast produce 'Lactic Acid' or 'Ethanol/Alcohol'?"
    },
    {
      yr: 2023,
      q: "In genetics, the physical appearance of an organism is called its:",
      o: ["Genotype", "Phenotype", "Allele", "Locus"],
      a: 1,
      e: "Phenotype refers to observable traits like height or eye color.",
      full: "The 'Genotype' is the actual genetic code (e.g., Tt), while the 'Phenotype' is what you actually see (e.g., Tall). The phenotype is determined by both the genotype and the environment.",
      h: "Is it the 'Genetic code' or the 'Physical appearance'?"
    },
    {
      yr: 2023,
      q: "The respiratory organ of an insect is the:",
      o: ["Gills", "Lungs", "Tracheal system", "Cell membrane"],
      a: 2,
      e: "Insects breathe through small holes called spiracles that lead into a network of tubes (tracheae).",
      full: "Unlike humans, insects don't use their blood to transport oxygen. The tracheal system carries air directly to the tissues and cells of the insect's body.",
      h: "Do insects use 'Lungs' or 'Tracheal tubes'?"
    },
    {
      yr: 2023,
      q: "An example of a fruit that is a caryopsis is:",
      o: ["Mango", "Maize grain", "Coconut", "Tomato"],
      a: 1,
      e: "A caryopsis is a dry indehiscent fruit where the seed coat is fused with the fruit wall.",
      full: "Cereals like maize, rice, and wheat are caryopses. Because the seed and the fruit are so tightly joined, we often call the whole thing a 'grain' rather than a 'fruit'.",
      h: "Is it 'Mango' or 'Maize'?"
    },
    {
      yr: 2023,
      q: "The joint between the femur and the pelvic girdle is an example of a:",
      o: ["Hinge joint", "Saddle joint", "Ball and socket joint", "Gliding joint"],
      a: 2,
      e: "This joint allows for movement in many directions (360 degrees).",
      full: "The round 'ball' of the femur fits into the 'socket' (acetabulum) of the hip. This is the same type of joint found in the shoulder.",
      h: "Does it move like a 'Door hinge' or 'All around'?"
    },
    {
      yr: 2023,
      q: "The hormone that regulates the level of sugar in the blood is:",
      o: ["Adrenaline", "Insulin", "Thyroxine", "Auxin"],
      a: 1,
      e: "Insulin is produced by the pancreas to lower blood glucose levels.",
      full: "When blood sugar is high (after a meal), the islets of Langerhans in the pancreas release insulin, which tells the liver to convert glucose into glycogen for storage. A lack of insulin leads to Diabetes.",
      h: "Is it 'Insulin' or 'Adrenaline'?"
    },
    {
      yr: 2023,
      q: "The part of the flower that receives pollen grains during pollination is the:",
      o: ["Ovary", "Style", "Stigma", "Anther"],
      a: 2,
      e: "The stigma is the sticky top part of the carpel designed to catch pollen.",
      full: "Pollination is simply the transfer of pollen from the Anther (male) to the Stigma (female). Once the pollen lands on the stigma, it grows a tube down the Style to reach the Ovary for fertilization.",
      h: "Is the 'Receiver' the 'Stigma' or the 'Anther'?"
    },


    {
      yr: 2022,
      q: "The level of organization of a Paramecium is the:",
      o: ["Tissue level", "System level", "Cellular level", "Organ level"],
      a: 2,
      e: "Paramecium is a unicellular organism, meaning a single cell performs all life functions.",
      full: "As a protozoan, the Paramecium represents the cellular level of organization. It carries out feeding, movement, and reproduction within a single cell membrane using specialized organelles.",
      h: "Is a 'Single Cell' the 'Cellular' or 'Tissue' level?"
    },
    {
      yr: 2022,
      q: "The movement of water molecules from a region of higher concentration to a region of lower concentration through a semi-permeable membrane is:",
      o: ["Diffusion", "Osmosis", "Plasmolysis", "Transpiration"],
      a: 1,
      e: "Osmosis specifically refers to the movement of 'water' through a 'semi-permeable membrane'.",
      full: "While diffusion is the movement of any particles, Osmosis is the special case for water. This process is crucial for plants to absorb water from the soil through their root hairs.",
      h: "Does 'Water + Membrane' mean 'Diffusion' or 'Osmosis'?"
    },
    {
      yr: 2022,
      q: "Which of the following organisms is a primary producer in an aquatic habitat?",
      o: ["Tadpole", "Water lily", "Fish", "Mosquito larva"],
      a: 1,
      e: "Producers are autotrophs (plants/algae) that manufacture food via photosynthesis.",
      full: "In an aquatic food chain, green plants like the Water lily or microscopic Phytoplankton capture solar energy to produce glucose, forming the base of the energy pyramid.",
      h: "Is the 'Producer' the 'Plant' or the 'Animal'?"
    },
    {
      yr: 2022,
      q: "The vitamin that is essential for the clotting of blood is:",
      o: ["Vitamin A", "Vitamin B", "Vitamin C", "Vitamin K"],
      a: 3,
      e: "Vitamin K is required for the synthesis of prothrombin, a key protein in blood coagulation.",
      full: "Without Vitamin K, even a small cut could lead to excessive bleeding. It is often found in green leafy vegetables and is also produced by bacteria in the human gut.",
      h: "Is 'Clotting' linked to Vitamin 'C' or 'K'?"
    },
    {
      yr: 2022,
      q: "The interaction between a remora fish and a shark, where the remora benefits and the shark is unaffected, is called:",
      o: ["Mutualism", "Parasitism", "Commensalism", "Competition"],
      a: 2,
      e: "Commensalism is a relationship where one organism benefits (+) and the other is neutral (0).",
      full: "The remora attaches to the shark for transport and food scraps. The shark is neither harmed nor helped. This differs from Mutualism where both must benefit.",
      h: "Is 'One Benefits, One Neutral' called 'Mutualism' or 'Commensalism'?"
    },
    {
      yr: 2022,
      q: "Which part of the mammalian ear is responsible for maintaining body balance?",
      o: ["Cochlea", "Pinna", "Eardrum", "Semicircular canals"],
      a: 3,
      e: "The semicircular canals contain fluid that moves when the head shifts, signaling balance to the brain.",
      full: "While the Cochlea is for hearing, the three semicircular canals are dedicated to equilibrium. They detect rotational movements of the head in different planes.",
      h: "Is 'Balance' handled by the 'Cochlea' or the 'Canals'?"
    },
    {
      yr: 2022,
      q: "The group of bacteria that convert atmospheric nitrogen into nitrates are:",
      o: ["Nitrifying bacteria", "Denitrifying bacteria", "Nitrogen-fixing bacteria", "Putrefying bacteria"],
      a: 2,
      e: "Nitrogen-fixing bacteria (like Rhizobium) convert nitrogen gas into forms plants can use.",
      full: "These bacteria are often found in the root nodules of leguminous plants. They play a vital role in the nitrogen cycle by 'fixing' the inert gas into usable soil nutrients.",
      h: "Do they 'Fix' the nitrogen or 'Denitrify' it?"
    },
    {
      yr: 2022,
      q: "In genetics, the physical and observable appearance of an organism is its:",
      o: ["Genotype", "Phenotype", "Allele", "Hybrid"],
      a: 1,
      e: "The phenotype is the outward expression of the genes (e.g., tallness, eye color).",
      full: "Genotype refers to the actual genetic code (TT or Tt), while Phenotype is what you actually see (Tall). Phenotype is often influenced by both genes and the environment.",
      h: "Is 'Physical Appearance' the 'Genotype' or 'Phenotype'?"
    },
    {
      yr: 2022,
      q: "Which of the following is an example of a flightless bird?",
      o: ["Pigeon", "Kiwi", "Eagle", "Vulture"],
      a: 1,
      e: "The Kiwi is a ratite bird from New Zealand that cannot fly.",
      full: "Flightless birds like the Kiwi, Ostrich, and Penguin have evolved to survive in environments where flight wasn't necessary for escaping predators or finding food.",
      h: "Is the 'Kiwi' or the 'Eagle' flightless?"
    },
    {
      yr: 2022,
      q: "The site for protein synthesis in the cell is the:",
      o: ["Mitochondrion", "Lysosome", "Ribosome", "Golgi body"],
      a: 2,
      e: "Ribosomes are the 'Protein Factories' where amino acids are assembled into proteins.",
      full: "Ribosomes can be found floating freely in the cytoplasm or attached to the Rough Endoplasmic Reticulum. They translate genetic code into functional proteins.",
      h: "Are 'Proteins' made in the 'Mitochondrion' or 'Ribosome'?"
    },
    {
      yr: 2022,
      q: "A pair of genes that control the same character and occupy the same locus on homologous chromosomes are:",
      o: ["Hybrids", "Alleles", "Chromatids", "Gametes"],
      a: 1,
      e: "Alleles are alternative forms of the same gene (e.g., the gene for height has 'Tall' and 'Short' alleles).",
      full: "Every trait is usually controlled by two alleles. If the alleles are identical (TT), it is homozygous; if they are different (Tt), it is heterozygous.",
      h: "Are 'Gene Variants' called 'Alleles' or 'Gametes'?"
    },
    {
      yr: 2022,
      q: "The respiratory organ used by an insect for gas exchange is the:",
      o: ["Lung", "Gill", "Tracheal system", "Skin"],
      a: 2,
      e: "Insects breathe through a network of tubes called tracheae that open via spiracles.",
      full: "Unlike mammals that use blood to transport oxygen, the insect's tracheal system delivers air directly to the cells. This limits the size an insect can grow.",
      h: "Do insects use 'Lungs' or 'Tracheae'?"
    },
    {
      yr: 2022,
      q: "Which of the following is a function of the Skeleton?",
      o: ["Transport of oxygen", "Production of bile", "Protection of delicate organs", "Digestion of fats"],
      a: 2,
      e: "The skull protects the brain, and the ribs protect the heart and lungs.",
      full: "The skeleton provides five main functions: Support, Protection, Movement, Blood Cell Production (in bone marrow), and Mineral Storage.",
      h: "Does the skeleton 'Protect Organs' or 'Digest Fats'?"
    },
    {
      yr: 2022,
      q: "The specialized dental formula 2/2, 0/0, 3/2, 3/3 is characteristic of a:",
      o: ["Carnivore", "Herbivore", "Omnivore", "Parasite"],
      a: 1,
      e: "The '0/0' indicates the absence of canines, which is common in many herbivores.",
      full: "Herbivores like sheep or rabbits often have a gap (diastema) where canines would be. They use their incisors for cutting and molars for grinding plant material.",
      h: "Does '0/0 Canines' describe a 'Meat-eater' or a 'Plant-eater'?"
    },
    {
      yr: 2022,
      q: "Which of the following is an example of an involuntary action?",
      o: ["Dancing", "Sneezing", "Reading", "Running"],
      a: 1,
      e: "Sneezing is a reflex action that happens automatically without conscious thought.",
      full: "Involuntary actions are controlled by the autonomic nervous system or the spinal cord. They are fast and bypass the 'decision-making' part of the brain to protect the body.",
      h: "Is 'Sneezing' or 'Dancing' done without thinking?"
    },
    {
      yr: 2022,
      q: "The theory that explains evolution as 'Survival of the Fittest' was put forward by:",
      o: ["Lamarck", "Mendel", "Darwin", "Linnaeus"],
      a: 2,
      e: "Charles Darwin proposed that organisms with better adaptations survive to pass on their genes.",
      full: "While Lamarck believed in 'acquired traits,' Darwin's theory of Natural Selection is based on genetic variation and environmental pressure.",
      h: "Was 'Survival of the Fittest' from 'Darwin' or 'Lamarck'?"
    },
    {
      yr: 2022,
      q: "The study of the relationship between a single species and its environment is:",
      o: ["Synecology", "Autecology", "Ecosystem", "Community"],
      a: 1,
      e: "Autecology focuses on individual species, while Synecology studies groups of species (communities).",
      full: "If you study only the Life of a Hibiscus plant in a garden, it's Autecology. If you study all the plants and animals in that garden, it's Synecology.",
      h: "Is 'Single Species' study 'Autecology' or 'Synecology'?"
    },
    {
      yr: 2022,
      q: "The deficiency of Iodine in the human diet causes:",
      o: ["Anaemia", "Rickets", "Goitre", "Scurvy"],
      a: 2,
      e: "Iodine is needed for the thyroid gland to produce thyroxine; its absence causes the gland to swell.",
      full: "Goitre is characterized by a swelling in the neck. This is why many countries use 'Iodized Salt' to ensure people get enough of this trace mineral.",
      h: "Is 'Neck Swelling' called 'Goitre' or 'Anaemia'?"
    },
    {
      yr: 2022,
      q: "Which of the following is a xerophyte?",
      o: ["Water lily", "Cactus", "Mushroom", "Fern"],
      a: 1,
      e: "Xerophytes are plants adapted to live in very dry conditions (deserts).",
      full: "Cacti have features like sunken stomata, thick waxy cuticles, and leaves reduced to spines to prevent water loss in arid environments.",
      h: "Is a 'Cactus' a 'Xerophyte' or a 'Hydrophyte'?"
    },
    {
      yr: 2022,
      q: "The sugar found in RNA is:",
      o: ["Glucose", "Deoxyribose", "Ribose", "Fructose"],
      a: 2,
      e: "RNA stands for Ribonucleic Acid, named after its 'Ribose' sugar.",
      full: "In contrast, DNA (Deoxyribonucleic Acid) contains Deoxyribose sugar. This single oxygen atom difference makes DNA more stable than RNA.",
      h: "Does RNA have 'Ribose' or 'Deoxyribose'?"
    },

    {
      yr: 2022,
      q: "The process of maintaining a constant osmotic pressure in the body fluids of an organism is:",
      o: ["Excretion", "Osmoregulation", "Homeostasis", "Plasmolysis"],
      a: 1,
      e: "Osmoregulation is the specific control of water and salt balance.",
      full: "While Homeostasis is the general term for internal balance, Osmoregulation specifically deals with the 'water potential' of the blood and tissues, primarily managed by the kidneys in humans.",
      h: "Is 'Water/Salt Balance' called 'Osmoregulation' or 'Excretion'?"
    },
    {
      yr: 2022,
      q: "Which of the following is a characteristic of a wind-pollinated flower?",
      o: ["Large brightly colored petals", "Sticky pollen grains", "Feathery stigmas", "Presence of nectar"],
      a: 2,
      e: "Feathery stigmas provide a large surface area to catch pollen floating in the air.",
      full: "Wind-pollinated flowers (like grasses and maize) don't need to attract insects, so they lack color and scent but have long filaments and feathery stigmas to maximize pollen capture.",
      h: "Does wind pollination require 'Bright Petals' or 'Feathery Stigmas'?"
    },
    {
      yr: 2022,
      q: "The phenotypic ratio of a cross between two heterozygous (Tt) tall plants is:",
      o: ["1:2:1", "3:1", "2:1", "1:1"],
      a: 1,
      e: "A Tt x Tt cross yields 3 Tall (TT, Tt, Tt) and 1 Short (tt).",
      full: "While the 'Genotypic' ratio is 1:2:1 (TT:Tt:tt), the 'Phenotypic' ratio—what the plants actually look like—is 3:1 because the dominant T mask the recessive t.",
      h: "Is the appearance ratio '3:1' or '1:2:1'?"
    },
    {
      yr: 2022,
      q: "In which of the following biomes would you find the greatest biodiversity?",
      o: ["Tropical Rainforest", "Savanna", "Desert", "Tundra"],
      a: 0,
      e: "Tropical Rainforests have constant high temperatures and rainfall, supporting massive species variety.",
      full: "Rainforests cover less than 7% of Earth's land but house over 50% of its species. The stratified layers (canopy, understory, etc.) create many different niches for life.",
      h: "Is 'High Biodiversity' in the 'Rainforest' or the 'Desert'?"
    },
    {
      yr: 2022,
      q: "The functional unit of a mammalian lung where gas exchange occurs is the:",
      o: ["Bronchus", "Alveolus", "Trachea", "Bronchiole"],
      a: 1,
      e: "Alveoli are tiny air sacs with very thin walls to allow oxygen and CO2 to diffuse easily.",
      full: "The lungs contain millions of Alveoli. Their large surface area and rich supply of blood capillaries make them highly efficient for gas exchange.",
      h: "Is the 'Air Sac' called the 'Alveolus' or 'Bronchiole'?"
    },
    {
      yr: 2022,
      q: "The blood group that is regarded as the universal recipient is:",
      o: ["Group O", "Group A", "Group B", "Group AB"],
      a: 3,
      e: "Group AB has no anti-A or anti-B antibodies, so it can receive any blood type.",
      full: "Because AB individuals don't produce antibodies against A or B antigens, their immune system won't attack donor blood. In contrast, Group O is the universal donor.",
      h: "Is 'AB' or 'O' the 'Recipient'?"
    },
    {
      yr: 2022,
      q: "An example of a parasitic plant that lacks chlorophyll is:",
      o: ["Mistletoe", "Dodder (Cuscuta)", "Mushroom", "Fern"],
      a: 1,
      e: "Dodder is a total parasite that wraps around host plants and sucks nutrients via haustoria.",
      full: "Unlike Mistletoe (which is a partial parasite and can still photosynthesize), Dodder has no green leaves and relies entirely on its host for survival.",
      h: "Is 'Dodder' or 'Mistletoe' the one that can't make its own food?"
    },
    {
      yr: 2022,
      q: "The movement of a plant part in response to the direction of a light stimulus is:",
      o: ["Geotropism", "Phototropism", "Hydrotropism", "Chemotropism"],
      a: 1,
      e: "Phototropism allows plants to grow toward light (positive) or away (negative).",
      full: "This is driven by the hormone Auxin, which migrates to the shaded side of the stem, causing those cells to elongate and bend the plant toward the light.",
      h: "Is light-response 'Photo-' or 'Geo-' tropism?"
    },
    {
      yr: 2022,
      q: "The enzyme in human saliva that breaks down cooked starch into maltose is:",
      o: ["Pepsin", "Rennin", "Ptyalin (Salivary Amylase)", "Lipase"],
      a: 2,
      e: "Ptyalin begins the chemical digestion of carbohydrates right in the mouth.",
      full: "Ptyalin works best in a slightly alkaline environment. It breaks down complex starches into simpler sugars like maltose before the food reaches the stomach.",
      h: "Is the saliva enzyme 'Pepsin' or 'Ptyalin'?"
    },
    {
      yr: 2022,
      q: "A sequence of organisms through which energy is transferred starting from a producer is a:",
      o: ["Food web", "Food chain", "Pyramid of numbers", "Trophic level"],
      a: 1,
      e: "A food chain shows a single, linear path of energy flow (e.g., Grass -> Grasshopper -> Toad).",
      full: "A food web is more complex, showing multiple interconnected chains. Both demonstrate how energy is lost as it moves up from producers to top carnivores.",
      h: "Is a 'Linear' path a 'Chain' or a 'Web'?"
    },
    {
      yr: 2022,
      q: "The hormone that regulates the level of sugar in the blood is:",
      o: ["Adrenaline", "Thyroxine", "Insulin", "Testosterone"],
      a: 2,
      e: "Insulin, produced by the pancreas, lowers blood sugar by helping cells absorb glucose.",
      full: "When sugar levels are high, the Pancreas releases Insulin. When they are low, it releases Glucagon. Together, they maintain glucose homeostasis.",
      h: "Is 'Sugar Regulation' handled by 'Insulin' or 'Adrenaline'?"
    },
    {
      yr: 2022,
      q: "The process by which green plants manufacture food using sunlight, CO2, and water is:",
      o: ["Respiration", "Photosynthesis", "Transpiration", "Translocation"],
      a: 1,
      e: "Photosynthesis occurs in the chloroplasts and produces glucose and oxygen.",
      full: "The chemical equation is: 6CO2 + 6H2O + light -> C6H12O6 + 6O2. It is the primary way energy enters most ecosystems on Earth.",
      h: "Is 'Food Making' called 'Respiration' or 'Photosynthesis'?"
    },
    {
      yr: 2022,
      q: "Which of the following organisms shows 'Alternation of Generations'?",
      o: ["Amoeba", "Fern", "Earthworm", "Hydra"],
      a: 1,
      e: "Ferns cycle between a multicellular haploid (gametophyte) and diploid (sporophyte) phase.",
      full: "In ferns, the plant you see is the sporophyte. It produces spores that grow into a tiny heart-shaped gametophyte, which then produces eggs and sperm.",
      h: "Is 'Alternation of Generations' seen in 'Ferns' or 'Amoeba'?"
    },
    {
      yr: 2022,
      q: "The habitat of an organism that lives in a salty water environment is described as:",
      o: ["Freshwater", "Marine", "Terrestrial", "Arboreal"],
      a: 1,
      e: "Marine habitats include oceans and seas where salinity is high.",
      full: "Organisms in marine habitats must have adaptations like salt-excreting glands to survive the high salt concentration compared to freshwater species.",
      h: "Is 'Salty Water' called 'Freshwater' or 'Marine'?"
    },
    {
      yr: 2022,
      q: "Which of the following is an example of an infectious, non-vector borne disease?",
      o: ["Malaria", "Yellow Fever", "Tuberculosis", "Sleeping Sickness"],
      a: 2,
      e: "Tuberculosis is spread through the air (droplets), while the others require a vector like a mosquito or fly.",
      full: "Vector-borne diseases need a 'middle-man' (like a mosquito for Malaria). Tuberculosis is directly transmitted from human to human via respiratory droplets.",
      h: "Is 'TB' or 'Malaria' spread without an insect?"
    },
    {
      yr: 2022,
      q: "The part of the brain that controls the heartbeat and breathing is the:",
      o: ["Cerebrum", "Cerebellum", "Medulla Oblongata", "Hypothalamus"],
      a: 2,
      e: "The Medulla Oblongata is the center for involuntary 'vital' functions.",
      full: "Located at the base of the brain, the medulla ensures you keep breathing and your heart keeps beating even while you are fast asleep.",
      h: "Is 'Breathing' controlled by the 'Cerebrum' or 'Medulla'?"
    },
    {
      yr: 2022,
      q: "The scientist who is often referred to as the 'Father of Genetics' is:",
      o: ["Charles Darwin", "Gregor Mendel", "Louis Pasteur", "Jean Lamarck"],
      a: 1,
      e: "Mendel's experiments with pea plants laid the foundation for modern genetics.",
      full: "Mendel discovered the laws of Segregation and Independent Assortment, showing how traits are passed from parents to offspring through 'factors' (now called genes).",
      h: "Was the 'Pea Plant' scientist 'Darwin' or 'Mendel'?"
    },
    {
      yr: 2022,
      q: "Which of the following structures is used for excretion in the Earthworm?",
      o: ["Contractile vacuole", "Flame cells", "Nephridia", "Malpighian tubules"],
      a: 2,
      e: "Earthworms have segmented excretory organs called nephridia.",
      full: "For comparison: Contractile vacuoles are for Amoeba, Flame cells are for Flatworms, and Malpighian tubules are for Insects.",
      h: "Does the Earthworm use 'Flame cells' or 'Nephridia'?"
    },
    {
      yr: 2022,
      q: "The small, finger-like projections in the small intestine used for absorption are:",
      o: ["Cilia", "Villi", "Flagella", "Pseudopodia"],
      a: 1,
      e: "Villi increase the surface area of the intestine for maximum nutrient absorption.",
      full: "Each villus contains blood capillaries and a lacteal (for fat absorption). This ensures that digested food quickly enters the circulatory system.",
      h: "Are 'Absorption' fingers called 'Cilia' or 'Villi'?"
    },
    {
      yr: 2022,
      q: "Which of these is a major cause of global warming?",
      o: ["Planting of trees", "Increase in atmospheric CO2", "Use of solar energy", "Reduction in fossil fuel use"],
      a: 1,
      e: "Carbon dioxide traps heat in the atmosphere, leading to the greenhouse effect.",
      full: "The burning of coal, oil, and gas releases CO2. This creates a blanket around the Earth that prevents heat from escaping into space, raising global temperatures.",
      h: "Is Global Warming caused by 'More CO2' or 'More Trees'?"
    },
    {
      yr: 2021,
      q: "Which of the following organisms is a prokaryote?",
      o: ["Amoeba", "Euglena", "Bacteria", "Spirogyra"],
      a: 2,
      e: "Prokaryotes lack a defined nucleus and membrane-bound organelles.",
      full: "Bacteria and Blue-green algae (Cyanobacteria) are the primary examples of prokaryotes. Unlike the others listed, their DNA is circular and floats freely in the cytoplasm in a region called the nucleoid.",
      h: "Does a 'Prokaryote' mean 'Bacteria' or 'Amoeba'?"
    },
    {
      yr: 2021,
      q: "The structural and functional unit of life is the:",
      o: ["Tissue", "Organ", "Cell", "System"],
      a: 2,
      e: "The cell theory states that the cell is the basic unit of all living things.",
      full: "Whether an organism is unicellular (like a yeast) or multicellular (like a human), the cell is the smallest unit that can perform all the functions of life.",
      h: "Is the 'Building Block' a 'Cell' or a 'Tissue'?"
    },
    {
      yr: 2021,
      q: "Which of the following is a supporting tissue in plants?",
      o: ["Phloem", "Xylem", "Sclerenchyma", "Cambium"],
      a: 2,
      e: "Sclerenchyma cells have thick, lignified walls that provide mechanical strength.",
      full: "While Xylem transports water and Phloem transports food, tissues like Sclerenchyma and Collenchyma are specifically designed to keep the plant upright and resistant to wind.",
      h: "Is 'Support' provided by 'Phloem' or 'Sclerenchyma'?"
    },
    {
      yr: 2021,
      q: "The movement of a whole organism in response to a light stimulus is:",
      o: ["Phototropism", "Phototaxis", "Photonasty", "Photosynthesis"],
      a: 1,
      e: "Taxis involves the movement of the 'whole' organism, unlike Tropism which is just a growth 'part'.",
      full: "An example is Chlamydomonas swimming toward light. If only a part of a fixed plant bends toward light, it is Phototropism; if the whole thing moves, it is Phototaxis.",
      h: "Is 'Whole Body Movement' called 'Tropism' or 'Taxis'?"
    },
    {
      yr: 2021,
      q: "The process of anaerobic respiration in yeast cells produces:",
      o: ["Lactic acid and energy", "Ethanol and carbon dioxide", "Water and oxygen", "Glucose and energy"],
      a: 1,
      e: "In the absence of oxygen, yeast converts sugar into alcohol (ethanol) and CO2.",
      full: "This process is also known as fermentation. It is widely used in the brewing and baking industries—the CO2 makes bread rise, and the ethanol is the alcohol in drinks.",
      h: "Does 'Yeast' produce 'Lactic Acid' or 'Ethanol'?"
    },
    {
      yr: 2021,
      q: "Which of the following is an example of an endoparasite?",
      o: ["Tick", "Louse", "Tapeworm", "Flea"],
      a: 2,
      e: "Endoparasites live 'inside' the body of the host.",
      full: "Tapeworms live in the human intestine (inside), whereas ticks, lice, and fleas are ectoparasites because they live on the 'outside' (skin or hair) of the host.",
      h: "Does a 'Tapeworm' live 'Inside' or 'Outside'?"
    },
    {
      yr: 2021,
      q: "The part of the mammalian tooth that contains blood vessels and nerves is the:",
      o: ["Enamel", "Dentine", "Pulp cavity", "Cement"],
      a: 2,
      e: "The pulp is the soft, living center of the tooth.",
      full: "The Enamel is the hard outer layer (non-living), the Dentine is below it, but the Pulp Cavity is where the life of the tooth resides, including the nerves that feel pain.",
      h: "Are 'Nerves' in the 'Enamel' or the 'Pulp'?"
    },
    {
      yr: 2021,
      q: "Which of the following is a nitrogenous waste product in birds?",
      o: ["Ammonia", "Urea", "Uric acid", "Nitrates"],
      a: 2,
      e: "Birds excrete uric acid because it is semi-solid and requires very little water to eliminate.",
      full: "This is an adaptation for flight (weight reduction) and water conservation. Fish excrete Ammonia (toxic, needs lots of water), and Mammals excrete Urea.",
      h: "Do birds excrete 'Urea' or 'Uric Acid'?"
    },
    {
      yr: 2021,
      q: "The enzyme that curdles milk in the stomach of young mammals is:",
      o: ["Pepsin", "Rennin", "Trypsin", "Amylase"],
      a: 1,
      e: "Rennin (Chymosin) acts on the milk protein casein to turn it into a solid curd for easier digestion.",
      full: "By solidifying the milk, the enzyme ensures that the milk stays in the stomach long enough for other enzymes like Pepsin to break down the proteins.",
      h: "Is 'Milk Curdling' done by 'Pepsin' or 'Rennin'?"
    },
    {
      yr: 2021,
      q: "The structure in the mammalian ear that equalizes pressure on both sides of the eardrum is the:",
      o: ["Ossicles", "Eustachian tube", "Cochlea", "Oval window"],
      a: 1,
      e: "The Eustachian tube connects the middle ear to the throat to balance air pressure.",
      full: "When you 'pop' your ears on a plane, that is the Eustachian tube opening. If the pressure isn't equalized, the eardrum cannot vibrate properly, affecting hearing.",
      h: "Is the 'Pressure Balancer' the 'Cochlea' or the 'Eustachian tube'?"
    },
    {
      yr: 2021,
      q: "Which of the following is a primary function of the fruit?",
      o: ["Storage of water", "Protection and dispersal of seeds", "Photosynthesis", "Anchorage"],
      a: 1,
      e: "Fruits protect the developing seeds and often help in their movement to new locations.",
      full: "Whether a fruit is fleshy (to be eaten by animals) or dry and winged (to be carried by wind), its biological goal is to ensure the seeds are scattered far from the parent plant.",
      h: "Is a fruit for 'Photosynthesis' or 'Seed Dispersal'?"
    },
    {
      yr: 2021,
      q: "The theory of Acquired Characteristics was proposed by:",
      o: ["Charles Darwin", "Jean-Baptiste Lamarck", "Gregor Mendel", "August Weismann"],
      a: 1,
      e: "Lamarckism suggests that changes acquired during an organism's life can be inherited.",
      full: "Lamarck famously used the example of giraffes stretching their necks. While we now know this isn't how inheritance works (Genetics), it was a major early theory of evolution.",
      h: "Was the 'Stretching Neck' theory by 'Darwin' or 'Lamarck'?"
    },
    {
      yr: 2021,
      q: "The part of the eye that controls the amount of light entering is the:",
      o: ["Cornea", "Iris", "Lens", "Retina"],
      a: 1,
      e: "The iris adjusts the size of the pupil to regulate light intake.",
      full: "In bright light, the iris muscles contract to make the pupil smaller; in dim light, they dilate it. This protects the sensitive retina from damage.",
      h: "Is the 'Light Gate' the 'Retina' or the 'Iris'?"
    },
    {
      yr: 2021,
      q: "In an ecosystem, energy is lost at each trophic level mainly as:",
      o: ["Water", "Heat", "Food", "Oxygen"],
      a: 1,
      e: "Only about 10% of energy is passed to the next level; the rest is lost as heat during metabolism.",
      full: "This is why food chains are rarely longer than 4 or 5 levels. There simply isn't enough energy left at the top to support a large population of apex predators.",
      h: "Is energy lost as 'Food' or as 'Heat'?"
    },
    {
      yr: 2021,
      q: "The condition where the red blood cells are sickle-shaped is a:",
      o: ["Nutritional disease", "Hereditary disease", "Infectious disease", "Viral disease"],
      a: 1,
      e: "Sickle Cell Anaemia is a genetic disorder passed from parents to offspring.",
      full: "It is caused by a mutation in the gene that makes haemoglobin. Because it is written in the DNA, it cannot be caught like a cold; it must be inherited.",
      h: "Is 'Sickle Cell' an 'Infection' or 'Hereditary'?"
    },
    {
      yr: 2021,
      q: "Which of the following is a function of the hormone Progesterone?",
      o: ["Development of male secondary sex characters", "Maintenance of pregnancy", "Control of blood sugar", "Increase in heart rate"],
      a: 1,
      e: "Progesterone prepares the uterus for implantation and maintains the uterine lining during pregnancy.",
      full: "It is often called the 'Pregnancy Hormone.' If fertilization does not occur, progesterone levels drop, leading to menstruation.",
      h: "Is 'Progesterone' for 'Pregnancy' or 'Blood Sugar'?"
    },
    {
      yr: 2021,
      q: "The group of plants that produce seeds but no flowers are the:",
      o: ["Angiosperms", "Gymnosperms", "Bryophytes", "Pteridophytes"],
      a: 1,
      e: "Gymnosperms (like Pines and Cycads) produce 'naked' seeds, usually in cones.",
      full: "Angiosperms are 'flowering plants.' Gymnosperms were the dominant land plants before flowering plants evolved. They don't hide their seeds inside a fruit.",
      h: "Are 'Seed-bearing, non-flowering' plants 'Gymnosperms' or 'Angiosperms'?"
    },
    {
      yr: 2021,
      q: "The joint that allows movement in only one plane is the:",
      o: ["Ball and socket joint", "Hinge joint", "Gliding joint", "Pivot joint"],
      a: 1,
      e: "The hinge joint (like the elbow and knee) moves back and forth like a door.",
      full: "In contrast, the Ball and Socket joint (shoulder and hip) allows for circular, multi-directional movement. The hinge joint is more restricted but very strong.",
      h: "Is the 'Elbow' a 'Ball and Socket' or a 'Hinge' joint?"
    },
    {
      yr: 2021,
      q: "Which of the following organisms is hermaphroditic?",
      o: ["Cockroach", "Earthworm", "Housefly", "Toad"],
      a: 1,
      e: "Earthworms possess both male and female reproductive organs in one body.",
      full: "While they have both sets of organs, most earthworms still need a partner to cross-fertilize. This ensures genetic variation within the population.",
      h: "Does the 'Earthworm' or 'Housefly' have 'Both Sexes'?"
    },
    {
      yr: 2021,
      q: "The breakdown of glucose to release energy in the presence of oxygen is:",
      o: ["Aerobic respiration", "Anaerobic respiration", "Photosynthesis", "Excretion"],
      a: 0,
      e: "Aerobic respiration is highly efficient and occurs in the mitochondria.",
      full: "The general formula is: Glucose + Oxygen -> Carbon Dioxide + Water + Energy (ATP). This is the primary way human cells get energy.",
      h: "Is respiration 'with oxygen' called 'Aerobic' or 'Anaerobic'?"
    },
    {
      yr: 2021,
      q: "The part of the flower that develops into a seed after fertilization is the:",
      o: ["Ovary", "Ovule", "Stigma", "Style"],
      a: 1,
      e: "While the Ovary becomes the Fruit, the Ovule becomes the Seed.",
      full: "After pollen fertilizes the egg inside the ovule, the ovule's integuments harden to form the seed coat (testa). The surrounding ovary wall then ripens into the fruit.",
      h: "Does the 'Ovule' or 'Ovary' become the 'Seed'?"
    },
    {
      yr: 2021,
      q: "The process by which an Amoeba engulfs solid food particles is:",
      o: ["Pinocytosis", "Phagocytosis", "Exocytosis", "Osmosis"],
      a: 1,
      e: "Phagocytosis is 'cell eating,' where the membrane wraps around solids.",
      full: "Amoeba uses pseudopodia (false feet) to surround a food particle, forming a food vacuole. Pinocytosis, by contrast, is 'cell drinking' for liquid intake.",
      h: "Is 'Cell Eating' called 'Phagocytosis' or 'Pinocytosis'?"
    },
    {
      yr: 2021,
      q: "Which of the following is a function of the hormone Auxin in plants?",
      o: ["Inhibition of lateral buds", "Ripening of fruits", "Breaking of seed dormancy", "Closing of stomata"],
      a: 0,
      e: "Auxins promote apical dominance, meaning they stop side branches from growing.",
      full: "Produced at the tip of the stem, Auxins encourage vertical growth. If you cut the tip (removing the auxin source), the lateral buds will start to grow, making the plant bushier.",
      h: "Does 'Auxin' promote 'Upward Growth' or 'Fruit Ripening'?"
    },
    {
      yr: 2021,
      q: "A habitat characterized by low rainfall, high temperature, and sparse vegetation is a:",
      o: ["Rainforest", "Desert", "Savanna", "Mangrove swamp"],
      a: 1,
      e: "Deserts are arid regions where evaporation often exceeds precipitation.",
      full: "Organisms in this habitat must have extreme adaptations, like the camel's ability to store fat or the cactus's ability to store water in its succulent stem.",
      h: "Is 'Sparse Vegetation' found in the 'Rainforest' or the 'Desert'?"
    },
    {
      yr: 2021,
      q: "The pigment responsible for the green color in plants is:",
      o: ["Haemoglobin", "Chlorophyll", "Melanin", "Xanthophyll"],
      a: 1,
      e: "Chlorophyll is located in the chloroplasts and is essential for photosynthesis.",
      full: "It absorbs light energy (mostly blue and red wavelengths) and converts it into chemical energy. Melanin is a skin pigment, and Haemoglobin is in blood.",
      h: "Is the 'Green Pigment' called 'Melanin' or 'Chlorophyll'?"
    },
    {
      yr: 2021,
      q: "Which of the following is a demerit of sexual reproduction?",
      o: ["High genetic variation", "Requires two parents", "Faster population growth", "Better adaptation to change"],
      a: 1,
      e: "Finding a mate takes time and energy, which can be a disadvantage compared to asexual reproduction.",
      full: "While sexual reproduction provides variation (a major advantage), it is slower and more energy-intensive because it usually requires two compatible individuals and the production of gametes.",
      h: "Is 'Requiring Two Parents' an advantage or a 'Demerit'?"
    },
    {
      yr: 2021,
      q: "The type of skeleton found in an earthworm is a/an:",
      o: ["Exoskeleton", "Endoskeleton", "Hydrostatic skeleton", "Bony skeleton"],
      a: 2,
      e: "Earthworms use fluid pressure within their body segments to maintain shape and move.",
      full: "Because they lack bones or shells, they rely on the 'incompressibility' of the fluid in their coelom. Muscles act against this fluid pressure to elongate or shorten the body.",
      h: "Is a 'Fluid-based' skeleton called 'Bony' or 'Hydrostatic'?"
    },
    {
      yr: 2021,
      q: "The blood vessel that carries oxygenated blood from the lungs to the heart is the:",
      o: ["Pulmonary artery", "Pulmonary vein", "Aorta", "Vena cava"],
      a: 1,
      e: "The pulmonary vein is the ONLY vein that carries oxygen-rich blood.",
      full: "Veins usually carry deoxygenated blood toward the heart. The Pulmonary Vein is the exception, bringing freshly oxygenated blood from the lungs to the Left Atrium.",
      h: "Does the 'Pulmonary Vein' or 'Artery' carry 'Oxygenated' blood?"
    },
    {
      yr: 2021,
      q: "The relationship between a nitrogen-fixing bacterium and a leguminous plant is:",
      o: ["Mutualism", "Commensalism", "Parasitism", "Saprophytism"],
      a: 0,
      e: "The plant gets nitrates, and the bacterium gets food and shelter.",
      full: "Both organisms benefit in this (+/+) relationship. This is why legumes are often used in crop rotation to naturally replenish soil nitrogen levels.",
      h: "Is 'Both Benefit' called 'Mutualism' or 'Parasitism'?"
    },
    {
      yr: 2021,
      q: "Which of the following is an example of an involuntary reflex?",
      o: ["Singing a song", "Withdrawal of hand from a hot object", "Riding a horse", "Solving a puzzle"],
      a: 1,
      e: "Reflexes are automatic and bypass the conscious brain for speed.",
      full: "The 'Reflex Arc' usually involves a sensory neuron, a relay neuron in the spinal cord, and a motor neuron. This allows for a split-second response to danger.",
      h: "Is 'Singing' or 'Hand Withdrawal' a reflex?"
    },
    {
      yr: 2021,
      q: "The instrument used to measure wind speed is the:",
      o: ["Hygrometer", "Anemometer", "Wind vane", "Barometer"],
      a: 1,
      e: "An anemometer usually consists of cups that rotate faster as wind speed increases.",
      full: "For comparison: A Wind Vane shows direction, a Hygrometer measures humidity, and a Barometer measures air pressure.",
      h: "Is speed measured by a 'Wind Vane' or an 'Anemometer'?"
    },
    {
      yr: 2021,
      q: "The vitamin that prevents the disease called Scurvy is:",
      o: ["Vitamin A", "Vitamin B", "Vitamin C", "Vitamin D"],
      a: 2,
      e: "Vitamin C is essential for collagen synthesis; its lack causes bleeding gums.",
      full: "Scurvy was common among sailors who lacked fresh fruits. Citrus fruits like oranges and lemons are excellent sources of Vitamin C.",
      h: "Is 'Scurvy' prevented by Vitamin 'C' or 'D'?"
    },
    {
      yr: 2021,
      q: "The structure used by insects for excretion is the:",
      o: ["Contractile vacuole", "Kidney", "Malpighian tubule", "Flame cell"],
      a: 2,
      e: "Malpighian tubules remove waste from the hemolymph into the gut of insects.",
      full: "This system is very efficient at conserving water, as the waste is excreted as nearly dry uric acid crystals alongside feces.",
      h: "Do insects use 'Kidneys' or 'Malpighian tubules'?"
    },
    {
      yr: 2021,
      q: "A person with blood group O can safely donate blood to people with blood groups:",
      o: ["O only", "A and B only", "AB only", "A, B, AB, and O"],
      a: 3,
      e: "Group O is the universal donor because its cells lack A and B antigens.",
      full: "Since there are no antigens on the surface of Group O red blood cells, the recipient's antibodies have nothing to attack. However, Group O can only receive blood from another O.",
      h: "Is 'Group O' the 'Universal Donor' or 'Universal Recipient'?"
    },
    {
      yr: 2021,
      q: "Which of the following is a major function of the Large Intestine?",
      o: ["Digestion of proteins", "Absorption of water", "Production of bile", "Absorption of glucose"],
      a: 1,
      e: "The colon reabsorbs water from undigested food, turning it into solid feces.",
      full: "While most chemical digestion and nutrient absorption happen in the small intestine, the large intestine is primarily responsible for water recovery and waste storage.",
      h: "Does the 'Large Intestine' digest 'Protein' or absorb 'Water'?"
    },
    {
      yr: 2021,
      q: "The theory of Natural Selection was co-proposed by Charles Darwin and:",
      o: ["Gregor Mendel", "Alfred Russel Wallace", "Louis Pasteur", "Robert Hooke"],
      a: 1,
      e: "Wallace independently arrived at the same conclusion as Darwin regarding evolution.",
      full: "Both scientists presented their findings together in 1858. However, Darwin became more famous after publishing 'On the Origin of Species' a year later.",
      h: "Was Darwin's partner 'Mendel' or 'Wallace'?"
    },
    {
      yr: 2021,
      q: "Which of the following is an example of a physiological variation?",
      o: ["Skin color", "Blood group", "Height", "Fingerprints"],
      a: 1,
      e: "Physiological variations relate to how the body functions internally.",
      full: "Skin color and height are 'Morphological' (physical appearance). Blood group is 'Physiological' because it depends on the chemical nature of the blood cells.",
      h: "Is 'Blood Group' or 'Height' a physiological trait?"
    },
    {
      yr: 2021,
      q: "The specialized breathing roots found in mangrove plants are:",
      o: ["Prop roots", "Pneumatophores", "Buttress roots", "Stilt roots"],
      a: 1,
      e: "Pneumatophores grow upward out of the mud to get oxygen for the roots.",
      full: "In swampy, waterlogged soils, there is little oxygen. Mangroves have evolved these 'breathing tubes' to allow air to reach the submerged root systems.",
      h: "Are 'Breathing Roots' called 'Buttress' or 'Pneumatophores'?"
    },
    {
      yr: 2021,
      q: "Which of the following organisms is at the top of a typical food chain?",
      o: ["Grass", "Grasshopper", "Lizard", "Hawk"],
      a: 3,
      e: "The hawk is a tertiary consumer or top predator with no natural enemies.",
      full: "In the chain Grass -> Grasshopper -> Lizard -> Hawk, the Hawk is the apex predator. Energy decreases at each step, so there are fewer hawks than grasshoppers.",
      h: "Is the 'Top' of the chain the 'Producer' or the 'Predator'?"
    },
    {
      yr: 2021,
      q: "The basic unit of classification is the:",
      o: ["Phylum", "Class", "Genus", "Species"],
      a: 3,
      e: "A species consists of organisms that can interbreed to produce fertile offspring.",
      full: "The hierarchy goes: Kingdom, Phylum, Class, Order, Family, Genus, Species. Species is the most specific level and the fundamental unit of the system.",
      h: "Is the 'Basic Unit' the 'Kingdom' or the 'Species'?"
    },
    {
      yr: 2020,
      q: "The structural unit of the nervous system is the:",
      o: ["Axon", "Neuron", "Dendrite", "Myelin sheath"],
      a: 1,
      e: "The neuron (nerve cell) is the specialized cell that transmits electrical impulses.",
      full: "A neuron consists of a cell body, dendrites to receive signals, and an axon to send them. Millions of these cells work together to form the brain, spinal cord, and nerves.",
      h: "Is the 'Brain Cell' called a 'Nephron' or a 'Neuron'?"
    },
    {
      yr: 2020,
      q: "Which of the following is an example of an arboreal animal?",
      o: ["Fish", "Toad", "Monkey", "Earthworm"],
      a: 2,
      e: "Arboreal animals are those that spend the majority of their lives in trees.",
      full: "Monkeys have adaptations like prehensile tails or long limbs for swinging and climbing. Other examples include squirrels, sloths, and certain species of snakes.",
      h: "Does 'Arboreal' mean living 'In Water' or 'In Trees'?"
    },
    {
      yr: 2020,
      q: "The process by which plants manufacture food is restricted to the green parts because they contain:",
      o: ["Leucoplasts", "Chromoplasts", "Chloroplasts", "Protoplasts"],
      a: 2,
      e: "Chloroplasts contain chlorophyll, the pigment that traps light energy.",
      full: "While other plastids store starch (Leucoplasts) or provide color to flowers (Chromoplasts), only Chloroplasts have the machinery for photosynthesis.",
      h: "Is 'Photosynthesis' in the 'Leucoplast' or 'Chloroplast'?"
    },
    {
      yr: 2020,
      q: "In the mammalian eye, the part that focus light onto the retina is the:",
      o: ["Sclera", "Iris", "Lens", "Choroid"],
      a: 2,
      e: "The biconvex lens changes shape to focus light from various distances.",
      full: "This process is called accommodation. The ciliary muscles pull or relax the lens to ensure that the image always lands sharply on the light-sensitive retina.",
      h: "Is the 'Focusing Part' the 'Iris' or the 'Lens'?"
    },
    {
      yr: 2020,
      q: "Which of the following is a function of the hormone Insulin?",
      o: ["Increasing blood pressure", "Conversion of glucose to glycogen", "Stimulating growth", "Breaking down fats"],
      a: 1,
      e: "Insulin lowers blood sugar by converting excess glucose into glycogen for storage in the liver.",
      full: "Produced by the Islets of Langerhans in the pancreas, insulin is the 'Key' that lets glucose into cells for energy or stores it away if there is too much in the blood.",
      h: "Does 'Insulin' increase sugar or 'Store' it as glycogen?"
    },
    {
      yr: 2020,
      q: "The dental formula 2/2, 1/1, 2/2, 3/3 represents an adult:",
      o: ["Dog", "Human", "Rabbit", "Sheep"],
      a: 1,
      e: "This formula represents the 32 teeth in a human adult (Incisors, Canines, Premolars, Molars).",
      full: "Multiply each number by 2 (for both sides of the jaw) and add them: (2+1+2+3) * 2 = 16 per jaw. 16 upper + 16 lower = 32 total teeth.",
      h: "Is '2123' the dental formula for a 'Human' or a 'Dog'?"
    },
    {
      yr: 2020,
      q: "The male reproductive organ of a flower is collectively called the:",
      o: ["Pistil", "Androecium", "Gynoecium", "Receptacle"],
      a: 1,
      e: "The Androecium consists of the stamens (anther and filament).",
      full: "The female part is the Gynoecium (or Pistil). The Androecium's main job is the production and dispersal of pollen grains containing the male gametes.",
      h: "Is the 'Male' part 'Androecium' or 'Gynoecium'?"
    },
    {
      yr: 2020,
      q: "Which of the following organisms is a scavenger?",
      o: ["Lion", "Vulture", "Goat", "Leopard"],
      a: 1,
      e: "Scavengers feed on the carcasses of animals that are already dead.",
      full: "Unlike predators (Lions) that hunt and kill, scavengers like Vultures play a vital role in the ecosystem by cleaning up dead organic matter and preventing the spread of disease.",
      h: "Is a 'Vulture' a 'Hunter' or a 'Scavenger'?"
    },
    {
      yr: 2020,
      q: "The theory of evolution by 'Natural Selection' was proposed by:",
      o: ["Mendel", "Lamarck", "Darwin", "Morgan"],
      a: 2,
      e: "Charles Darwin is the primary figure associated with the theory of natural selection.",
      full: "Darwin observed that individuals with favorable variations are more likely to survive and reproduce. Over generations, these traits become more common in the population.",
      h: "Was 'Natural Selection' by 'Darwin' or 'Lamarck'?"
    },
    {
      yr: 2020,
      q: "The respiratory organ in a fish is the:",
      o: ["Trachea", "Lung", "Gill", "Skin"],
      a: 2,
      e: "Gills allow fish to extract dissolved oxygen from water through a counter-current flow mechanism.",
      full: "Water enters the mouth and passes over the thin, blood-rich gill filaments where oxygen is absorbed and carbon dioxide is released.",
      h: "Do fish use 'Lungs' or 'Gills'?"
    },
    {
      yr: 2020,
      q: "The part of the seed that provides food for the embryo in monocots is the:",
      o: ["Radicle", "Plumule", "Endosperm", "Cotyledon"],
      a: 2,
      e: "In monocots like maize, the endosperm is the main food storage tissue.",
      full: "While dicots often store food in their two cotyledons, monocots keep their nutrients in a separate tissue called the endosperm until the seed begins to germinate.",
      h: "Is the food store in maize the 'Plumule' or the 'Endosperm'?"
    },
    {
      yr: 2020,
      q: "A group of organisms of the same species living in a particular area at a given time is a:",
      o: ["Community", "Population", "Ecosystem", "Biome"],
      a: 1,
      e: "A population refers specifically to one species in one location.",
      full: "A 'Community' includes all the different populations in an area, and an 'Ecosystem' includes both the living community and the non-living environment.",
      h: "Is a 'Single Species Group' a 'Population' or a 'Community'?"
    },
    {
      yr: 2020,
      q: "The enzyme Pepsin works best in an environment that is:",
      o: ["Alkaline", "Acidic", "Neutral", "Saline"],
      a: 1,
      e: "Pepsin requires the low pH (acidic) provided by hydrochloric acid in the stomach.",
      full: "Pepsin is secreted as inactive pepsinogen. The HCl in the stomach activates it and provides the acidic environment (pH 1.5-2) it needs to digest proteins.",
      h: "Is the stomach 'Acidic' or 'Alkaline'?"
    },
    {
      yr: 2020,
      q: "Which of the following is a non-heritable variation?",
      o: ["Eye color", "Skin color", "Knowledge of a language", "Blood group"],
      a: 2,
      e: "Acquired skills or knowledge are not encoded in the DNA and cannot be passed to offspring.",
      full: "Variations like eye color and blood group are genetic. However, environmental variations—like scars or things you learn—are not heritable.",
      h: "Can you 'Inherit' a 'Language' or is it 'Learned'?"
    },
    {
      yr: 2020,
      q: "The main excretory organ in humans is the:",
      o: ["Liver", "Lung", "Kidney", "Skin"],
      a: 2,
      e: "The kidneys are the primary organs for filtering blood and removing nitrogenous waste as urine.",
      full: "While the skin excretes sweat and the lungs excrete CO2, the Kidney is the central organ for osmoregulation and the removal of urea.",
      h: "Is the 'Urine Maker' the 'Liver' or the 'Kidney'?"
    },
    {
      yr: 2020,
      q: "The joint found at the human shoulder and hip is the:",
      o: ["Hinge joint", "Pivot joint", "Ball and socket joint", "Gliding joint"],
      a: 2,
      e: "Ball and socket joints allow for the greatest range of movement in multiple planes.",
      full: "The rounded head of one bone (the ball) fits into the cup-like depression of another (the socket), allowing for rotation and circular movement.",
      h: "Is the 'Shoulder' a 'Hinge' or a 'Ball and Socket'?"
    },
    {
      yr: 2020,
      q: "The process by which liquid water is lost from the leaves of plants in the form of drops is:",
      o: ["Transpiration", "Guttation", "Evaporation", "Exudation"],
      a: 1,
      e: "Guttation occurs through hydathodes, usually at night or in high humidity.",
      full: "Transpiration is the loss of water as *vapor*. Guttation is the loss of *liquid* water, often seen as 'dew drops' on the tips of leaves in the morning.",
      h: "Is 'Liquid Water Loss' called 'Transpiration' or 'Guttation'?"
    },
    {
      yr: 2020,
      q: "The vector for the parasite that causes Malaria is the:",
      o: ["Tsetse fly", "Housefly", "Female Anopheles mosquito", "Male Anopheles mosquito"],
      a: 2,
      e: "The female Anopheles mosquito carries the Plasmodium parasite and injects it into humans.",
      full: "The female mosquito needs a blood meal for her eggs. The male mosquito does not bite humans; it feeds on plant nectar.",
      h: "Is it the 'Female' or 'Male' Anopheles that bites?"
    },
    {
      yr: 2020,
      q: "Which of the following is an example of a social insect?",
      o: ["Butterfly", "Honeybee", "Mosquito", "Cotton stainer"],
      a: 1,
      e: "Honeybees live in highly organized colonies with distinct roles (Queen, Drone, Worker).",
      full: "Social insects cannot survive alone. They exhibit division of labor, communal care of the young, and often have different physical forms (castes) for different jobs.",
      h: "Do 'Honeybees' or 'Butterflies' live in organized 'Colonies'?"
    },
    {
      yr: 2020,
      q: "The first stage of mitosis is:",
      o: ["Metaphase", "Prophase", "Anaphase", "Telophase"],
      a: 1,
      e: "In prophase, the chromatin condenses into visible chromosomes and the nuclear envelope breaks down.",
      full: "Mitosis follows the sequence: Prophase, Metaphase (lining up), Anaphase (pulling apart), and Telophase (forming two new nuclei).",
      h: "Is the 'Start' of mitosis 'Prophase' or 'Metaphase'?"
    },
    {
      yr: 2021,
      q: "The part of the flower that develops into a seed after fertilization is the:",
      o: ["Ovary", "Ovule", "Stigma", "Style"],
      a: 1,
      e: "While the Ovary becomes the Fruit, the Ovule becomes the Seed.",
      full: "After pollen fertilizes the egg inside the ovule, the ovule's integuments harden to form the seed coat (testa). The surrounding ovary wall then ripens into the fruit.",
      h: "Does the 'Ovule' or 'Ovary' become the 'Seed'?"
    },
    {
      yr: 2021,
      q: "The process by which an Amoeba engulfs solid food particles is:",
      o: ["Pinocytosis", "Phagocytosis", "Exocytosis", "Osmosis"],
      a: 1,
      e: "Phagocytosis is 'cell eating,' where the membrane wraps around solids.",
      full: "Amoeba uses pseudopodia (false feet) to surround a food particle, forming a food vacuole. Pinocytosis, by contrast, is 'cell drinking' for liquid intake.",
      h: "Is 'Cell Eating' called 'Phagocytosis' or 'Pinocytosis'?"
    },
    {
      yr: 2021,
      q: "Which of the following is a function of the hormone Auxin in plants?",
      o: ["Inhibition of lateral buds", "Ripening of fruits", "Breaking of seed dormancy", "Closing of stomata"],
      a: 0,
      e: "Auxins promote apical dominance, meaning they stop side branches from growing.",
      full: "Produced at the tip of the stem, Auxins encourage vertical growth. If you cut the tip (removing the auxin source), the lateral buds will start to grow, making the plant bushier.",
      h: "Does 'Auxin' promote 'Upward Growth' or 'Fruit Ripening'?"
    },
    {
      yr: 2021,
      q: "A habitat characterized by low rainfall, high temperature, and sparse vegetation is a:",
      o: ["Rainforest", "Desert", "Savanna", "Mangrove swamp"],
      a: 1,
      e: "Deserts are arid regions where evaporation often exceeds precipitation.",
      full: "Organisms in this habitat must have extreme adaptations, like the camel's ability to store fat or the cactus's ability to store water in its succulent stem.",
      h: "Is 'Sparse Vegetation' found in the 'Rainforest' or the 'Desert'?"
    },
    {
      yr: 2021,
      q: "The pigment responsible for the green color in plants is:",
      o: ["Haemoglobin", "Chlorophyll", "Melanin", "Xanthophyll"],
      a: 1,
      e: "Chlorophyll is located in the chloroplasts and is essential for photosynthesis.",
      full: "It absorbs light energy (mostly blue and red wavelengths) and converts it into chemical energy. Melanin is a skin pigment, and Haemoglobin is in blood.",
      h: "Is the 'Green Pigment' called 'Melanin' or 'Chlorophyll'?"
    },
    {
      yr: 2021,
      q: "Which of the following is a demerit of sexual reproduction?",
      o: ["High genetic variation", "Requires two parents", "Faster population growth", "Better adaptation to change"],
      a: 1,
      e: "Finding a mate takes time and energy, which can be a disadvantage compared to asexual reproduction.",
      full: "While sexual reproduction provides variation (a major advantage), it is slower and more energy-intensive because it usually requires two compatible individuals and the production of gametes.",
      h: "Is 'Requiring Two Parents' an advantage or a 'Demerit'?"
    },
    {
      yr: 2021,
      q: "The type of skeleton found in an earthworm is a/an:",
      o: ["Exoskeleton", "Endoskeleton", "Hydrostatic skeleton", "Bony skeleton"],
      a: 2,
      e: "Earthworms use fluid pressure within their body segments to maintain shape and move.",
      full: "Because they lack bones or shells, they rely on the 'incompressibility' of the fluid in their coelom. Muscles act against this fluid pressure to elongate or shorten the body.",
      h: "Is a 'Fluid-based' skeleton called 'Bony' or 'Hydrostatic'?"
    },
    {
      yr: 2021,
      q: "The blood vessel that carries oxygenated blood from the lungs to the heart is the:",
      o: ["Pulmonary artery", "Pulmonary vein", "Aorta", "Vena cava"],
      a: 1,
      e: "The pulmonary vein is the ONLY vein that carries oxygen-rich blood.",
      full: "Veins usually carry deoxygenated blood toward the heart. The Pulmonary Vein is the exception, bringing freshly oxygenated blood from the lungs to the Left Atrium.",
      h: "Does the 'Pulmonary Vein' or 'Artery' carry 'Oxygenated' blood?"
    },
    {
      yr: 2021,
      q: "The relationship between a nitrogen-fixing bacterium and a leguminous plant is:",
      o: ["Mutualism", "Commensalism", "Parasitism", "Saprophytism"],
      a: 0,
      e: "The plant gets nitrates, and the bacterium gets food and shelter.",
      full: "Both organisms benefit in this (+/+) relationship. This is why legumes are often used in crop rotation to naturally replenish soil nitrogen levels.",
      h: "Is 'Both Benefit' called 'Mutualism' or 'Parasitism'?"
    },
    {
      yr: 2021,
      q: "Which of the following is an example of an involuntary reflex?",
      o: ["Singing a song", "Withdrawal of hand from a hot object", "Riding a horse", "Solving a puzzle"],
      a: 1,
      e: "Reflexes are automatic and bypass the conscious brain for speed.",
      full: "The 'Reflex Arc' usually involves a sensory neuron, a relay neuron in the spinal cord, and a motor neuron. This allows for a split-second response to danger.",
      h: "Is 'Singing' or 'Hand Withdrawal' a reflex?"
    },
    {
      yr: 2021,
      q: "The instrument used to measure wind speed is the:",
      o: ["Hygrometer", "Anemometer", "Wind vane", "Barometer"],
      a: 1,
      e: "An anemometer usually consists of cups that rotate faster as wind speed increases.",
      full: "For comparison: A Wind Vane shows direction, a Hygrometer measures humidity, and a Barometer measures air pressure.",
      h: "Is speed measured by a 'Wind Vane' or an 'Anemometer'?"
    },
    {
      yr: 2021,
      q: "The vitamin that prevents the disease called Scurvy is:",
      o: ["Vitamin A", "Vitamin B", "Vitamin C", "Vitamin D"],
      a: 2,
      e: "Vitamin C is essential for collagen synthesis; its lack causes bleeding gums.",
      full: "Scurvy was common among sailors who lacked fresh fruits. Citrus fruits like oranges and lemons are excellent sources of Vitamin C.",
      h: "Is 'Scurvy' prevented by Vitamin 'C' or 'D'?"
    },
    {
      yr: 2021,
      q: "The structure used by insects for excretion is the:",
      o: ["Contractile vacuole", "Kidney", "Malpighian tubule", "Flame cell"],
      a: 2,
      e: "Malpighian tubules remove waste from the hemolymph into the gut of insects.",
      full: "This system is very efficient at conserving water, as the waste is excreted as nearly dry uric acid crystals alongside feces.",
      h: "Do insects use 'Kidneys' or 'Malpighian tubules'?"
    },
    {
      yr: 2021,
      q: "A person with blood group O can safely donate blood to people with blood groups:",
      o: ["O only", "A and B only", "AB only", "A, B, AB, and O"],
      a: 3,
      e: "Group O is the universal donor because its cells lack A and B antigens.",
      full: "Since there are no antigens on the surface of Group O red blood cells, the recipient's antibodies have nothing to attack. However, Group O can only receive blood from another O.",
      h: "Is 'Group O' the 'Universal Donor' or 'Universal Recipient'?"
    },
    {
      yr: 2021,
      q: "Which of the following is a major function of the Large Intestine?",
      o: ["Digestion of proteins", "Absorption of water", "Production of bile", "Absorption of glucose"],
      a: 1,
      e: "The colon reabsorbs water from undigested food, turning it into solid feces.",
      full: "While most chemical digestion and nutrient absorption happen in the small intestine, the large intestine is primarily responsible for water recovery and waste storage.",
      h: "Does the 'Large Intestine' digest 'Protein' or absorb 'Water'?"
    },
    {
      yr: 2021,
      q: "The theory of Natural Selection was co-proposed by Charles Darwin and:",
      o: ["Gregor Mendel", "Alfred Russel Wallace", "Louis Pasteur", "Robert Hooke"],
      a: 1,
      e: "Wallace independently arrived at the same conclusion as Darwin regarding evolution.",
      full: "Both scientists presented their findings together in 1858. However, Darwin became more famous after publishing 'On the Origin of Species' a year later.",
      h: "Was Darwin's partner 'Mendel' or 'Wallace'?"
    },
    {
      yr: 2021,
      q: "Which of the following is an example of a physiological variation?",
      o: ["Skin color", "Blood group", "Height", "Fingerprints"],
      a: 1,
      e: "Physiological variations relate to how the body functions internally.",
      full: "Skin color and height are 'Morphological' (physical appearance). Blood group is 'Physiological' because it depends on the chemical nature of the blood cells.",
      h: "Is 'Blood Group' or 'Height' a physiological trait?"
    },
    {
      yr: 2021,
      q: "The specialized breathing roots found in mangrove plants are:",
      o: ["Prop roots", "Pneumatophores", "Buttress roots", "Stilt roots"],
      a: 1,
      e: "Pneumatophores grow upward out of the mud to get oxygen for the roots.",
      full: "In swampy, waterlogged soils, there is little oxygen. Mangroves have evolved these 'breathing tubes' to allow air to reach the submerged root systems.",
      h: "Are 'Breathing Roots' called 'Buttress' or 'Pneumatophores'?"
    },
    {
      yr: 2021,
      q: "Which of the following organisms is at the top of a typical food chain?",
      o: ["Grass", "Grasshopper", "Lizard", "Hawk"],
      a: 3,
      e: "The hawk is a tertiary consumer or top predator with no natural enemies.",
      full: "In the chain Grass -> Grasshopper -> Lizard -> Hawk, the Hawk is the apex predator. Energy decreases at each step, so there are fewer hawks than grasshoppers.",
      h: "Is the 'Top' of the chain the 'Producer' or the 'Predator'?"
    },
    {
      yr: 2021,
      q: "The basic unit of classification is the:",
      o: ["Phylum", "Class", "Genus", "Species"],
      a: 3,
      e: "A species consists of organisms that can interbreed to produce fertile offspring.",
      full: "The hierarchy goes: Kingdom, Phylum, Class, Order, Family, Genus, Species. Species is the most specific level and the fundamental unit of the system.",
      h: "Is the 'Basic Unit' the 'Kingdom' or the 'Species'?"
    },
    {
      yr: 2020,
      q: "The process by which inherited traits are passed from parents to offspring is:",
      o: ["Evolution", "Heredity", "Variation", "Adaptation"],
      a: 1,
      e: "Heredity is the transmission of genetic characteristics from one generation to the next.",
      full: "Genetics is the study of heredity. It explains why offspring look like their parents while still showing some differences (variations) due to the mixing of genes during meiosis.",
      h: "Is 'Passing on Traits' called 'Evolution' or 'Heredity'?"
    },
    {
      yr: 2020,
      q: "Which of the following is a function of the mammalian skin?",
      o: ["Production of red blood cells", "Regulation of body temperature", "Digestion of fats", "Absorption of oxygen"],
      a: 1,
      e: "The skin regulates temperature through sweating and the dilation/constriction of blood vessels.",
      full: "When the body is too hot, sweat glands release moisture that cools the skin as it evaporates. When cold, hair erector muscles contract (goosebumps) to trap a layer of warm air.",
      h: "Does the skin 'Make Blood' or 'Regulate Temperature'?"
    },
    {
      yr: 2020,
      q: "The type of fruit formed from a single flower with several free carpels is a/an:",
      o: ["Simple fruit", "Aggregate fruit", "Multiple fruit", "Dry fruit"],
      a: 1,
      e: "Aggregate fruits (like kola nut or strawberry) develop from one flower with many ovaries.",
      full: "A Simple fruit comes from one ovary. A Multiple fruit (like pineapple) comes from a group of flowers (inflorescence). An Aggregate fruit comes from many ovaries in one single flower.",
      h: "Is it a 'Simple' or 'Aggregate' fruit if it has 'Many Free Carpels'?"
    },
    {
      yr: 2020,
      q: "The part of the brain responsible for muscular coordination and balance is the:",
      o: ["Cerebrum", "Cerebellum", "Thalamus", "Pons varolii"],
      a: 1,
      e: "The cerebellum coordinates voluntary movements such as posture, balance, and speech.",
      full: "While the Cerebrum handles thinking and memory, the Cerebellum (often called the 'little brain') ensures your movements are smooth and you don't fall over.",
      h: "Is 'Balance' controlled by the 'Cerebrum' or 'Cerebellum'?"
    },
    {
      yr: 2020,
      q: "Which of the following is a function of the Xylem tissue in plants?",
      o: ["Transport of manufactured food", "Transport of water and mineral salts", "Gaseous exchange", "Translocation of sugar"],
      a: 1,
      e: "Xylem vessels carry water and dissolved minerals upwards from the roots to the leaves.",
      full: "Xylem also provides mechanical support to the plant due to its lignified walls. Food transport, however, is the job of the Phloem.",
      h: "Does 'Xylem' carry 'Food' or 'Water'?"
    },
    {
      yr: 2020,
      q: "The deficiency of Vitamin A in the diet leads to:",
      o: ["Rickets", "Night blindness", "Beri-beri", "Scurvy"],
      a: 1,
      e: "Vitamin A is essential for the formation of rhodopsin in the retina, which is needed for low-light vision.",
      full: "Severe Vitamin A deficiency can lead to permanent blindness (xerophthalmia). Carrots and leafy greens are famous sources of this vitamin.",
      h: "Is Vitamin A for 'Bones' or 'Eyes'?"
    },
    {
      yr: 2020,
      q: "The sum total of all the chemical reactions occurring in a living cell is:",
      o: ["Anabolism", "Catabolism", "Metabolism", "Digestion"],
      a: 2,
      e: "Metabolism includes both 'building up' (anabolism) and 'breaking down' (catabolism) reactions.",
      full: "Metabolism allows organisms to grow, reproduce, maintain their structures, and respond to their environments. It is the engine of life.",
      h: "Is the 'Total Reactions' called 'Digestion' or 'Metabolism'?"
    },
    {
      yr: 2020,
      q: "Which of the following is a flight adaptation in birds?",
      o: ["Heavy solid bones", "Pneumatic (hollow) bones", "Long thick neck", "Lateral line system"],
      a: 1,
      e: "Hollow bones reduce body weight, making it easier for birds to stay airborne.",
      full: "These pneumatic bones are often reinforced with internal struts for strength despite being light. This is a classic example of structure meeting function in evolution.",
      h: "Are bird bones 'Solid' or 'Hollow'?"
    },
    {
      yr: 2020,
      q: "The hormone that promotes the ripening of fruits is:",
      o: ["Auxin", "Gibberellin", "Ethylene (Ethene)", "Cytokinin"],
      a: 2,
      e: "Ethylene is a gaseous hormone that triggers the breakdown of cell walls and conversion of starch to sugar in fruits.",
      full: "Because it is a gas, one ripe fruit can cause others nearby to ripen quickly. This is why 'one bad apple spoils the whole bunch'.",
      h: "Is the ripening gas 'Ethylene' or 'Auxin'?"
    },
    {
      yr: 2020,
      q: "The structure in a cell where aerobic respiration takes place is the:",
      o: ["Nucleus", "Mitochondrion", "Ribosome", "Vacuole"],
      a: 1,
      e: "Mitochondria are the 'powerhouses' of the cell, generating ATP through respiration.",
      full: "Cells that require a lot of energy, like muscle cells or sperm cells, contain a very high number of mitochondria to meet their energy demands.",
      h: "Is 'Energy' made in the 'Ribosome' or 'Mitochondrion'?"
    },
    {
      yr: 2020,
      q: "An example of a succulent plant found in arid regions is:",
      o: ["Oak", "Cactus", "Water lily", "Mushroom"],
      a: 1,
      e: "Succulents store water in thick, fleshy stems or leaves to survive droughts.",
      full: "Cacti are perfectly adapted xerophytes. They have spines instead of leaves to reduce water loss and green stems to carry out photosynthesis.",
      h: "Is a 'Cactus' or 'Oak' a water-storing plant?"
    },
    {
      yr: 2020,
      q: "The nitrogenous base that is present in DNA but absent in RNA is:",
      o: ["Adenine", "Guanine", "Cytosine", "Thymine"],
      a: 3,
      e: "DNA uses Thymine, while RNA replaces it with Uracil.",
      full: "Both have Adenine, Guanine, and Cytosine. The presence of Thymine is one of the key chemical signatures that distinguishes DNA from RNA.",
      h: "Is 'Thymine' or 'Uracil' unique to DNA?"
    },
    {
      yr: 2020,
      q: "The organism that causes the disease 'African Sleeping Sickness' is:",
      o: ["Plasmodium", "Trypanosoma", "Vibrio cholerae", "Tsetse fly"],
      a: 1,
      e: "Trypanosoma is the protozoan parasite; the Tsetse fly is only the vector.",
      full: "It is important not to confuse the 'pathogen' (Trypanosoma) with the 'vector' (Tsetse fly). The parasite attacks the central nervous system, leading to lethargy.",
      h: "Is the 'Parasite' called 'Trypanosoma' or 'Tsetse'?"
    },
    {
      yr: 2020,
      q: "Which of the following is an example of a physiological variation in humans?",
      o: ["Ability to roll the tongue", "Weight", "Height", "Hair color"],
      a: 0,
      e: "Physiological variations are functional differences governed by one or a few genes.",
      full: "Tongue rolling and blood groups are clear-cut (discrete) physiological variations. Height and weight are morphological and show continuous variation.",
      h: "Is 'Tongue Rolling' or 'Height' a physiological trait?"
    },
    {
      yr: 2020,
      q: "The association between a shark and a suckerfish (remora) is:",
      o: ["Parasitism", "Commensalism", "Mutualism", "Saprophytism"],
      a: 1,
      e: "The suckerfish gets food and transport, while the shark is unaffected.",
      full: "This is a (+/0) relationship. The remora benefits by eating scraps from the shark's meals, but the shark neither gains nor loses anything from the remora's presence.",
      h: "Is 'One Benefits, Other Neutral' called 'Mutualism' or 'Commensalism'?"
    },
    {
      yr: 2020,
      q: "The part of the flower that receives pollen grains is the:",
      o: ["Anther", "Stigma", "Style", "Ovary"],
      a: 1,
      e: "The stigma is the receptive tip of the carpel, often sticky to trap pollen.",
      full: "Pollination is successful when pollen moves from the anther to the stigma. From there, the pollen grain germinates and grows a tube toward the ovary.",
      h: "Is the 'Receiver' the 'Anther' or 'Stigma'?"
    },
    {
      yr: 2020,
      q: "Which of the following blood cells is responsible for fighting infections?",
      o: ["Red blood cells", "White blood cells", "Platelets", "Plasma"],
      a: 1,
      e: "White blood cells (leukocytes) identify and destroy pathogens like bacteria and viruses.",
      full: "Some white blood cells 'eat' bacteria (phagocytes), while others produce antibodies (lymphocytes) to neutralize specific threats to the body.",
      h: "Do 'Red' or 'White' cells fight disease?"
    },
    {
      yr: 2020,
      q: "The movement of a plant shoot towards light is known as:",
      o: ["Positive geotropism", "Positive phototropism", "Negative phototropism", "Hydrotropism"],
      a: 1,
      e: "Shoots grow 'towards' (positive) light (photo).",
      full: "Roots, on the other hand, show negative phototropism (growing away from light) and positive geotropism (growing towards gravity/the earth).",
      h: "Is light-seeking growth 'Positive' or 'Negative' phototropism?"
    },
    {
      yr: 2020,
      q: "The organ in the human body that detoxifies poisonous substances is the:",
      o: ["Kidney", "Liver", "Pancreas", "Spleen"],
      a: 1,
      e: "The liver breaks down toxins, drugs, and alcohol into less harmful substances.",
      full: "The liver is the body's primary chemical processing center. It also produces bile for fat digestion and stores excess sugar as glycogen.",
      h: "Is the 'Detox Center' the 'Kidney' or 'Liver'?"
    },
    {
      yr: 2020,
      q: "Which of the following is a non-renewable natural resource?",
      o: ["Water", "Forest", "Natural gas", "Soil"],
      a: 2,
      e: "Fossil fuels like natural gas take millions of years to form and cannot be replaced once used.",
      full: "While forests can be replanted and water cycles through the environment, minerals and fossil fuels are finite and will eventually be depleted.",
      h: "Can 'Natural Gas' be replaced as quickly as 'Trees'?"
    },
    {
      yr: 2019,
      q: "The organelles responsible for cellular respiration are:",
      o: ["Chloroplasts", "Mitochondria", "Ribosomes", "Lysosomes"],
      a: 1,
      e: "Mitochondria produce ATP by breaking down glucose in the presence of oxygen.",
      full: "Mitochondria are known as the 'powerhouse' of the cell. They are most numerous in cells with high energy requirements, such as muscle cells and sperm cells.",
      h: "Is the 'Powerhouse' the 'Chloroplast' or the 'Mitochondrion'?"
    },
    {
      yr: 2019,
      q: "The transition from an aquatic to a terrestrial habitat was first achieved by the:",
      o: ["Pisces", "Amphibia", "Reptilia", "Aves"],
      a: 1,
      e: "Amphibians were the first vertebrates to live on land, though they still return to water to breed.",
      full: "Amphibians like frogs represent a bridge between water and land. They have lungs for air breathing but also use their moist skin for gas exchange (cutaneous respiration).",
      h: "Were 'Amphibians' or 'Reptiles' the first to step onto land?"
    },
    {
      yr: 2019,
      q: "Which of the following is a characteristic of the Kingdom Fungi?",
      o: ["Autotrophic nutrition", "Cell wall made of cellulose", "Heterotrophic nutrition", "Locomotion by cilia"],
      a: 2,
      e: "Fungi cannot make their own food; they absorb nutrients from organic matter.",
      full: "Unlike plants (which have cellulose walls), fungi have cell walls made of chitin. Because they lack chlorophyll, they are either saprophytes or parasites.",
      h: "Are Fungi 'Autotrophs' (make food) or 'Heterotrophs' (absorb food)?"
    },
    {
      yr: 2019,
      q: "The hormone that stimulates the 'let-down' of milk in lactating mammals is:",
      o: ["Progesterone", "Oxytocin", "Estrogen", "Prolactin"],
      a: 1,
      e: "Oxytocin triggers the contraction of smooth muscles to release milk.",
      full: "While Prolactin stimulates the *production* of milk, Oxytocin is responsible for the actual *release* (ejection) of the milk during nursing.",
      h: "Is 'Milk Release' caused by 'Prolactin' or 'Oxytocin'?"
    },
    {
      yr: 2019,
      q: "Which of the following is a vestigial organ in humans?",
      o: ["Liver", "Appendix", "Pancreas", "Spleen"],
      a: 1,
      e: "The appendix is a small pouch that has lost its original digestive function in humans.",
      full: "Vestigial organs are structures that were functional in ancestors but have become reduced and useless over time. Other examples include the coccyx (tailbone) and wisdom teeth.",
      h: "Is the 'Appendix' or 'Liver' a useless leftover from evolution?"
    },
    {
      yr: 2019,
      q: "The part of the flower that produces the male gamete is the:",
      o: ["Stigma", "Filament", "Anther", "Ovary"],
      a: 2,
      e: "The anther contains pollen sacs where pollen grains (male gametophytes) are formed.",
      full: "The stamen is the male reproductive part, consisting of the stalk (filament) and the pollen-bearing tip (anther).",
      h: "Is the 'Anther' or 'Ovary' the male part?"
    },
    {
      yr: 2019,
      q: "The type of association where one organism kills and eats another is:",
      o: ["Parasitism", "Commensalism", "Predation", "Symiosis"],
      a: 2,
      e: "Predation involves a predator hunting and consuming its prey.",
      full: "This is a (+/-) relationship where the predator benefits and the prey is killed. It is a major factor in controlling population sizes in an ecosystem.",
      h: "Is a lion eating a zebra 'Parasitism' or 'Predation'?"
    },
    {
      yr: 2019,
      q: "The blood vessel that carries deoxygenated blood from the body to the right atrium is the:",
      o: ["Aorta", "Pulmonary artery", "Vena cava", "Pulmonary vein"],
      a: 2,
      e: "The Vena Cava is the largest vein, returning 'spent' blood to the heart.",
      full: "The Superior Vena Cava brings blood from the upper body, while the Inferior Vena Cava brings it from the lower body, both emptying into the Right Atrium.",
      h: "Is the 'Main Vein' the 'Aorta' or the 'Vena Cava'?"
    },
    {
      yr: 2019,
      q: "Which of the following is a function of the spinal cord?",
      o: ["Memory storage", "Control of reflex actions", "Regulation of body temperature", "Intelligence"],
      a: 1,
      e: "The spinal cord acts as the center for simple reflex actions that bypass the brain.",
      full: "The spinal cord provides a fast pathway for nerve impulses. It allows the body to react to danger (like heat) before the brain even processes the pain.",
      h: "Does the 'Spinal Cord' handle 'Reflexes' or 'Thinking'?"
    },
    {
      yr: 2019,
      q: "The pigment in the red blood cells that carries oxygen is:",
      o: ["Chlorophyll", "Haemoglobin", "Melanin", "Anthocyanin"],
      a: 1,
      e: "Haemoglobin contains iron, which binds to oxygen molecules in the lungs.",
      full: "When haemoglobin binds with oxygen, it becomes oxyhaemoglobin (bright red). It releases this oxygen when it reaches tissues with low oxygen concentration.",
      h: "Is 'Blood Pigment' called 'Melanin' or 'Haemoglobin'?"
    },
    {
      yr: 2019,
      q: "The condition in which a person can see distant objects clearly but not near ones is:",
      o: ["Myopia", "Hypermetropia", "Astigmatism", "Glaucoma"],
      a: 1,
      e: "Hypermetropia (long-sightedness) occurs when the focal point is behind the retina.",
      full: "To correct this, a converging (convex) lens is used to bring the image forward onto the retina. Myopia (short-sightedness) is the opposite condition.",
      h: "Is 'Long-sightedness' called 'Myopia' or 'Hypermetropia'?"
    },
    {
      yr: 2019,
      q: "Which of the following is a primary consumer in a terrestrial habitat?",
      o: ["Grass", "Grasshopper", "Lizard", "Snake"],
      a: 1,
      e: "Primary consumers (herbivores) feed directly on producers (plants).",
      full: "In this chain, Grass is the producer. The Grasshopper is the primary consumer because it eats the grass. The Lizard would be a secondary consumer.",
      h: "Is a 'Grasshopper' a 'Producer' or 'Primary Consumer'?"
    },
    {
      yr: 2019,
      q: "The process by which plants lose water vapor through the stomata is:",
      o: ["Osmosis", "Guttation", "Transpiration", "Evaporation"],
      a: 2,
      e: "Transpiration creates a 'pull' that helps draw water up from the roots to the leaves.",
      full: "While evaporation can happen from any surface, Transpiration is the biological loss of water vapor specifically from plant leaves and stems.",
      h: "Is 'Water Vapor Loss' called 'Transpiration' or 'Osmosis'?"
    },
    {
      yr: 2019,
      q: "The structural unit of inheritance is the:",
      o: ["Chromosome", "Gene", "Nucleus", "DNA"],
      a: 1,
      e: "A gene is a segment of DNA that codes for a specific protein or trait.",
      full: "Genes are located on chromosomes. While DNA is the material, the 'Gene' is the functional unit that actually determines characteristics like eye color.",
      h: "Is the 'Unit of Inheritance' the 'Gene' or the 'Chromosome'?"
    },
    {
      yr: 2019,
      q: "Which of the following is a function of the skeleton in mammals?",
      o: ["Digestion of food", "Production of blood cells", "Excretion of urea", "Synthesis of vitamins"],
      a: 1,
      e: "Red and white blood cells are produced in the bone marrow of long bones.",
      full: "The skeleton isn't just for support; it's a dynamic tissue. The bone marrow acts as a factory for nearly all the blood cells in the body.",
      h: "Does the skeleton 'Make Blood' or 'Digest Food'?"
    },
    {
      yr: 2019,
      q: "The enzyme that digests fats (lipids) into fatty acids and glycerol is:",
      o: ["Amylase", "Pepsin", "Lipase", "Trypsin"],
      a: 2,
      e: "Lipase is produced by the pancreas and acts in the small intestine.",
      full: "Fats are first emulsified by bile to increase their surface area, then Lipase breaks the chemical bonds to turn them into absorbable molecules.",
      h: "Is 'Lipase' or 'Amylase' for 'Fats'?"
    },
    {
      yr: 2019,
      q: "The type of germination where the cotyledons remain below the soil is:",
      o: ["Epigeal", "Hypogeal", "Aerial", "Hydroponic"],
      a: 1,
      e: "In hypogeal germination (e.g., maize), the epicotyl elongates while the cotyledons stay underground.",
      full: "In Epigeal germination (e.g., beans), the hypocotyl elongates, pulling the cotyledons above the soil surface where they often turn green.",
      h: "Does 'Hypogeal' mean 'Below' or 'Above' the ground?"
    },
    {
      yr: 2019,
      q: "The scientist who discovered the first antibiotic, Penicillin, was:",
      o: ["Louis Pasteur", "Alexander Fleming", "Robert Koch", "Gregor Mendel"],
      a: 1,
      e: "Fleming noticed a mold (Penicillium) killing bacteria in a petri dish in 1928.",
      full: "This discovery revolutionized medicine, moving humanity into the 'antibiotic era' where bacterial infections were no longer a guaranteed death sentence.",
      h: "Was 'Penicillin' discovered by 'Pasteur' or 'Fleming'?"
    },
    {
      yr: 2019,
      q: "Which of the following is an example of an ecosystem?",
      o: ["A school of fish", "A tropical rainforest", "A herd of cattle", "A flock of birds"],
      a: 1,
      e: "An ecosystem includes both the living community and the non-living environment (soil, air, water).",
      full: "A school of fish is a 'population.' A tropical rainforest is an 'ecosystem' because it encompasses all the plants, animals, and the physical climate they live in.",
      h: "Is a 'Rainforest' or a 'Herd' an ecosystem?"
    },
    {
      yr: 2019,
      q: "The male gamete in humans is the:",
      o: ["Ova", "Spermatozoon", "Zygote", "Embryo"],
      a: 1,
      e: "The sperm cell is a motile haploid cell produced in the testes.",
      full: "It consists of a head containing DNA, a midpiece full of mitochondria for energy, and a tail (flagellum) for swimming toward the egg.",
      h: "Is the 'Male Cell' the 'Ova' or the 'Sperm'?"
    },
    {
      yr: 2019,
      q: "The movement of particles from a region of higher concentration to a region of lower concentration is:",
      o: ["Osmosis", "Diffusion", "Active transport", "Translocation"],
      a: 1,
      e: "Diffusion occurs down a concentration gradient and does not require energy.",
      full: "Examples include the smell of perfume spreading in a room or oxygen moving from the alveoli into the blood. Unlike Osmosis, it does not require a semi-permeable membrane.",
      h: "Is 'General Particle Movement' called 'Osmosis' or 'Diffusion'?"
    },
    {
      yr: 2019,
      q: "Which of the following is a function of the mammalian liver?",
      o: ["Deamination of excess amino acids", "Production of digestive enzymes", "Filtration of sewage", "Storage of liquid waste"],
      a: 0,
      e: "The liver breaks down excess amino acids into urea and a carbohydrate part.",
      full: "The nitrogen-containing part is turned into urea (excreted by kidneys), while the rest is used for energy. This prevents toxic ammonia buildup in the body.",
      h: "Does the liver 'Deaminate Amino Acids' or 'Make Enzymes'?"
    },
    {
      yr: 2019,
      q: "The observable characteristics of an individual resulting from the interaction of its genotype with the environment is the:",
      o: ["Allele", "Phenotype", "Hybrid", "Locus"],
      a: 1,
      e: "Phenotype = Genotype + Environment (e.g., a person's height or skin color).",
      full: "Even if two plants have the same genes for height, if one is grown in poor soil, it will be shorter. The 'Short' or 'Tall' result is the Phenotype.",
      h: "Is 'Physical Appearance' the 'Genotype' or 'Phenotype'?"
    },
    {
      yr: 2019,
      q: "The small, specialized vessels where exchange of materials between blood and cells occurs are:",
      o: ["Arteries", "Veins", "Capillaries", "Venules"],
      a: 2,
      e: "Capillaries have walls that are only one cell thick to allow for rapid diffusion.",
      full: "Arteries carry blood away, veins bring it back, but the Capillaries are the 'business end' where oxygen and nutrients actually enter the tissues.",
      h: "Are 'Exchange Vessels' called 'Arteries' or 'Capillaries'?"
    },
    {
      yr: 2019,
      q: "Which of the following is an example of a discontinuous variation?",
      o: ["Height", "Weight", "Blood Group", "Intelligence"],
      a: 2,
      e: "Discontinuous variations have distinct categories with no intermediates (you are either A, B, AB, or O).",
      full: "Continuous variations (like height) show a range of values. Discontinuous variations are usually controlled by a single gene and are not affected by the environment.",
      h: "Is 'Blood Group' or 'Height' a distinct category?"
    },
    {
      yr: 2019,
      q: "The association between a fungus and an alga in a Lichen is:",
      o: ["Mutualism", "Parasitism", "Commensalism", "Saprophytism"],
      a: 0,
      e: "The alga provides food (photosynthesis) and the fungus provides water and protection.",
      full: "This is a classic 'win-win' situation. Without each other, many species of lichens would not be able to survive on bare rocks or tree bark.",
      h: "Is 'Lichen' an example of 'Mutualism' or 'Parasitism'?"
    },
    {
      yr: 2019,
      q: "The part of the mammalian ear that converts sound vibrations into nerve impulses is the:",
      o: ["Ossicles", "Cochlea", "Tympanic membrane", "Pinna"],
      a: 1,
      e: "The cochlea is a snail-shaped structure filled with fluid and sensory hair cells.",
      full: "When the fluid vibrates, the hair cells trigger electrical signals that travel via the auditory nerve to the brain for interpretation as sound.",
      h: "Is the 'Signal Maker' the 'Eardrum' or the 'Cochlea'?"
    },
    {
      yr: 2019,
      q: "Which of the following is a dental adaptation of a carnivore?",
      o: ["Flat molars for grinding", "Long pointed canines", "Diastema", "Horny pad"],
      a: 1,
      e: "Canines are used for piercing, gripping, and tearing the flesh of prey.",
      full: "Carnivores also have carnassial teeth (modified premolars and molars) that act like scissors to shear through bone and muscle.",
      h: "Do 'Meat-eaters' need 'Flat Molars' or 'Long Canines'?"
    },
    {
      yr: 2019,
      q: "The structure in a plant cell that provides rigidity and support is the:",
      o: ["Cell membrane", "Cell wall", "Cytoplasm", "Nucleus"],
      a: 1,
      e: "The cell wall is made of cellulose and maintains the shape of the plant cell.",
      full: "Animal cells lack a cell wall, which is why they are flexible. The cell wall prevents plant cells from bursting when they take in water by osmosis.",
      h: "Is 'Rigidity' provided by the 'Wall' or the 'Membrane'?"
    },
    {
      yr: 2019,
      q: "Which of the following is a greenhouse gas?",
      o: ["Oxygen", "Nitrogen", "Carbon dioxide", "Argon"],
      a: 2,
      e: "CO2 traps heat in the atmosphere, contributing to the greenhouse effect.",
      full: "While nitrogen and oxygen make up most of the air, they don't trap heat. CO2, methane, and water vapor are the main gases responsible for warming the planet.",
      h: "Is 'CO2' or 'Oxygen' a greenhouse gas?"
    },
    {
      yr: 2019,
      q: "The type of evolution where unrelated species develop similar traits due to similar environments is:",
      o: ["Divergent evolution", "Convergent evolution", "Adaptive radiation", "Co-evolution"],
      a: 1,
      e: "Convergent evolution results in analogous structures (e.g., wings of birds and insects).",
      full: "Even though a shark (fish) and a dolphin (mammal) are unrelated, they both have streamlined bodies and fins because they both live in the ocean.",
      h: "Is 'Similar traits in different species' called 'Convergent' or 'Divergent'?"
    },
    {
      yr: 2019,
      q: "The primary organ for gaseous exchange in a frog living on land is the:",
      o: ["Gills", "Lungs", "Skin", "Buccal cavity"],
      a: 1,
      e: "Adult frogs use lungs for breathing on land, though skin helps significantly.",
      full: "Frogs are unique because they use three surfaces: Lungs (pulmonary), Skin (cutaneous), and the Mouth lining (buccal). On land, lungs do the heavy lifting.",
      h: "Does an adult frog use 'Gills' or 'Lungs'?"
    },
    {
      yr: 2019,
      q: "The waste product of photosynthesis that is essential for animal life is:",
      o: ["Glucose", "Water", "Oxygen", "Carbon dioxide"],
      a: 2,
      e: "Plants release oxygen as a byproduct of splitting water molecules during the light stage.",
      full: "This 'waste' product for the plant is the lifeblood for aerobic organisms (like us) who need it for cellular respiration.",
      h: "Is the 'Plant Waste' called 'CO2' or 'Oxygen'?"
    },
    {
      yr: 2019,
      q: "Which of the following is an example of a reflex arc component?",
      o: ["Cerebrum", "Sensory neuron", "Pituitary gland", "Liver"],
      a: 1,
      e: "A reflex arc consists of a receptor, sensory neuron, relay neuron, motor neuron, and effector.",
      full: "The sensory neuron carries the 'danger' message from the skin to the spinal cord, bypassing the brain to ensure a faster reaction.",
      h: "Is a 'Neuron' or the 'Liver' part of a reflex?"
    },
    {
      yr: 2019,
      q: "The study of the relationship between a group of different species and their environment is:",
      o: ["Autecology", "Synecology", "Ethology", "Taxonomy"],
      a: 1,
      e: "Synecology looks at communities and ecosystems as a whole.",
      full: "If you study only one zebra species, it's Autecology. If you study the entire Savannah (lions, zebras, grass, etc.), it's Synecology.",
      h: "Is 'Group Study' called 'Autecology' or 'Synecology'?"
    },
    {
      yr: 2019,
      q: "The blood group that can be given to any patient in an emergency is:",
      o: ["Group A", "Group B", "Group AB", "Group O"],
      a: 3,
      e: "Group O negative is the 'Universal Donor' because it has no A, B, or Rh antigens.",
      full: "Because it lacks these surface 'markers,' the recipient's immune system won't recognize it as an invader, preventing a dangerous transfusion reaction.",
      h: "Is the 'Universal Donor' group 'O' or 'AB'?"
    },
    {
      yr: 2019,
      q: "Which of the following structures is used for movement in Euglena?",
      o: ["Cilia", "Flagellum", "Pseudopodia", "Tentacles"],
      a: 1,
      e: "Euglena uses a long, whip-like flagellum at its front end to pull itself through water.",
      full: "Paramecium uses Cilia (tiny hairs) and Amoeba uses Pseudopodia (false feet). The Flagellum is the specific motor for Euglena.",
      h: "Does 'Euglena' use 'Hairs' or a 'Whip'?"
    },
    {
      yr: 2019,
      q: "The part of the brain that maintains posture and equilibrium is the:",
      o: ["Cerebrum", "Cerebellum", "Medulla", "Hypothalamus"],
      a: 1,
      e: "The cerebellum coordinates muscle movements to keep the body balanced.",
      full: "If the cerebellum is damaged, a person might still be able to move their legs (cerebrum function) but will walk with a clumsy, drunken stagger.",
      h: "Is 'Balance' the 'Cerebrum' or 'Cerebellum'?"
    },
    {
      yr: 2019,
      q: "The hormone that causes the 'fight or flight' response is produced by the:",
      o: ["Pituitary gland", "Thyroid gland", "Adrenal gland", "Pancreas"],
      a: 2,
      e: "The adrenal glands (on top of the kidneys) release adrenaline during stress.",
      full: "Adrenaline increases your heart rate and redirects blood to your muscles, preparing you to either face a threat or run away from it.",
      h: "Is 'Adrenaline' from the 'Thyroid' or 'Adrenal' gland?"
    },
    {
      yr: 2019,
      q: "Which of the following is a non-heritable characteristic?",
      o: ["Albinism", "A scar from a burn", "Haemophilia", "Color blindness"],
      a: 1,
      e: "Physical injuries or learned behaviors are not passed down through genes.",
      full: "Albinism and Haemophilia are genetic conditions written into your DNA. A scar is an environmental change and won't be passed on to your children.",
      h: "Is a 'Scar' or 'Albinism' heritable?"
    },
    {
      yr: 2018,
      q: "The process of cell division that results in the formation of gametes is:",
      o: ["Mitosis", "Meiosis", "Binary fission", "Budding"],
      a: 1,
      e: "Meiosis reduces the chromosome number by half to produce haploid sperm and egg cells.",
      full: "While Mitosis produces identical 'daughter' cells for growth, Meiosis ensures that when fertilization occurs, the normal diploid number of chromosomes is restored in the zygote.",
      h: "Is 'Gamete Formation' called 'Mitosis' or 'Meiosis'?"
    },
    {
      yr: 2018,
      q: "Which of the following is a function of the contractile vacuole in Amoeba?",
      o: ["Digestion of food", "Osmoregulation", "Locomotion", "Reproduction"],
      a: 1,
      e: "The contractile vacuole collects and expels excess water to prevent the cell from bursting.",
      full: "Since Amoeba lives in freshwater (hypotonic environment), water constantly enters the cell by osmosis. The vacuole acts as a pump to maintain water balance.",
      h: "Does the 'Vacuole' handle 'Food' or 'Water Balance'?"
    },
    {
      yr: 2018,
      q: "The structural basis of inheritance which carries the genetic code is:",
      o: ["Cytoplasm", "Ribosome", "DNA", "Lysosome"],
      a: 2,
      e: "Deoxyribonucleic acid (DNA) contains the instructions for the development and function of all living things.",
      full: "DNA is organized into genes, which are located on chromosomes within the nucleus. It is the molecular 'blueprint' passed from one generation to the next.",
      h: "Is the 'Genetic Code' in 'DNA' or 'Ribosomes'?"
    },
    {
      yr: 2018,
      q: "The cervical vertebrae are located in the:",
      o: ["Neck region", "Chest region", "Waist region", "Tail region"],
      a: 0,
      e: "The cervical vertebrae support the head and allow for neck movement.",
      full: "In almost all mammals (including humans and giraffes), there are 7 cervical vertebrae. The first two are the Atlas and the Axis, which allow the head to nod and rotate.",
      h: "Are 'Cervical' vertebrae in the 'Neck' or 'Waist'?"
    },
    {
      yr: 2018,
      q: "The enzyme Ptyalin (Salivary Amylase) acts on:",
      o: ["Proteins", "Starch", "Fats", "Vitamins"],
      a: 1,
      e: "Ptyalin begins the chemical digestion of cooked starch into maltose in the mouth.",
      full: "Digestion starts in the mouth. If you chew bread for a long time, it begins to taste sweet because the ptyalin is converting the starch into sugar.",
      h: "Does 'Ptyalin' digest 'Meat' or 'Starch'?"
    },
    {
      yr: 2018,
      q: "Which of the following is an example of a physiological variation?",
      o: ["Fingerprints", "Blood group", "Height", "Eye color"],
      a: 1,
      e: "Blood groups are functional/chemical differences that don't change with the environment.",
      full: "Physiological variations like tongue rolling and blood groups show 'discontinuous variation,' meaning you fall into one distinct category or another.",
      h: "Is 'Height' or 'Blood Group' a physiological trait?"
    },
    {
      yr: 2018,
      q: "The part of the flower that produces the female gametes is the:",
      o: ["Stigma", "Style", "Ovary", "Anther"],
      a: 2,
      e: "The ovary contains the ovules, which house the female egg cells.",
      full: "After fertilization, the ovules become seeds and the ovary ripens into a fruit. The anther, by contrast, is the male part that produces pollen.",
      h: "Is the 'Female Part' the 'Anther' or 'Ovary'?"
    },
    {
      yr: 2018,
      q: "In which of the following biomes is the vegetation characterized by 'buttress roots'?",
      o: ["Savanna", "Tropical rainforest", "Desert", "Tundra"],
      a: 1,
      e: "Buttress roots provide extra support for tall trees in shallow, nutrient-poor rainforest soils.",
      full: "Because rainforest soil is often thin, trees develop these wide, plank-like roots at the base to prevent them from toppling over in the wet ground.",
      h: "Are 'Buttress Roots' in the 'Desert' or 'Rainforest'?"
    },
    {
      yr: 2018,
      q: "The hormone that regulates the amount of water reabsorbed by the kidney is:",
      o: ["Adrenaline", "Insulin", "Anti-diuretic hormone (ADH)", "Thyroxine"],
      a: 2,
      e: "ADH (Vasopressin) makes the kidney tubules more permeable to water when the body is dehydrated.",
      full: "ADH is produced by the hypothalamus and released by the pituitary. When you are thirsty, more ADH is released, so your kidneys produce more concentrated urine.",
      h: "Is the 'Water Regulator' hormone 'Insulin' or 'ADH'?"
    },
    {
      yr: 2018,
      q: "The respiratory organ used by an adult toad is the:",
      o: ["Gill", "Skin and lungs", "Trachea", "Spiracle"],
      a: 1,
      e: "Toads use both lungs and their moist skin for gaseous exchange on land.",
      full: "While the tadpole stage uses gills, the adult toad breathes through its lungs and skin (cutaneous respiration). This is why toads must keep their skin moist.",
      h: "Do adult toads use 'Gills' or 'Skin/Lungs'?"
    },
    {
      yr: 2018,
      q: "Which of the following organisms is a primary producer?",
      o: ["Grasshopper", "Fungus", "Green plant", "Lion"],
      a: 2,
      e: "Green plants are autotrophs that produce their own food via photosynthesis.",
      full: "Producers form the base of every food chain. They convert solar energy into chemical energy (glucose) which then feeds all other organisms (consumers).",
      h: "Is a 'Lion' or a 'Plant' a producer?"
    },
    {
      yr: 2018,
      q: "The part of the mammalian brain responsible for intelligence and voluntary action is the:",
      o: ["Cerebellum", "Cerebrum", "Medulla oblongata", "Thalamus"],
      a: 1,
      e: "The cerebrum is the largest part of the brain and handles complex functions like memory and logic.",
      full: "The cerebrum is divided into lobes that process sight, sound, and touch, and it is where all our conscious decisions and thoughts are made.",
      h: "Is 'Thinking' done in the 'Cerebrum' or 'Cerebellum'?"
    },
    {
      yr: 2018,
      q: "The relationship between a tick and a cow is:",
      o: ["Commensalism", "Mutualism", "Parasitism", "Symbiosis"],
      a: 2,
      e: "The tick (parasite) benefits by sucking blood, while the cow (host) is harmed.",
      full: "This is a (+/-) relationship. Parasites usually do not kill their host immediately, as they rely on the host for a constant food supply.",
      h: "Is 'Tick on a Cow' called 'Mutualism' or 'Parasitism'?"
    },
    {
      yr: 2018,
      q: "The structure in the plant cell that contains the cell sap is the:",
      o: ["Nucleus", "Large central vacuole", "Chloroplast", "Cytoplasm"],
      a: 1,
      e: "The vacuole stores water, salts, and sugars, providing turgor pressure for the cell.",
      full: "Animal cells have small, temporary vacuoles, but plant cells have a large, permanent central vacuole that keeps the cell firm (turgid) and supports the plant structure.",
      h: "Is 'Cell Sap' in the 'Nucleus' or 'Vacuole'?"
    },
    {
      yr: 2018,
      q: "Which of the following is a symptom of nitrogen deficiency in plants?",
      o: ["Purple leaves", "Yellowing of leaves (chlorosis)", "Weak stems", "Premature fruit drop"],
      a: 1,
      e: "Nitrogen is needed for chlorophyll; its lack causes leaves to turn pale or yellow.",
      full: "Nitrogen is a key component of amino acids and proteins. Without it, the plant's growth is stunted and it cannot carry out photosynthesis efficiently.",
      h: "Does 'Nitrogen' lack cause 'Purple' or 'Yellow' leaves?"
    },
    {
      yr: 2018,
      q: "The bone that articulates with the glenoid cavity is the:",
      o: ["Femur", "Humerus", "Tibia", "Radius"],
      a: 1,
      e: "The head of the humerus fits into the glenoid cavity of the scapula (shoulder blade).",
      full: "This forms a ball-and-socket joint, allowing the arm to move in many directions. For the hip, the femur fits into the acetabulum.",
      h: "Does the 'Humerus' or 'Femur' fit the 'Glenoid Cavity'?"
    },
    {
      yr: 2018,
      q: "The process of maintaining a constant internal environment is:",
      o: ["Osmosis", "Homeostasis", "Excretion", "Respiration"],
      a: 1,
      e: "Homeostasis involves regulating temperature, blood sugar, and water levels.",
      full: "It ensures that the body's internal conditions stay stable despite changes in the external environment, which is vital for enzyme function and cell survival.",
      h: "Is 'Internal Balance' called 'Excretion' or 'Homeostasis'?"
    },
    {
      yr: 2018,
      q: "The instrument used to measure the rate of transpiration is the:",
      o: ["Photometer", "Potometer", "Hygrometer", "Anemometer"],
      a: 1,
      e: "A potometer measures the water uptake of a plant shoot, which is proportional to transpiration.",
      full: "By observing how fast an air bubble moves in the potometer's tube, scientists can calculate how much water the plant is losing to the atmosphere.",
      h: "Is 'Transpiration' measured with a 'Potometer' or 'Photometer'?"
    },
    {
      yr: 2018,
      q: "The vector for the parasite that causes Sleeping Sickness is the:",
      o: ["Mosquito", "Housefly", "Tsetse fly", "Black fly"],
      a: 2,
      e: "The tsetse fly transmits the Trypanosoma parasite through its bite.",
      full: "The disease, also called African Trypanosomiasis, affects both humans and livestock. It is restricted to sub-Saharan Africa where the tsetse fly is found.",
      h: "Is the 'Sleeping Sickness' fly the 'Mosquito' or 'Tsetse fly'?"
    },
    {
      yr: 2018,
      q: "The breakdown of fats into small droplets by bile is called:",
      o: ["Digestion", "Absorption", "Emulsification", "Assimilation"],
      a: 2,
      e: "Emulsification increases the surface area of fats for enzymes to work on.",
      full: "Bile (produced by the liver) acts like a detergent, breaking large fat globules into tiny droplets. This allows the enzyme Lipase to digest the fats much faster.",
      h: "Is 'Fat Breaking' called 'Absorption' or 'Emulsification'?"
    },
    {
      yr: 2018,
      q: "The movement of a whole organism from one place to another is:",
      o: ["Tropism", "Taxis", "Nastic movement", "Growth"],
      a: 1,
      e: "Taxis is a directional movement of a whole cell or organism in response to a stimulus.",
      full: "Unlike Tropism (where only a part of a fixed plant moves/grows), Taxis involves the entire body moving, such as a sperm cell swimming toward a chemical (Chemotaxis).",
      h: "Is 'Whole Body Movement' called 'Tropism' or 'Taxis'?"
    },
    {
      yr: 2018,
      q: "Which of the following is a function of the large intestine in mammals?",
      o: ["Digestion of proteins", "Absorption of water", "Production of bile", "Absorption of amino acids"],
      a: 1,
      e: "The colon reabsorbs water from undigested food materials before they are excreted.",
      full: "While the small intestine handles most digestion and nutrient absorption, the large intestine ensures the body doesn't lose too much water during the waste removal process.",
      h: "Does the 'Large Intestine' digest 'Meat' or absorb 'Water'?"
    },
    {
      yr: 2018,
      q: "The structure in the mammalian ear that is responsible for balance is the:",
      o: ["Cochlea", "Semicircular canals", "Ossicles", "Eardrum"],
      a: 1,
      e: "Semicircular canals contain fluid that moves when the head moves, signaling the brain about position.",
      full: "While the Cochlea is for hearing, the three Semicircular Canals are oriented in different planes to detect rotational movement and maintain equilibrium.",
      h: "Are 'Balance Organs' the 'Cochlea' or 'Semicircular Canals'?"
    },
    {
      yr: 2018,
      q: "The part of the flower that receives pollen grains during pollination is the:",
      o: ["Stigma", "Style", "Anther", "Ovary"],
      a: 0,
      e: "The stigma is the sticky or feathery tip of the carpel designed to catch pollen.",
      full: "Once the pollen lands on the stigma, it germinates and grows a pollen tube down through the style to reach the ovules in the ovary.",
      h: "Is the 'Pollen Receiver' the 'Anther' or 'Stigma'?"
    },
    {
      yr: 2018,
      q: "Which of the following is an example of an endoparasite?",
      o: ["Tick", "Louse", "Tapeworm", "Flea"],
      a: 2,
      e: "Endoparasites live 'inside' the host's body.",
      full: "Tapeworms live in the human gut. Ticks, lice, and fleas are ectoparasites because they live on the 'outside' (skin) of the host.",
      h: "Does a 'Tapeworm' live 'Inside' or 'Outside'?"
    },
    {
      yr: 2018,
      q: "The process of gaseous exchange in an insect occurs through the:",
      o: ["Lungs", "Gills", "Spiracles and Tracheae", "Skin"],
      a: 2,
      e: "Insects have a network of tubes called tracheae that open to the outside via spiracles.",
      full: "Air enters through the spiracles (holes in the abdomen) and travels directly to the tissues through the tracheal system, bypassing the blood entirely.",
      h: "Do insects use 'Lungs' or 'Spiracles'?"
    },
    {
      yr: 2018,
      q: "The type of fruit formed from a group of independent flowers on a single stalk is a:",
      o: ["Simple fruit", "Aggregate fruit", "Multiple fruit", "Dry fruit"],
      a: 2,
      e: "Multiple fruits (e.g., Pineapple) develop from an entire inflorescence (group of flowers).",
      full: "A Simple fruit comes from one ovary. An Aggregate fruit comes from many ovaries in one flower. A Multiple fruit comes from many flowers joined together.",
      h: "Is a 'Pineapple' a 'Multiple' or 'Simple' fruit?"
    },
    {
      yr: 2018,
      q: "The enzyme that digests proteins in the stomach is:",
      o: ["Amylase", "Pepsin", "Lipase", "Ptyalin"],
      a: 1,
      e: "Pepsin breaks down proteins into smaller peptides in an acidic environment.",
      full: "Pepsin is highly efficient in the low pH of the stomach. Amylase is for starch, and Lipase is for fats.",
      h: "Is 'Pepsin' or 'Amylase' for 'Protein'?"
    },
    {
      yr: 2018,
      q: "Which of the following is a function of the hormone Estrogen?",
      o: ["Development of male features", "Maintenance of pregnancy", "Development of female secondary sex characteristics", "Regulation of blood sugar"],
      a: 2,
      e: "Estrogen is responsible for female traits like breast development and the menstrual cycle.",
      full: "Estrogen also helps regulate the growth of the uterine lining during the first half of the cycle. Testosterone does the equivalent for males.",
      h: "Is 'Estrogen' for 'Female Traits' or 'Blood Sugar'?"
    },
    {
      yr: 2018,
      q: "The part of the eye that contains light-sensitive cells is the:",
      o: ["Sclera", "Iris", "Retina", "Cornea"],
      a: 2,
      e: "The retina contains rods (for dim light) and cones (for color and detail).",
      full: "The retina is like the film in a camera; it captures the image and sends the information to the brain via the optic nerve.",
      h: "Is the 'Light-Sensitive' layer the 'Iris' or 'Retina'?"
    },
    {
      yr: 2018,
      q: "The process by which liquid water is lost from the leaves in droplets is:",
      o: ["Transpiration", "Guttation", "Evaporation", "Exhalation"],
      a: 1,
      e: "Guttation occurs through special pores called hydathodes at the leaf margins.",
      full: "This usually happens at night when the air is humid and soil moisture is high. Transpiration is the loss of water as vapor.",
      h: "Is 'Liquid Loss' called 'Transpiration' or 'Guttation'?"
    },
    {
      yr: 2018,
      q: "Which of the following is a symptom of iron deficiency in humans?",
      o: ["Rickets", "Anaemia", "Goitre", "Scurvy"],
      a: 1,
      e: "Iron is needed to make haemoglobin; its lack reduces the blood's oxygen-carrying capacity.",
      full: "Anaemia results in tiredness and pale skin because the body isn't getting enough oxygen to its cells. Scurvy is Vitamin C deficiency.",
      h: "Does 'Iron' lack cause 'Scurvy' or 'Anaemia'?"
    },
    {
      yr: 2018,
      q: "The theory that suggest that new species evolve through the use and disuse of parts is:",
      o: ["Darwinism", "Mendelism", "Lamarckism", "Spontaneous generation"],
      a: 2,
      e: "Lamarckism proposed that traits acquired through use are passed to offspring.",
      full: "Lamarck believed that if an animal used an organ frequently, it would grow larger and be inherited. This was later disproven by the discovery of genetics.",
      h: "Was 'Use and Disuse' proposed by 'Darwin' or 'Lamarck'?"
    },
    {
      yr: 2018,
      q: "The association between nitrogen-fixing bacteria and legumes is:",
      o: ["Parasitism", "Commensalism", "Mutualism", "Saprophytism"],
      a: 2,
      e: "Both benefit: the bacteria get sugar, and the plant gets nitrates for growth.",
      full: "This is a symbiotic relationship. The bacteria live in root nodules and 'fix' atmospheric nitrogen into a form the plant can use.",
      h: "Is 'Both Benefit' called 'Mutualism' or 'Parasitism'?"
    },
    {
      yr: 2018,
      q: "Which of the following is an example of an excretory organ in insects?",
      o: ["Kidney", "Flame cell", "Malpighian tubule", "Nephridium"],
      a: 2,
      e: "Malpighian tubules remove metabolic waste from the insect's hemolymph.",
      full: "Kidneys are for mammals, flame cells are for flatworms, and nephridia are for earthworms. Malpighian tubules empty into the gut of insects.",
      h: "Do insects use 'Kidneys' or 'Malpighian tubules'?"
    },
    {
      yr: 2018,
      q: "The change in population of a species over time due to natural selection is:",
      o: ["Growth", "Evolution", "Reproduction", "Classification"],
      a: 1,
      e: "Evolution is the gradual change in the genetic makeup of a population over generations.",
      full: "Natural selection acts as the 'filter' that decides which traits are passed on, leading to the overall evolution of the species.",
      h: "Is 'Gradual Change' called 'Growth' or 'Evolution'?"
    },
    {
      yr: 2018,
      q: "Which of the following is a major cause of deforestation?",
      o: ["Afforestation", "Agriculture", "Crop rotation", "Terracing"],
      a: 1,
      e: "Clearing land for farming is a leading cause of forest loss worldwide.",
      full: "Agriculture, logging, and urban expansion are the primary drivers that reduce forest cover, leading to habitat loss and climate change.",
      h: "Does 'Agriculture' or 'Afforestation' destroy forests?"
    },
    {
      yr: 2018,
      q: "The site of photosynthesis in a green plant cell is the:",
      o: ["Vacuole", "Mitochondrion", "Chloroplast", "Nucleus"],
      a: 2,
      e: "Chloroplasts contain chlorophyll, which traps sunlight for sugar production.",
      full: "Chloroplasts are mostly found in the palisade mesophyll cells of leaves, which are positioned to catch the most sunlight.",
      h: "Is 'Food Making' in the 'Mitochondrion' or 'Chloroplast'?"
    },
    {
      yr: 2018,
      q: "The type of skeleton found in insects is the:",
      o: ["Endoskeleton", "Exoskeleton", "Hydrostatic skeleton", "Bony skeleton"],
      a: 1,
      e: "Insects have a hard outer shell made of chitin that protects their soft bodies.",
      full: "This exoskeleton must be shed and regrown (molting) as the insect grows, because the shell itself cannot expand.",
      h: "Is a 'Hard Outer Shell' an 'Endo-' or 'Exoskeleton'?"
    },
    {
      yr: 2018,
      q: "The blood group known as the 'universal recipient' is:",
      o: ["Group A", "Group B", "Group AB", "Group O"],
      a: 2,
      e: "Group AB can receive any blood type because it has no anti-A or anti-B antibodies.",
      full: "Because they don't produce antibodies against A or B, their blood won't attack donor cells. In contrast, Group O is the universal donor.",
      h: "Is 'AB' or 'O' the 'Recipient'?"
    },



    {
      yr: 2023,
      q: "A structure in the cell that contains hereditary information (DNA) is the:",
      o: ["Cytoplasm", "Nucleus", "Vacuole", "Centriole"],
      a: 1,
      e: "The nucleus houses the chromosomes, which are made of DNA.",
      full: "The nucleus is the 'Control Center' of the cell. It coordinates cell activities like growth, metabolism, and reproduction by regulating gene expression.",
      h: "Is the 'Brain' of the cell the 'Nucleus' or the 'Vacuole'?"
    },
    {
      yr: 2023,
      q: "The condition in which the focus of light falls behind the retina is known as:",
      o: ["Myopia", "Hypermetropia", "Astigmatism", "Presbyopia"],
      a: 1,
      e: "Hypermetropia (long-sightedness) occurs when the eyeball is too short or the lens is too thin.",
      full: "In Hypermetropia, a person can see distant objects clearly but close objects appear blurred. It is corrected using a 'Converging' or 'Convex' lens to bring the focus forward onto the retina.",
      h: "Is 'Short-sightedness' or 'Long-sightedness' (Hypermetropia) the one where light falls 'Behind'?"
    },
    {
      yr: 2023,
      q: "The process by which an organism maintains a constant internal environment is:",
      o: ["Excretion", "Homeostasis", "Osmoregulation", "Metabolism"],
      a: 1,
      e: "Homeostasis is the 'Balance' of the body's internal conditions like temperature and pH.",
      full: "Even if the weather is freezing or boiling, your body tries to keep its internal temperature at 37°C. Homeostasis involves negative feedback loops to correct any deviations from the 'Set Point'.",
      h: "Is 'Internal Balance' called 'Metabolism' or 'Homeostasis'?"
    },
    {
      yr: 2023,
      q: "Which of the following is a function of the Liver?",
      o: ["Production of insulin", "Storage of iron and vitamins", "Filtration of urea", "Production of digestive enzymes"],
      a: 1,
      e: "The liver stores minerals like iron and fat-soluble vitamins (A, D, E, K).",
      full: "The liver is a 'Chemical Factory.' It also produces bile, detoxifies the blood, and converts excess glucose into glycogen for storage. Note: Insulin is made by the Pancreas, not the Liver.",
      h: "Does the liver 'Store Vitamins' or 'Produce Insulin'?"
    },
    {
      yr: 2023,
      q: "In an ecosystem, the organisms that break down dead organic matter are:",
      o: ["Producers", "Primary Consumers", "Decomposers", "Secondary Consumers"],
      a: 2,
      e: "Decomposers (like bacteria and fungi) recycle nutrients back into the soil.",
      full: "Without decomposers, the earth would be covered in dead bodies. They break down complex organic molecules into simple inorganic ones that plants (Producers) can use again.",
      h: "Are they 'Hunters' or 'Recyclers'?"
    },
    {
      yr: 2023,
      q: "The mammalian heart has four chambers to prevent the:",
      o: ["Clotting of blood", "Mixing of oxygenated and deoxygenated blood", "Backflow of blood", "High pressure of blood"],
      a: 1,
      e: "The left side handles oxygen-rich blood, while the right side handles oxygen-poor blood.",
      full: "By separating the two types of blood, mammals achieve a highly efficient supply of oxygen to the tissues. This supports their high metabolic rate and warm-blooded (endothermic) nature.",
      h: "Does the four-chambered heart 'Mix' or 'Separate' the blood?"
    },
    {
      yr: 2023,
      q: "Which of the following parts of the eye is sensitive to light?",
      o: ["Choroid", "Sclera", "Retina", "Cornea"],
      a: 2,
      e: "The retina contains photoreceptor cells called rods and cones.",
      full: "The retina acts like the 'Film' in a camera. Rods are sensitive to low light (night vision), while Cones are sensitive to color and bright light.",
      h: "Is the 'Screen' of the eye the 'Cornea' or the 'Retina'?"
    },
    {
      yr: 2023,
      q: "A group of similar cells performing a specific function is a/an:",
      o: ["Organ", "System", "Tissue", "Organelle"],
      a: 2,
      e: "Cells group together to form tissues, and tissues group to form organs.",
      full: "Examples include Muscle tissue, Nervous tissue, and Epithelial tissue. The hierarchy of life goes: Cell -> Tissue -> Organ -> System -> Organism.",
      h: "Is it a 'Tissue' or an 'Organ'?"
    },
    {
      yr: 2023,
      q: "The hormone that causes the 'fight or flight' response is:",
      o: ["Insulin", "Adrenaline", "Estrogen", "Progesterone"],
      a: 1,
      e: "Adrenaline (epinephrine) increases heart rate and blood flow during emergencies.",
      full: "Produced by the Adrenal glands, it prepares the body for sudden action by increasing sugar in the blood and dilating the pupils. It is the 'Emergency Hormone'.",
      h: "Is it 'Adrenaline' or 'Insulin'?"
    },
    {
      yr: 2023,
      q: "Which of the following is a non-renewable resource?",
      o: ["Water", "Forest", "Petroleum", "Wildlife"],
      a: 2,
      e: "Petroleum takes millions of years to form and cannot be replaced once used.",
      full: "Renewable resources (like sun, water, and trees) can be replenished naturally. Non-renewable resources like coal, oil, and minerals are finite and will eventually run out.",
      h: "Can 'Oil' be replaced as fast as 'Trees'?"
    },
    {
      yr: 2023,
      q: "The blood vessel that carries deoxygenated blood from the heart to the lungs is the:",
      o: ["Aorta", "Pulmonary artery", "Pulmonary vein", "Vena cava"],
      a: 1,
      e: "The pulmonary artery is the ONLY artery that carries deoxygenated blood.",
      full: "Arteries usually carry oxygenated blood *away* from the heart. The exception is the Pulmonary Artery, which goes to the lungs to pick up oxygen. The Pulmonary Vein then brings oxygenated blood *back* to the heart.",
      h: "Is it the 'Aorta' or the 'Pulmonary Artery'?"
    },
    {
      yr: 2023,
      q: "Which of the following is a social insect?",
      o: ["Housefly", "Mosquito", "Termite", "Butterfly"],
      a: 2,
      e: "Termites live in organized colonies with a division of labor (King, Queen, Soldiers, Workers).",
      full: "Social insects (like honeybees, ants, and termites) cannot survive alone. They work together for the survival of the colony, often with different body shapes (castes) for different jobs.",
      h: "Do 'Mosquitoes' live in a 'Kingdom' or do 'Termites'?"
    },
    {
      yr: 2023,
      q: "The process by which a tadpole develops into a frog is:",
      o: ["Growth", "Metamorphosis", "Fertilization", "Pollination"],
      a: 1,
      e: "Metamorphosis is a biological process involving a conspicuous change in body structure.",
      full: "Frogs undergo 'Complete Metamorphosis' where they change from a water-breathing larva with a tail (tadpole) to an air-breathing adult with legs and no tail.",
      h: "Is this 'Simple Growth' or 'Metamorphosis'?"
    },
    {
      yr: 2023,
      q: "The vitamin that helps in the absorption of calcium for strong bones is:",
      o: ["Vitamin A", "Vitamin C", "Vitamin D", "Vitamin E"],
      a: 2,
      e: "Vitamin D is essential for bone mineralization and prevents Rickets.",
      full: "Vitamin D is often called the 'Sunshine Vitamin' because the skin produces it when exposed to ultraviolet rays. Without it, the body cannot absorb calcium from the diet.",
      h: "Is Vitamin D for 'Bones' or for 'Eyes'?"
    },
    {
      yr: 2023,
      q: "A symbiotic relationship where both organisms benefit is:",
      o: ["Parasitism", "Commensalism", "Mutualism", "Competition"],
      a: 2,
      e: "Mutualism is a 'win-win' relationship (e.g., nitrogen-fixing bacteria in root nodules).",
      full: "In Commensalism, one benefits while the other is unaffected. In Parasitism, one benefits while the other is harmed. In Mutualism, both are happy!",
      h: "Does 'Both Benefit' mean 'Mutualism' or 'Parasitism'?"
    },
    {
      yr: 2023,
      q: "The male gamete in flowering plants is produced in the:",
      o: ["Filament", "Pollen grain", "Stigma", "Ovary"],
      a: 1,
      e: "Pollen grains are produced in the anther and contain the male nuclei.",
      full: "The anther produces the pollen (the vehicle), but the actual male gametes are the nuclei found inside the pollen grain that travel down the pollen tube.",
      h: "Is the male part 'Pollen' or 'Ovary'?"
    },
    {
      yr: 2023,
      q: "The deficiency of iron in the diet causes:",
      o: ["Goitre", "Scurvy", "Anaemia", "Pellagra"],
      a: 2,
      e: "Iron is needed to make haemoglobin, which carries oxygen in the blood.",
      full: "Anaemia results in tiredness and pale skin because the body's cells aren't getting enough oxygen. Goitre is caused by Iodine deficiency, and Scurvy by Vitamin C deficiency.",
      h: "Is Iron for 'Blood' (Anaemia) or for 'Neck' (Goitre)?"
    },
    {
      yr: 2023,
      q: "Which of the following is a simple reflex action?",
      o: ["Riding a bicycle", "Blinking of the eye", "Writing a letter", "Solving a math problem"],
      a: 1,
      e: "A reflex action is an involuntary, rapid response to a stimulus.",
      full: "Reflexes like blinking, coughing, or pulling your hand away from a hot stove do not involve the 'thinking' part of the brain. They are handled by the spinal cord to save time and prevent injury.",
      h: "Is 'Blinking' or 'Math' a fast, automatic response?"
    },
    {
      yr: 2023,
      q: "The theory of Natural Selection was proposed by:",
      o: ["Gregor Mendel", "Charles Darwin", "Robert Hooke", "Louis Pasteur"],
      a: 1,
      e: "Darwin published 'On the Origin of Species' in 1859, explaining evolution.",
      full: "Natural Selection suggests that organisms with traits better suited to their environment are more likely to survive and reproduce. This is often summarized as 'Survival of the Fittest'.",
      h: "Was the 'Selection' theory by 'Mendel' or 'Darwin'?"
    },

  
    {
    yr: 2022,
    q: 'Sources of air pollutants are ___',
    o: [
      'Industrial chimneys, burning fossil oils and river dams',
      'Sulphur dioxide, acid rain and pesticides',
      'Sulphur dioxide, vehicle exhausts, and aerosols',
      'Sewage, smoke and old vehicles',
    ],
    a: 2,
    e: 'Sulphur dioxide (from industries/burning fossil fuels), vehicle exhausts, and aerosols (sprays) are all direct sources of air pollutants. The others mix causes with effects or unrelated items.',
    full: 'Air pollution sources:\n\n• Sulphur dioxide (SO₂): from burning coal, oil, and industrial processes ✓\n• Vehicle exhausts: release CO, NOₓ, particulate matter, hydrocarbons ✓\n• Aerosols: spray cans release CFCs and other chemicals ✓\n\nWhy other options are wrong:\n• A: river dams are NOT air pollution sources\n• B: acid rain and pesticides are effects/consequences of pollution, not sources\n• D: sewage is water pollution, not air pollution\n\nMajor air pollutants include: CO, SO₂, NOₓ, particulate matter, CFCs, ozone (low-level), hydrocarbons.',
    h: 'Which option lists actual SOURCES of air pollution (not effects or water pollutants)?',
  },
  {
    yr: 2022,
    q: 'The body of a snail is divided into head, ___ and ___.',
    o: ['Thorax and abdomen', 'Visceral mass and abdomen', 'Thorax and foot', 'Visceral mass and foot'],
    a: 3,
    e: 'A snail\'s body has three main regions: head, visceral mass (containing internal organs), and foot (muscular locomotion organ).',
    full: 'Snail body plan (Class Gastropoda, Phylum Mollusca):\n\n• Head: bears eyes, tentacles (sensory), and mouth\n• Visceral mass (visceral hump): contains organs — digestive, reproductive, excretory — enclosed in the shell\n• Foot: flat, muscular structure used for locomotion via wave-like contractions\n\nSnails are NOT arthropods — they don\'t have thorax or abdomen (those are arthropod/insect terms).\n\nMemory tip: Snail = Head + Visceral Mass + Foot (HVF)',
    h: 'Snails are molluscs, not insects. Which two body regions follow the head in a snail?',
  },
  {
    yr: 2022,
    q: 'An adaptation for defence in animals is ___',
    o: [
      'Croaking of a male toad',
      'Basking in lizard',
      'Spines in porcupine fish',
      'Huddling together of penguins',
    ],
    a: 2,
    e: 'Spines in the porcupine fish are a structural defence adaptation — they deter predators by making the fish difficult to swallow, especially when it inflates.',
    full: 'Types of adaptations:\n\n• Croaking of male toad (A): reproductive adaptation — attracts mates\n• Basking in lizard (B): thermoregulatory adaptation — warms body using sunlight (ectotherm)\n• Spines in porcupine fish (C): DEFENCE adaptation ✓ — physical deterrent to predators; fish also inflates body with water to make spines protrude outward\n• Huddling of penguins (D): thermoregulatory/social adaptation — conserves heat in cold environments\n\nDefence adaptations include: camouflage, warning colours (aposematism), spines, shells, toxins, mimicry, speed.',
    h: 'Which adaptation directly protects the animal from predators rather than helping reproduction or temperature regulation?',
  },
  {
    yr: 2022,
    q: 'The movement of Euglena towards the source of light is a ___',
    o: ['Tropic movement', 'Tactic movement', 'Nastic movement', 'Kinetic movement'],
    a: 1,
    e: 'Euglena is a motile organism that moves its whole body directionally towards light — this is phototaxis, a type of tactic movement. Taxis = directional movement of a whole organism in response to a stimulus.',
    full: 'Types of movement responses:\n\n• Taxis (Tactic movement): directional movement of a WHOLE MOTILE ORGANISM in response to a stimulus\n  - Phototaxis: movement towards/away from light ✓ (Euglena moving towards light = positive phototaxis)\n  - Chemotaxis: response to chemicals\n\n• Tropism (Tropic movement): directional growth response in PLANTS (not whole organism movement)\n  - Phototropism: plant shoot grows towards light\n\n• Nastic movement: non-directional plant response (e.g., Mimosa folding leaves, flowers opening/closing)\n\n• Kinetic movement: change in SPEED or frequency of movement, not direction\n\nAnswer: B — Tactic movement (taxis)',
    h: 'Euglena is a motile organism moving toward light — taxis or tropism? (Tropism is for plants)',
  },
  {
    yr: 2022,
    q: 'During mitosis, the stage at which chromosomes line up around the equator is ___',
    o: ['Telophase', 'Metaphase', 'Anaphase', 'Prophase'],
    a: 1,
    e: 'Metaphase is when chromosomes align at the cell\'s equatorial plate (metaphase plate), each attached to spindle fibres from opposite poles.',
    full: 'Stages of mitosis (PMAT):\n\n• Prophase (P): chromosomes condense and become visible; spindle fibres form; nuclear envelope breaks down\n\n• Metaphase (M): chromosomes ALIGN at the equator (middle) of the cell — the metaphase plate ✓\n  Each chromosome is attached to spindle fibres from both poles\n\n• Anaphase (A): sister chromatids SEPARATE and are pulled to opposite poles\n\n• Telophase (T): nuclear envelopes reform; chromosomes decondense; cell begins to divide (cytokinesis)\n\nMemory: "PMAT" — at Metaphase = Middle/equator',
    h: 'Which mitosis stage has chromosomes lined up at the cell\'s middle/equator? PMAT → M = Middle.',
  },
  {
    yr: 2022,
    q: 'The waste product of insects is ___',
    o: ['Uric acid', 'Urine', 'Mucilage', 'Sweat'],
    a: 0,
    e: 'Insects excrete uric acid — a nearly insoluble, non-toxic nitrogenous waste. This conserves water, crucial for land-dwelling insects.',
    full: 'Nitrogenous waste products by organism type:\n\n• Ammonia (NH₃): aquatic animals (fish, aquatic invertebrates) — toxic but easily diluted in water\n• Urea: mammals, amphibians, cartilaginous fish — less toxic, requires some water\n• Uric acid: insects, reptiles, birds, land snails ✓ — nearly insoluble, very non-toxic, minimal water needed\n\nWhy insects use uric acid:\n• They have a waterproof cuticle\n• They cannot afford to lose water in urine\n• Uric acid can be excreted as a paste/solid with minimal water loss\n• Malpighian tubules (insect excretory organs) concentrate uric acid\n\nMucilage = plant secretion (not an excretory product)\nSweat = mammalian thermoregulation fluid',
    h: 'What nitrogenous waste do land-dwelling, water-conserving organisms like insects excrete?',
  },
  {
    yr: 2022,
    q: 'Succession that occurs on an abandoned farmland is ___',
    o: ['Tertiary', 'Secondary', 'Primary', 'Climax'],
    a: 1,
    e: 'Abandoned farmland still has soil — ecological succession starting where soil already exists is secondary succession. Primary succession starts on bare rock/sand with no soil.',
    full: 'Types of ecological succession:\n\n• Primary succession: begins on bare, lifeless substrate with NO soil\n  - Examples: newly exposed rock after glacier retreat, fresh lava flows, newly formed sand dunes\n  - Pioneer organisms: lichens, mosses\n  - Very slow process (hundreds to thousands of years)\n\n• Secondary succession: begins on previously inhabited land where soil ALREADY EXISTS\n  - Examples: abandoned farmland ✓, forest after fire, flood-damaged land, cleared land\n  - Much faster than primary (decades)\n  - Pre-existing soil seeds + nutrients accelerate recovery\n\nClimax community: the stable final stage of succession — not a type of succession itself.\n\n⚠️ EduPadi marked C (primary) — this is WRONG. Correct answer: B (secondary).',
    h: 'Abandoned farmland has existing soil — is that primary or secondary succession?',
  },
  {
    yr: 2022,
    q: 'In Nigeria, Southern Guinea Savanna is found in ___',
    o: ['Borno and Sokoto', 'Kogi and Kwara', 'Kaduna and Cross River', 'Kano and Niger'],
    a: 1,
    e: 'Southern Guinea Savanna is a transitional vegetation zone in central Nigeria. Kogi and Kwara states lie within this zone, between the forest belt in the south and the Sudan Savanna in the north.',
    full: 'Nigerian vegetation zones (north to south):\n\n1. Sahel Savanna: extreme northeast (Borno, Yobe, Jigawa)\n2. Sudan Savanna: northern Nigeria (Sokoto, Katsina, Kano, Borno)\n3. Northern Guinea Savanna: central north (Kaduna, Plateau, Bauchi, Gombe, Niger)\n4. Southern Guinea Savanna: central belt (Kogi, Kwara, FCT, Nasarawa, Benue, Taraba) ✓\n5. Derived Savanna: transition zone near forest belt\n6. Rainforest: southern Nigeria (Cross River, Edo, Delta, Rivers, Anambra, etc.)\n7. Mangrove/freshwater swamp: coastal areas\n\nKogi and Kwara = central Nigeria = Southern Guinea Savanna ✓',
    h: 'Southern Guinea Savanna is in central Nigeria. Which state pair is centrally located?',
  },
  {
    yr: 2022,
    q: 'Which of the following is associated with the dark stage of photosynthesis?',
    o: [
      'Assimilation of carbon(IV)oxide',
      'Photophosphorylation',
      'Photolysis',
      'Excitation of chlorophyll',
    ],
    a: 0,
    e: 'The dark stage (light-independent/Calvin cycle) involves CO₂ fixation and assimilation. Photophosphorylation, photolysis, and chlorophyll excitation all occur in the light-dependent stage.',
    full: 'Photosynthesis: two stages\n\nLight-dependent stage (in thylakoid membrane):\n• Excitation of chlorophyll by light\n• Photolysis: splitting of water → O₂ released\n• Photophosphorylation: ADP + Pᵢ → ATP (using light energy)\n• NADPH produced\n\nLight-independent stage / Dark stage (in stroma of chloroplast):\n• CO₂ assimilation/fixation ✓ → combined with RuBP (Calvin cycle)\n• Uses ATP and NADPH from light stage\n• Produces glucose (G3P → glucose)\n• Does NOT require direct light (but depends on products of light stage)\n\nAnswer: A — assimilation of carbon(IV)oxide (CO₂)',
    h: 'The dark stage = Calvin cycle = CO₂ fixation. Which option describes a dark-stage process?',
  },
  {
    yr: 2022,
    q: 'The part of mammalian skin that excretes metabolic wastes is ___',
    o: ['Sweat gland', 'Horny layer', 'Malpighian layer', 'Sebaceous gland'],
    a: 0,
    e: 'Sweat glands excrete urea, water, and salts as sweat — removing metabolic waste while also regulating temperature.',
    full: 'Functions of skin structures:\n\n• Sweat gland (sudoriferous gland) ✓:\n  - Excretes water, urea, NaCl, lactic acid in sweat\n  - Also regulates body temperature by evaporative cooling\n\n• Horny layer (stratum corneum):\n  - Outermost layer of epidermis\n  - Made of dead, keratinised cells\n  - Forms a waterproof protective barrier — does NOT excrete\n\n• Malpighian layer (stratum basale/germinativum):\n  - Deepest layer of epidermis\n  - Contains dividing cells that renew skin\n  - Contains melanocytes (produces melanin)\n  - Does NOT excrete metabolic waste\n\n• Sebaceous gland:\n  - Secretes sebum (oil) — lubricates hair and skin\n  - NOT an excretory organ\n\nAnswer: A — sweat gland',
    h: 'Which skin structure actively removes metabolic waste (urea, salts) from the body?',
  },

  // ── 2023 ──────────────────────────────────────────────────────────────────

  {
    yr: 2023,
    q: 'Which processes are involved in nutrient cycling in a functioning ecosystem?',
    o: [
      'Erosion, weathering, and sedimentation',
      'Decomposition, evaporation, and precipitation',
      'Nitrogen fixation, denitrification, and ammonification',
      'Respiration, photosynthesis, and transpiration',
    ],
    a: 2,
    e: 'Nitrogen fixation, denitrification, and ammonification are all steps in the nitrogen cycle — a key nutrient cycle. They directly involve transforming nitrogen compounds in soil and atmosphere.',
    full: 'The nitrogen cycle — key processes:\n\n• Nitrogen fixation: N₂ (atmospheric) → NH₃/NH₄⁺\n  - By Rhizobium bacteria (in legume root nodules)\n  - By free-living bacteria (Azotobacter, Clostridium)\n  - By lightning\n\n• Ammonification: organic nitrogen (dead organisms, waste) → NH₃/NH₄⁺\n  - By decomposers (bacteria, fungi)\n\n• Nitrification: NH₄⁺ → NO₂⁻ → NO₃⁻\n  - By Nitrosomonas, Nitrobacter bacteria\n\n• Denitrification: NO₃⁻ → N₂ (returns nitrogen to atmosphere)\n  - By Pseudomonas, Thiobacillus bacteria\n\n• Assimilation: plants absorb NO₃⁻, NH₄⁺ for protein synthesis\n\nAll three in option C are core nitrogen cycle processes ✓',
    h: 'Which set of three processes all belong specifically to the nitrogen cycle?',
  },
  {
    yr: 2023,
    q: 'Which eye defect is caused by the inability of the eye to focus light on the retina?',
    o: ['Glaucoma', 'Myopia', 'Cataracts', 'Astigmatism'],
    a: 1,
    e: 'Myopia (short-sightedness) occurs when the eyeball is too long — light from distant objects focuses in FRONT of the retina, not ON it, causing blurry distant vision.',
    full: 'Eye defects:\n\n• Myopia (short-sightedness) ✓:\n  - Eyeball too long OR cornea/lens too curved\n  - Light focuses in FRONT of retina\n  - Near objects clear, distant objects blurry\n  - Corrected with concave (diverging) lens\n\n• Hypermetropia (long-sightedness):\n  - Eyeball too short\n  - Light focuses BEHIND retina\n  - Distant objects clearer, near objects blurry\n  - Corrected with convex (converging) lens\n\n• Glaucoma: increased intraocular pressure damaging optic nerve — not a focusing defect\n\n• Cataracts: clouding of the lens — reduces light transmission\n\n• Astigmatism: irregular cornea curvature → blurred vision at all distances\n\nAnswer: B — Myopia (most direct "cannot focus on retina" due to eyeball length)',
    h: 'Which defect causes light to focus in front of the retina due to the eyeball being too long?',
  },
  {
    yr: 2023,
    q: 'Which of the following is the correct classification of carbohydrates?',
    o: ['Lipid', 'Phytonutrient', 'Macronutrient', 'Micronutrient'],
    a: 2,
    e: 'Carbohydrates are macronutrients — nutrients required in large amounts. Macronutrients include carbohydrates, proteins, and fats.',
    full: 'Nutrient classification:\n\nMacronutrients (needed in large quantities):\n• Carbohydrates ✓ (primary energy source)\n• Proteins (growth and repair)\n• Fats/Lipids (energy store, cell membranes, insulation)\n\nMicronutrients (needed in small quantities):\n• Vitamins\n• Minerals (iron, calcium, zinc, etc.)\n\nNote:\n• Lipid: carbohydrates are NOT lipids (different chemical structure)\n• Phytonutrient: plant-specific compounds (flavonoids, carotenoids) — not a standard nutritional classification\n\nAnswer: C — Macronutrient',
    h: 'Carbohydrates, proteins, and fats are all what type of nutrients — macro or micro?',
  },
  {
    yr: 2023,
    q: 'Which of the following statements about viruses is true?',
    o: [
      'Viruses can reproduce outside of a host cell',
      'Viruses require a host cell to replicate',
      'Viruses possess a cellular structure',
      'Viruses are living organisms',
    ],
    a: 1,
    e: 'Viruses are obligate intracellular parasites — they CANNOT replicate without using the host cell\'s machinery (ribosomes, enzymes, ATP). Outside a host, they are inert particles.',
    full: 'Characteristics of viruses:\n\n• No cell structure (not cellular): they consist of nucleic acid (DNA or RNA) + protein coat (capsid) ± envelope\n• Not considered living organisms by most definitions: they lack metabolism, cannot grow, cannot reproduce independently\n• Obligate intracellular parasites ✓: must infect a host cell and hijack its replication machinery\n• Outside a host: viruses are inert — they cannot feed, respire, or reproduce\n• Reproduction: virus injects DNA/RNA into host cell → host replicates viral genome → new virions assembled and released (lysis or budding)\n\nTherefore:\n• A: FALSE — cannot replicate outside host\n• B: TRUE ✓ — require host cell\n• C: FALSE — no cell structure (no nucleus, no organelles)\n• D: Debatable — most biologists say viruses are NOT living (no metabolism, not cellular)',
    h: 'Viruses have no ribosomes or metabolism — they can only replicate WHERE?',
  },
  {
    yr: 2023,
    q: 'What is the definition of population ecology?',
    o: [
      'The study of interactions between organisms and their physical environment',
      'The study of evolutionary processes and their effects on populations',
      'The study of interactions between different populations in an ecosystem',
      'The study of the distribution and abundance of individuals within a species',
    ],
    a: 3,
    e: 'Population ecology is the branch of ecology studying the size, structure, distribution, and dynamics of populations of a single species over time and space.',
    full: 'Branches of ecology:\n\n• Autecology: study of individual organisms and their environment\n\n• Population ecology ✓: study of the distribution and abundance of individuals of a SINGLE SPECIES\n  - Includes: population size (N), density, birth rate, death rate, age structure, immigration, emigration\n  - Population dynamics (how and why populations change)\n\n• Community ecology: study of interactions between DIFFERENT SPECIES/POPULATIONS in a community (option C describes this)\n\n• Ecosystem ecology: study of how organisms interact with their physical environment (option A describes this)\n\n• Evolutionary ecology: study of evolutionary processes (option B describes this)\n\nAnswer: D — distribution and abundance of individuals within a species',
    h: 'Population ecology focuses on one SPECIES — its numbers, distribution, and changes over time.',
  },
  {
    yr: 2023,
    q: 'Which represents the correct hierarchical organisation of life from smallest to largest scale?',
    o: [
      'Organs, tissues, cells, organisms, populations, communities, ecosystems',
      'Cells, organs, tissues, organisms, populations, communities, ecosystems',
      'Tissues, organs, cells, organisms, populations, communities, ecosystems',
      'Cells, tissues, organs, organisms, populations, communities, ecosystems',
    ],
    a: 3,
    e: 'Correct order (smallest to largest): Cells → Tissues → Organs → Organisms → Populations → Communities → Ecosystems.',
    full: 'Levels of biological organisation (smallest to largest):\n\n1. Atoms/Molecules\n2. Organelles\n3. **Cells** ← smallest life unit\n4. **Tissues** ← groups of similar cells\n5. **Organs** ← groups of tissues with a common function\n6. Organ systems\n7. **Organisms** ← complete individual\n8. **Populations** ← all individuals of one species in an area\n9. **Communities** ← all populations in an area\n10. **Ecosystems** ← community + physical environment\n11. Biosphere\n\nThe JAMB answer: Cells → Tissues → Organs → Organisms → Populations → Communities → Ecosystems ✓\n\nCommon mistake: confusing the order of cells, tissues, and organs.',
    h: 'Remember: Cells → Tissues → Organs → Organisms → Populations → Communities → Ecosystems.',
  },
  {
    yr: 2023,
    q: 'Which soil type becomes less fertile due to intense leaching by tropical rains?',
    o: ['Yellow soil', 'Laterite soil', 'Red soils', 'Black soil'],
    a: 1,
    e: 'Laterite soil (common in tropical West Africa) loses fertility through intense leaching — heavy rains wash nutrients downward, leaving iron/aluminium oxides that harden the soil.',
    full: 'Laterite soil:\n• Typical of humid tropical regions (West Africa, including Nigeria)\n• Heavy tropical rains cause intense leaching\n• Soluble nutrients (calcium, magnesium, potassium, nitrogen) are washed away\n• Iron and aluminium oxides accumulate → characteristic red/orange colour\n• Can harden into rock-like material (laterite/ironpan) when exposed to sun\n• Results in poor, infertile soil\n\nContrast:\n• Black soil (vertisol): rich in clay, high organic matter, fertile — found in drier savanna regions\n• Red soils: also common in tropics but broader term; may include laterites\n• Yellow soil: not a primary JAMB classification\n\nAnswer: B — Laterite soil',
    h: 'Which tropical soil type loses fertility as rain washes away nutrients, leaving iron oxides behind?',
  },
  {
    yr: 2023,
    q: 'Which of the following factors primarily affects the distribution of organisms in an ecosystem?',
    o: ['Wind speed', 'Soil pH', 'Temperature', 'Day length'],
    a: 2,
    e: 'Temperature is the primary abiotic factor controlling the distribution of organisms — each species has a specific temperature tolerance range (optimum, minimum, maximum). It affects metabolic rates, behaviour, and survival.',
    full: 'Abiotic factors affecting organism distribution:\n\n• Temperature ✓: primary factor\n  - Controls enzyme activity, metabolic rate\n  - Defines thermal tolerance zones for all organisms\n  - Explains global biome distribution (tropical → temperate → polar)\n  - Affects breeding cycles, dormancy, migration\n\n• Soil pH: important for plants and soil organisms but secondary to temperature globally\n\n• Day length (photoperiod): affects flowering, breeding, migration — seasonal but not primary distribution factor\n\n• Wind speed: modifies temperature/moisture effects but not primary\n\nTemperature is considered the single most important abiotic factor for organism distribution.',
    h: 'Which single abiotic factor most broadly determines where organisms can live across the globe?',
  },
  {
    yr: 2023,
    q: 'Which of the following statements is true regarding cell growth?',
    o: [
      'Cell growth is solely influenced by external factors',
      'Cell growth is a continuous process throughout the life of a cell',
      'Cell growth involves an increase in the number of organelles within a cell',
      'Cell growth occurs by cell division',
    ],
    a: 3,
    e: 'Cell growth involves an increase in cell size and mass, which is ultimately completed by cell division — producing two daughter cells from one parent cell.',
    full: 'Cell growth and division:\n\n• Cell growth = increase in cell size, mass, and complexity\n• Growth prepares the cell for division\n• Growth occurs during interphase (G1 and G2 phases)\n• Cell division (mitosis/meiosis) is the culmination of cell growth — cell divides into daughter cells\n\nAnalysis of options:\n• A: "solely influenced by external factors" — FALSE; both internal (genes, hormones) and external factors affect growth\n• B: "continuous throughout life" — FALSE; growth occurs in phases (G1, S, G2) and stops when cell prepares for division\n• C: "increase in number of organelles" — partially true but incomplete description of growth\n• D: "occurs by cell division" ✓ — the JAMB-accepted answer; cell growth leads to and results in cell division\n\nAnswer: D',
    h: 'What process ultimately completes cell growth, producing two daughter cells from one?',
  },
    
  {
    yr: 2024,
    q: 'Which organ removes the largest quantity of water from the blood?',
    o: ['Lung', 'Skin', 'Kidney', 'Intestine'],
    a: 2,
    e: 'The kidneys filter approximately 180 litres of blood daily and reabsorb most of the water, excreting only about 1–2 litres as urine. This is the largest volume of water removed from blood by any single organ.',
    full: 'The kidneys are the primary regulators of water balance (osmoregulation) in the body. They filter blood continuously through millions of nephrons, reabsorbing most of the water and only allowing excess to leave as urine.\n\nWhile the lungs lose water through breathing (~400 mL/day) and skin loses water through sweat, these amounts are far smaller than what the kidneys process.\n\nThe intestine absorbs water from food — it does not remove water FROM the blood in the same regulatory sense.\n\nAnswer: Kidney (C) — the dominant organ for water removal from blood.',
    h: 'Which organ filters blood and controls water balance through urine production?',
  },

  {
    yr: 2024,
    q: 'The organisms that adopt swarming as an adaptation to overcome overcrowding are ______.',
    o: ['Agama lizard', 'Tilapia', 'Rats', 'Termites'],
    a: 3,
    e: 'When a termite colony becomes overcrowded, winged reproductive termites (alates) are produced. These alates swarm out of the colony, mate, and establish new colonies elsewhere — a direct response to overcrowding.',
    full: 'Swarming is a specific population dispersal strategy observed in social insects, particularly termites (and also bees and ants).\n\nIn termites:\n• When the colony grows too large and resources become limited, the queen produces winged reproductive individuals called alates.\n• These alates swarm in large numbers, typically triggered by temperature or rain.\n• They fly out, mate, shed their wings, and the fertilised queen starts a new colony.\n\nThis swarming behaviour is specifically an adaptation to overcome overcrowding — dispersing the population to new locations.\n\n• Agama lizards show territorial behaviour (not swarming).\n• Tilapia and rats disperse individually or in small groups, not through organised swarming.',
    h: 'Which social insect produces winged alates that swarm when the colony is overcrowded?',
  },

  {
    yr: 2024,
    q: 'Bryophyte is an intermediate group between higher algae and ______.',
    o: ['Thallophyte', 'Pteridophyte', 'Spermatophyte', 'Tracheophyte'],
    a: 1,
    e: 'Bryophytes (mosses, liverworts, hornworts) are transitional between aquatic algae and vascular land plants. Pteridophytes (ferns) are the next group — the first true vascular plants.',
    full: 'Plant kingdom evolution in order:\n1. Algae (aquatic, no true leaves/stems/roots)\n2. Bryophyta — mosses, liverworts (first land plants; no vascular tissue, need water for reproduction)\n3. Pteridophyta — ferns (first vascular plants; no seeds)\n4. Spermatophyta — seed plants (gymnosperms + angiosperms)\n\nBryophytes sit between higher algae and pteridophytes:\n• Like algae: no vascular tissue, need water for fertilisation\n• Unlike algae: adapted to land, have leaf-like and stem-like structures\n• Unlike pteridophytes: no xylem/phloem\n\n"Tracheophyte" is a broader term encompassing pteridophytes and spermatophytes (all vascular plants). The more specific intermediate step is pteridophyta.',
    h: 'In plant evolution, what group comes just after bryophytes — the first vascular plants?',
  },

  {
    yr: 2024,
    q: 'One main feature of trees in the savanna habitat is the possession of ______.',
    o: [
      'Large, leathery leaves',
      'Straight slender stems with branches near the top',
      'Thin, smooth barks',
      'Thick, corky bark',
    ],
    a: 3,
    e: 'Savanna trees have thick, corky bark as an adaptation against frequent bush fires and to reduce water loss during the long dry season.',
    full: 'Savanna is characterised by seasonal rainfall, a prolonged dry season, and frequent fires. Trees are adapted as follows:\n\n✓ Thick, corky bark:\n• Protects against fire damage\n• Reduces water loss through the bark\n• Insulates the living tissue inside from heat\n\n✗ Large, leathery leaves: Rainforest adaptation (to capture light in shade).\n✗ Straight slender stems with branches near top: Adaptation for competing for light in dense forests.\n✗ Thin, smooth bark: Found in humid environments — offers NO fire protection.\n\nOther savanna tree adaptations: deep tap roots, drought-deciduous (shedding leaves in dry season), water storage in trunk (e.g., baobab).',
    h: 'What bark feature protects savanna trees from fire and water loss?',
  },

  {
    yr: 2024,
    q: 'Which of the following structures enables the exchange of gases in insects?',
    o: ['Skin', 'Tracheae', 'Malpighian tubules', 'Flame cell'],
    a: 1,
    e: 'Insects breathe through a tracheal system — a network of air-filled tubes (tracheae) that carry oxygen directly to tissues. Air enters through openings called spiracles.',
    full: 'Insects do not use lungs or gills. Instead they have a unique respiratory system:\n\n• Tracheae: Branching tubes that carry air directly to every cell in the body. Oxygen diffuses directly into tissues without needing blood as an intermediary.\n• Spiracles: Small openings on the body surface where air enters the tracheal system.\n• Tracheoles: The finest branches of the tracheae, in direct contact with cells.\n\nOther options:\n• Skin: Some gas exchange occurs through the skin in soft-bodied insects, but it is not the PRIMARY system.\n• Malpighian tubules: Excretory organs (like kidneys) — remove nitrogenous waste.\n• Flame cells: Excretory/osmoregulatory structures found in flatworms — NOT in insects.',
    h: 'What air-tube system carries oxygen directly to insect tissues?',
  },

  {
    yr: 2024,
    q: 'A community of 2,310,000 people lives in an area of 2,310 km². What is the population density?',
    o: ['10000', '10', '100', '1000'],
    a: 3,
    e: 'Population density = Population ÷ Area = 2,310,000 ÷ 2,310 = 1,000 people/km².',
    full: 'Population density is calculated as:\n\nPopulation density = Number of individuals ÷ Area\n\n= 2,310,000 ÷ 2,310\n= 1,000 people per km²\n\nThis is a straightforward calculation. Population density tells us how crowded a given area is — useful for studying competition, resource availability, and ecological pressure in biology.',
    h: 'Population density = population ÷ area. Calculate: 2,310,000 ÷ 2,310 = ?',
  },

  {
    yr: 2024,
    q: 'Similar structures that are modified to work in different ways in different organisms are referred to as ______.',
    o: ['Homologous structures', 'Analogous structures', 'Divergent structures', 'Convergent structures'],
    a: 0,
    e: 'Homologous structures share a common evolutionary origin (same ancestry) but have been modified to serve different functions in different organisms — evidence of divergent evolution.',
    full: 'Key definitions:\n\n• Homologous structures: Same embryonic origin, different function.\n  Example: Human arm, whale flipper, bat wing, dog foreleg — all share the same bone arrangement (humerus, radius, ulna, carpals) but serve different purposes.\n  → Evidence of divergent evolution from a common ancestor.\n\n• Analogous structures: Different origin, same function.\n  Example: Wings of a butterfly and wings of a bird — both used for flight but evolved independently.\n  → Evidence of convergent evolution.\n\nThe question describes structures that are "similar" (same origin) but "work differently" — this is the definition of homologous structures.',
    h: 'Same origin + different functions in different organisms = homologous or analogous?',
  },

  {
    yr: 2024,
    q: 'Which of the following plants shows hypogeal germination?',
    o: ['Castor oil', 'Groundnut', 'Maize', 'Orange'],
    a: 2,
    e: 'Maize shows hypogeal germination — the cotyledon (scutellum) stays underground while the plumule grows upward. Castor oil, groundnut, and orange show epigeal germination (cotyledons emerge above ground).',
    full: 'Two types of seed germination:\n\n1. Epigeal germination: The hypocotyl elongates, pushing the cotyledons ABOVE the soil surface.\n   Examples: Castor oil, groundnut, orange, beans, paw-paw\n\n2. Hypogeal germination: The epicotyl elongates while the cotyledon(s) remain BELOW the soil.\n   Examples: Maize, wheat, millet, peas, cocoa, coconut\n\nMemory trick:\n• Hypo = below → cotyledon stays below (underground)\n• Epi = above → cotyledon comes above\n\nMaize (a monocot) keeps its scutellum underground and only the shoot (plumule) emerges.',
    h: 'In hypogeal germination, the cotyledon stays underground. Which plant does this?',
  },

  {
    yr: 2024,
    q: 'Bilateral symmetry, cylindrical bodies and double openings (mouth and anus) are characteristic features of ______.',
    o: ['Nematodes', 'Hydra', 'Protozoa', 'Protists'],
    a: 0,
    e: 'Nematodes (roundworms) have bilateral symmetry, cylindrical/tube-shaped bodies, and a complete digestive system with both a mouth and an anus — all matching the description.',
    full: 'Match the features to the phylum:\n\n• Bilateral symmetry: Body has a distinct left and right side (mirror images) — found in nematodes, humans, insects.\n• Cylindrical bodies: Tube-shaped, worm-like — characteristic of roundworms.\n• Double openings (complete gut): Mouth AND anus — allows one-way movement of food through the digestive tract.\n\nAll three features together = Nematoda (roundworms).\n\nOther options:\n• Hydra: Radial symmetry, single opening (mouth only, no separate anus) — incomplete gut.\n• Protozoa: Single-celled, no body symmetry of this kind.\n• Protists: Broad kingdom of mostly single-celled organisms.',
    h: 'Which worm-like group has bilateral symmetry, cylindrical body, mouth AND anus?',
  },

  // ══════════════════════════════════════════════
  // 2023
  // ══════════════════════════════════════════════

  {
    yr: 2023,
    q: 'Which of the following is the most inclusive level of classification in the Linnaean system?',
    o: ['Kingdom', 'Domain', 'Class', 'Phylum'],
    a: 0,
    e: 'In the classical Linnaean system, Kingdom is the highest (most inclusive) level. Domain was added later by Woese and is not part of the original Linnaean hierarchy. JAMB answer: Kingdom.',
    full: 'The classical Linnaean hierarchy from most to least inclusive:\n1. Kingdom\n2. Phylum\n3. Class\n4. Order\n5. Family\n6. Genus\n7. Species\n\nDomain (Bacteria, Archaea, Eukarya) was introduced by Carl Woese in 1990 — ABOVE Kingdom — but is NOT part of the original Linnaean system.\n\nSince the question asks about the "Linnaean system" specifically, the most inclusive level is Kingdom.\n\n⚠️ EduPadi\'s explanation mentioned Domain but the verified JAMB answer is Kingdom (A).',
    h: 'In Linnaeus\'s original classification, what is the broadest/most inclusive rank?',
  },

  {
    yr: 2023,
    q: 'Which of the following is a method of asexual reproduction in plants?',
    o: ['Pollination', 'Vegetative propagation', 'Seed dispersal', 'Fertilization'],
    a: 1,
    e: 'Vegetative propagation produces new plants from vegetative parts (stems, roots, leaves, bulbs) of one parent plant — no gametes involved. It is a form of asexual reproduction.',
    full: 'Asexual reproduction in plants involves a single parent and no gamete fusion. Types include:\n• Vegetative propagation: Using stems (runners, tubers, rhizomes), leaves (e.g., Bryophyllum), or roots (e.g., cassava cuttings)\n• Budding (in yeast)\n• Spore formation\n• Fragmentation\n\nOther options:\n• Pollination: Transfer of pollen — part of sexual reproduction\n• Seed dispersal: Spreading seeds — part of sexual reproduction cycle\n• Fertilisation: Fusion of gametes — sexual reproduction\n\nVegetative propagation is the only asexual method listed.',
    h: 'Which method of plant reproduction uses leaves, stems, or roots — not seeds or gametes?',
  },

  {
    yr: 2023,
    q: 'Which of the following is the primary organ involved in gas exchange during respiration in humans?',
    o: ['Diaphragm', 'Bronchi', 'Lungs', 'Trachea'],
    a: 2,
    e: 'Gas exchange (O₂ in, CO₂ out) occurs in the alveoli of the lungs. The diaphragm drives breathing movement, bronchi are airways, and the trachea is the windpipe — none of them are gas exchange surfaces.',
    full: 'The respiratory system pathway:\nNose/Mouth → Trachea (windpipe) → Bronchi (two branches) → Bronchioles → Alveoli\n\nGAS EXCHANGE happens at the alveoli — tiny air sacs in the lungs with:\n• Thin walls (one cell thick)\n• Large surface area\n• Rich blood supply (capillaries)\n\nOxygen diffuses into the blood; CO₂ diffuses out.\n\nOther organs:\n• Diaphragm: A muscle that contracts/relaxes to change lung volume (ventilation), not exchange.\n• Bronchi/Trachea: Airways that conduct air to the lungs — no gas exchange occurs there.',
    h: 'Where does O₂ enter the blood and CO₂ leave it during breathing?',
  },

  {
    yr: 2023,
    q: 'Which of the following statements about the heart is true?',
    o: [
      'The heart is responsible for the production of red blood cells',
      'The heart pumps oxygenated blood to the lungs',
      'The heart receives blood from the kidneys and filters waste products',
      'The heart is a muscular organ that contracts to circulate blood throughout the body',
    ],
    a: 3,
    e: 'The heart is a pump — a muscular organ that contracts rhythmically to push blood around the body. It does not produce RBCs (that\'s the red bone marrow), filter waste (that\'s kidneys), or send oxygenated blood to lungs (it sends deoxygenated blood to lungs).',
    full: 'The heart is a double pump:\n• Right side: receives deoxygenated blood from body → pumps it to LUNGS (pulmonary circulation)\n• Left side: receives oxygenated blood from lungs → pumps it to BODY (systemic circulation)\n\nWhy the other options are wrong:\n• A: Red blood cells are produced in red bone marrow, not the heart.\n• B: The heart pumps DEOXYGENATED blood to the lungs (to pick up oxygen), not oxygenated blood.\n• C: The kidneys filter waste from blood — not the heart.\n• D: ✓ The heart is a muscular organ that contracts to circulate blood. Correct.',
    h: 'What is the heart\'s primary function — production, filtration, or pumping?',
  },

  {
    yr: 2023,
    q: 'Which of the following characteristics is typical of the phylum Arthropoda?',
    o: [
      'Radial symmetry',
      'Closed circulatory system',
      'Endoskeleton made of bones',
      'Presence of a segmented body',
    ],
    a: 3,
    e: 'Arthropods (insects, spiders, crabs, centipedes) are defined by their segmented bodies, jointed appendages, and exoskeleton made of chitin — NOT an endoskeleton of bone.',
    full: 'Phylum Arthropoda characteristics:\n✓ Segmented body (e.g., head, thorax, abdomen in insects)\n✓ Jointed appendages (arthros = joint, poda = leg)\n✓ Exoskeleton made of chitin\n✓ Bilateral symmetry\n✓ OPEN circulatory system (blood called haemolymph fills body cavities)\n\nWhy the other options are wrong:\n• A: Radial symmetry → found in echinoderms (starfish) and cnidarians (jellyfish).\n• B: Closed circulatory system → found in vertebrates and earthworms.\n• C: Endoskeleton of bones → vertebrates only.\n\nArthropoda is the largest animal phylum, containing over 80% of all known animal species.',
    h: 'What body feature is the defining characteristic of all arthropods?',
  },

  {
    yr: 2023,
    q: 'Which process in the nutrient cycle converts atmospheric nitrogen into a form that plants can utilise?',
    o: ['Denitrification', 'Nitrogen fixation', 'Ammonification', 'Nitrification'],
    a: 1,
    e: 'Nitrogen fixation converts N₂ gas (atmospheric nitrogen) into ammonia (NH₃) or nitrates — forms usable by plants. Carried out by nitrogen-fixing bacteria such as Rhizobium in root nodules.',
    full: 'The nitrogen cycle steps:\n\n1. Nitrogen fixation: N₂ → NH₃/NH₄⁺\n   • Done by: Rhizobium (in legume root nodules), Azotobacter, Cyanobacteria\n   • This is the ENTRY POINT — converts inert N₂ into usable nitrogen\n\n2. Nitrification: NH₄⁺ → NO₂⁻ → NO₃⁻\n   • Done by: Nitrosomonas and Nitrobacter\n   • Converts ammonia to nitrates (plant-absorbable form)\n\n3. Ammonification: Organic nitrogen → NH₄⁺\n   • Decomposers break down dead organisms\n\n4. Denitrification: NO₃⁻ → N₂\n   • Returns nitrogen to the atmosphere\n   • Done by: Pseudomonas, Thiobacillus\n\nThe question asks specifically about converting ATMOSPHERIC nitrogen (N₂) — that is NITROGEN FIXATION.',
    h: 'Which step in the nitrogen cycle captures N₂ gas and converts it into ammonia?',
  },

  {
    yr: 2023,
    q: 'Most fishes do not sink in water because of the presence of:\nI. Swim bladder  II. Air bladder  III. Air sacs  IV. Air in spongy bones',
    o: ['II and III only', 'I and II only', 'I, II, III and IV', 'III and IV only'],
    a: 1,
    e: 'The swim bladder (also called the air bladder) is the gas-filled organ that controls buoyancy in bony fish. "Swim bladder" and "air bladder" are the same organ — two names for it. Air sacs and air in spongy bones are not fish buoyancy structures.',
    full: '"Swim bladder" and "air bladder" are TWO NAMES for the SAME organ in bony fish (Osteichthyes). It is a gas-filled sac that adjusts the fish\'s density to match the surrounding water, preventing sinking or floating unintentionally.\n\n• Statement I (swim bladder) ✓\n• Statement II (air bladder) ✓ — same thing, different name\n• Statement III (air sacs) ✗ — air sacs are found in birds, not fish\n• Statement IV (air in spongy bones) ✗ — bird adaptation, not fish\n\nAnswer: I and II only (B)',
    h: 'What organ(s) control buoyancy in bony fish? Are "swim bladder" and "air bladder" the same?',
  },

  {
    yr: 2023,
    q: 'A biome characterised by hot summers, warm winters and treeless vegetation is ______.',
    o: ['Steppe grasslands', 'Temperate deserts', 'Savannah grassland', 'Tropical deserts'],
    a: 0,
    e: 'Steppe grasslands have hot summers, relatively warm (not freezing cold) winters, low rainfall, and are largely treeless — dominated by grasses. This matches the description.',
    full: 'Biome comparison:\n\n• Steppe grasslands: Treeless, hot summers, warm-to-mild winters, low rainfall, vast grasslands. Found in Central Asia, Eastern Europe, North America (Great Plains).\n• Savannah grassland: Has TREES (scattered), tropical, distinct wet and dry seasons.\n• Temperate deserts: Very low rainfall, extreme temperature swings — very cold winters, hot summers.\n• Tropical deserts: Extremely hot year-round (e.g., Sahara) — sparse vegetation, not truly "treeless grassland."\n\nKey clue in the question: "treeless vegetation" + "warm winters" → Steppe grassland.\n\nSavannah is often confused with steppe, but savannah HAS trees (e.g., acacia) and is tropical.',
    h: 'Which grassland biome is treeless with hot summers but warmer (not freezing) winters?',
  },

  {
    yr: 2023,
    q: 'Which of the following describes the inheritance of traits from parents to offspring?',
    o: ['Adaptation', 'Evolution', 'Natural selection', 'Genetics'],
    a: 3,
    e: 'Genetics is the branch of biology that studies how traits (characteristics) are passed from parents to their offspring through genes and chromosomes.',
    full: 'Definitions:\n• Genetics: Study of heredity — how traits are transmitted from parents to offspring via genes.\n• Evolution: Long-term change in the inherited traits of populations over many generations.\n• Natural selection: Process where organisms with favourable traits survive and reproduce more.\n• Adaptation: A trait that improves an organism\'s fitness in its environment.\n\nThe question asks specifically about INHERITANCE from parents to offspring — that is Genetics.\n\nKey concept: Genes carry the information. DNA is copied and passed to offspring either through sexual reproduction (with variation) or asexual reproduction (identical copy).',
    h: 'What branch of biology studies how traits are passed from parents to children?',
  },

  {
    yr: 2023,
    q: 'Which of the following options correctly identifies excretory organs in animals?',
    o: [
      'Stomach, intestines, and bladder',
      'Lungs, kidneys, and skin',
      'Brain, spinal cord, and nerves',
      'Heart, liver, and spleen',
    ],
    a: 1,
    e: 'Excretory organs eliminate metabolic waste from the body. Lungs excrete CO₂, kidneys excrete urea/water/salts as urine, and skin excretes some salts and water through sweat.',
    full: 'Excretion is the removal of metabolic waste products produced by chemical reactions in the body.\n\nMain excretory organs in animals:\n• Kidneys: Excrete urea, uric acid, excess salts, and water (as urine)\n• Lungs: Excrete CO₂ and water vapour\n• Skin: Excretes water, salts, and traces of urea through sweat\n• Liver: Produces urea from deamination of amino acids (sends it to kidneys)\n\nOptions breakdown:\n• A: Stomach, intestines, bladder — digestive/storage organs, not primary excretory organs\n• B: Lungs, kidneys, skin ✓ — the three main excretory organs\n• C: Brain, spinal cord, nerves — nervous system\n• D: Heart, liver, spleen — circulatory/lymphatic organs',
    h: 'Which three organs eliminate metabolic waste (CO₂, urea, salts) from the body?',
  },

  {
    yr: 2023,
    q: 'Which processes are involved in nutrient cycling in a functioning ecosystem?',
    o: [
      'Erosion, weathering, and sedimentation',
      'Decomposition, evaporation, and precipitation',
      'Nitrogen fixation, denitrification, and ammonification',
      'Respiration, photosynthesis, and transpiration',
    ],
    a: 2,
    e: 'Nitrogen fixation, denitrification, and ammonification are all steps in the nitrogen cycle — a key nutrient cycle in ecosystems. They cycle nitrogen between the atmosphere, soil, and living organisms.',
    full: 'Nutrient cycling involves the movement of essential elements (nitrogen, carbon, phosphorus, etc.) through biotic and abiotic components of an ecosystem.\n\nNitrogen cycle steps:\n• Nitrogen fixation: N₂ → NH₃ (by Rhizobium, Azotobacter)\n• Ammonification: Dead organic matter → NH₄⁺ (by decomposers)\n• Nitrification: NH₄⁺ → NO₃⁻ (by Nitrosomonas, Nitrobacter)\n• Denitrification: NO₃⁻ → N₂ (by Pseudomonas)\n\nAll three in option C are part of the nitrogen cycle — the most tested nutrient cycle in JAMB Biology.\n\nThe other options describe weather processes (A), the water cycle (B), and energy flow through photosynthesis/respiration (D) — not nutrient cycling.',
    h: 'Which set of three processes are all part of the nitrogen nutrient cycle?',
  },

  {
    yr: 2023,
    q: 'Which of the following eye defects is caused by the inability of the eye to focus light on the retina?',
    o: ['Glaucoma', 'Myopia', 'Cataracts', 'Astigmatism'],
    a: 1,
    e: 'Myopia (short-sightedness) occurs when the eyeball is too long or the cornea/lens is too curved, causing light to focus in FRONT of the retina instead of on it. Distant objects appear blurry.',
    full: 'Eye defects:\n\n• Myopia (short-sightedness): Light focuses IN FRONT of retina. Distant objects are blurry. Corrected with concave (diverging) lenses.\n• Hypermetropia (long-sightedness): Light focuses BEHIND retina. Near objects are blurry. Corrected with convex (converging) lenses.\n• Astigmatism: Uneven curvature of cornea/lens → distorted image. Corrected with cylindrical lenses.\n• Glaucoma: Increased pressure inside the eye → damages optic nerve. Not a focusing problem.\n• Cataracts: Clouding of the eye lens → reduced light passage. Not a focusing/shape problem.\n\nThe question describes "inability to focus light ON the retina" — this is myopia (light focuses short of the retina).',
    h: 'Which eye defect causes light to focus in front of the retina, blurring distant objects?',
  },

  {
    yr: 2023,
    q: 'Which of the following is the correct classification of carbohydrates?',
    o: ['Lipid', 'Phytonutrient', 'Macronutrient', 'Micronutrient'],
    a: 2,
    e: 'Carbohydrates are macronutrients — nutrients needed by the body in large amounts for energy. Macronutrients include carbohydrates, proteins, and fats.',
    full: 'Nutrient classification:\n\nMacronutrients (needed in large quantities):\n• Carbohydrates — primary energy source (4 kcal/g)\n• Proteins — growth, repair, enzymes (4 kcal/g)\n• Fats/Lipids — energy storage, insulation (9 kcal/g)\n\nMicronutrients (needed in small quantities):\n• Vitamins (A, B, C, D, E, K...)\n• Minerals (iron, calcium, iodine...)\n\nCarbohydrates are definitely NOT:\n• Lipids (fats) — a separate macronutrient class\n• Phytonutrients — plant-derived protective chemicals (e.g., lycopene, flavonoids)\n• Micronutrients — needed only in trace amounts',
    h: 'Carbohydrates, proteins, and fats are all examples of which nutrient category?',
  },

  {
    yr: 2023,
    q: 'Which of the following best describes the alimentary canal in the human digestive system?',
    o: [
      'Salivary glands, tongue, and pharynx',
      'Large intestine, appendix, and rectum',
      'Stomach, liver, and gallbladder',
      'Oesophagus, pancreas, and small intestine',
    ],
    a: 1,
    e: 'The alimentary canal is the continuous tube from mouth to anus. Large intestine, appendix, and rectum are all true parts of this tube. Liver, pancreas, and gallbladder are accessory glands — outside the canal itself.',
    full: 'The alimentary canal (digestive tract) is the muscular tube running from mouth to anus:\nMouth → Oesophagus → Stomach → Small intestine → Large intestine → Appendix → Rectum → Anus\n\nAccessory organs (NOT part of the canal itself, but connected to it):\n• Liver (produces bile)\n• Gallbladder (stores bile)\n• Pancreas (produces digestive enzymes and hormones)\n• Salivary glands (produce saliva)\n\nOption B (large intestine, appendix, rectum) — all part of the alimentary canal ✓\n\n⚠️ EduPadi listed D as correct (oesophagus, pancreas, small intestine). This is wrong because the pancreas is an ACCESSORY organ, NOT part of the alimentary canal. The correct answer is B.',
    h: 'Which set of organs are all part of the alimentary canal tube — not accessory glands?',
  },

  {
    yr: 2023,
    q: 'Which of the following statements about viruses is true?',
    o: [
      'Viruses can reproduce outside of a host cell',
      'Viruses require a host cell to replicate',
      'Viruses possess a cellular structure',
      'Viruses are living organisms',
    ],
    a: 1,
    e: 'Viruses are obligate intracellular parasites — they MUST use a host cell\'s machinery (ribosomes, ATP, enzymes) to replicate. They cannot reproduce independently.',
    full: 'Virus characteristics:\n• Not cellular — no cell membrane, cytoplasm, or organelles\n• Not considered living (debated) — cannot carry out metabolism independently\n• Consist of: nucleic acid (DNA or RNA) + protein coat (capsid), sometimes a lipid envelope\n• Can ONLY replicate inside a living host cell\n\nViral replication cycle:\n1. Attachment to host cell surface receptors\n2. Injection of nucleic acid into host\n3. Use of host\'s ribosomes/enzymes to make viral proteins and copy viral DNA/RNA\n4. Assembly of new viruses\n5. Release (lysis or budding)\n\nWhy others are wrong:\n• A: Viruses CANNOT reproduce outside a host — inert particles outside.\n• C: Viruses are acellular — no cellular structure.\n• D: Viruses are considered non-living — no metabolism, no homeostasis independently.',
    h: 'What do viruses REQUIRE in order to replicate themselves?',
  },

  {
    yr: 2023,
    q: 'What is the definition of population ecology?',
    o: [
      'The study of interactions between organisms and their physical environment',
      'The study of evolutionary processes and their effects on populations',
      'The study of interactions between different populations in an ecosystem',
      'The study of the distribution and abundance of individuals within a species',
    ],
    a: 3,
    e: 'Population ecology is the study of how and why populations of a single species change in size and distribution over time — including birth rates, death rates, immigration, emigration, and limiting factors.',
    full: 'Ecology sub-disciplines:\n\n• Organismal ecology: How individual organisms interact with their environment\n• Population ecology: Distribution and abundance of a single species — birth/death rates, carrying capacity, population growth models (D)\n• Community ecology: Interactions BETWEEN different populations (C) — competition, predation, symbiosis\n• Ecosystem ecology: Interactions between communities and their physical environment (A)\n• Evolutionary ecology: How evolution shapes ecological interactions (B)\n\nThe question asks about population ecology specifically — "distribution and abundance of individuals within a species" ✓',
    h: 'Population ecology studies the numbers and spread of individuals within which level of organisation?',
  },

  {
    yr: 2023,
    q: 'Which of the following represents the correct hierarchical organisation of life from smallest to largest scale?',
    o: [
      'Organs, tissues, cells, organisms, populations, communities, ecosystems',
      'Cells, organs, tissues, organisms, populations, communities, ecosystems',
      'Tissues, organs, cells, organisms, populations, communities, ecosystems',
      'Cells, tissues, organs, organisms, populations, communities, ecosystems',
    ],
    a: 3,
    e: 'The correct order from smallest to largest: Cells → Tissues → Organs → Organisms → Populations → Communities → Ecosystems.',
    full: 'Hierarchy of biological organisation (smallest → largest):\n\n1. Cells — basic unit of life\n2. Tissues — groups of similar cells\n3. Organs — groups of tissues with a specific function\n4. Organisms — individual living things\n5. Populations — all individuals of one species in an area\n6. Communities — all populations in an area\n7. Ecosystems — community + its physical environment\n8. Biosphere — all ecosystems on Earth\n\nThe correct answer is D: Cells, tissues, organs, organisms, populations, communities, ecosystems.',
    h: 'Put in order from smallest to largest: cells, organs, tissues, organisms, populations, communities, ecosystems.',
  },

  {
    yr: 2023,
    q: 'Which of the following soil types becomes less fertile due to intense leaching caused by tropical rains?',
    o: ['Yellow soil', 'Laterite soil', 'Red soils', 'Black soil'],
    a: 1,
    e: 'Laterite soil is formed in tropical areas with heavy rainfall. The intense leaching washes away minerals and nutrients, leaving behind iron and aluminium oxides — making the soil hard, reddish, and infertile.',
    full: 'Laterite soil:\n• Forms in tropical/subtropical regions with high rainfall and seasonal drying\n• Heavy rains leach (wash away) silica, calcium, potassium, and other nutrients downward\n• What remains: iron oxides (Fe₂O₃) and aluminium oxides (Al₂O₃) — laterite\n• The soil hardens on exposure to air (low organic matter, low nutrients)\n• Very poor for agriculture without intensive fertilisation\n\nThis is common in West Africa, including parts of Nigeria.\n\nOther options:\n• Black soil (cotton soil/vertisol): Very fertile, rich in calcium, magnesium — NOT leached\n• Red soils: Some overlap with laterite but are not all infertile\n• Yellow soil: Not a major category associated with tropical leaching',
    h: 'Which tropical soil type loses fertility because rainwater washes away its minerals?',
  },

  {
    yr: 2023,
    q: 'Which of the following factors primarily affects the distribution of organisms in an ecosystem?',
    o: ['Wind speed', 'Soil pH', 'Temperature', 'Day length'],
    a: 2,
    e: 'Temperature is the primary abiotic factor controlling where organisms can survive and reproduce. Every organism has a specific temperature range — this determines their geographic distribution more than most other factors.',
    full: 'Abiotic factors affecting distribution:\n• Temperature ★ — the single most important factor governing distribution at large scales. Determines metabolic rates, enzyme activity, and survival zones of all organisms.\n• Soil pH — important for plant distribution but more localised\n• Day length (photoperiod) — affects flowering time, animal behaviour, but secondary to temperature\n• Wind speed — affects evaporation/transpiration but not the primary distribution factor\n\nTemperature explains why:\n• Polar bears live in the Arctic (not tropics)\n• Cacti grow in deserts (not rainforests)\n• Coral reefs only exist in warm tropical seas\n• Different biomes exist at different latitudes\n\nFor JAMB: temperature = the PRIMARY ecological factor controlling organism distribution.',
    h: 'Which abiotic factor most determines WHERE different species of organisms can live?',
  },

  {
    yr: 2023,
    q: 'Which of the following statements is true regarding cell growth?',
    o: [
      'Cell growth is solely influenced by external factors',
      'Cell growth is a continuous process throughout the life of a cell',
      'Cell growth involves an increase in the number of organelles within a cell',
      'Cell growth occurs by cell division',
    ],
    a: 3,
    e: 'Cell growth and reproduction occur through cell division (mitosis for somatic cells). A parent cell grows and then divides into two daughter cells — this is how organisms grow and replace cells.',
    full: 'Cell growth:\n• Cells grow to a certain size, then divide (mitosis) producing two daughter cells\n• Growth = increase in cell size AND ultimately increase in cell number through division\n\nWhy the other options are wrong:\n• A: Cell growth is influenced by BOTH internal (genes, hormones) AND external factors — not solely external\n• B: Cell growth is NOT continuous throughout the life of a cell — cells have a G1 phase (growth), S phase (DNA replication), G2 phase, then mitosis. Many cells exit the cycle entirely.\n• C: Organelle number does increase during growth, but this is not the DEFINITION of cell growth; growth leads to DIVISION\n• D: ✓ Cell growth and reproduction occur through cell division\n\nNote: In JAMB context, "cell growth occurs by cell division" means that organisms grow by cells dividing — creating more cells.',
    h: 'How do organisms grow at the cellular level — how are new cells produced?',
  },

  {
    yr: 2023,
    q: 'The term "cell" was coined by ______.',
    o: ['Robert Hooke', 'Schwann', 'De Bary', 'Tatum'],
    a: 0,
    e: 'Robert Hooke first used the term "cell" in 1665 after observing the box-like compartments in cork under a microscope. He described them as "cells" because they reminded him of small rooms (cellula in Latin).',
    full: 'History of the cell:\n• 1665 — Robert Hooke: First observed dead cork cells under a microscope; coined the word "cell" (from Latin cellula = small room)\n• 1674 — Antonie van Leeuwenhoek: First observed living cells (bacteria, protozoa)\n• 1838 — Matthias Schleiden: All plants are made of cells\n• 1839 — Theodor Schwann: All animals are made of cells → Cell Theory\n• 1855 — Rudolf Virchow: All cells come from pre-existing cells (Omnis cellula e cellula)\n\nThe question asks specifically who GAVE (coined) the TERM "cell" — that is Robert Hooke.',
    h: 'Who first used the word "cell" to describe the structures seen in cork under a microscope?',
  },

  {
    yr: 2023,
    q: 'Which of the following is an example of an abiotic ecological factor?',
    o: ['Temperature', 'Competition', 'Predation', 'Symbiosis'],
    a: 0,
    e: 'Abiotic factors are non-living physical and chemical components of an ecosystem. Temperature is abiotic. Competition, predation, and symbiosis are biotic factors — interactions between living organisms.',
    full: 'Ecological factors:\n\nAbiotic (non-living):\n• Temperature ✓\n• Light intensity\n• Rainfall/water availability\n• Soil pH and mineral content\n• Wind speed\n• Humidity\n\nBiotic (living/biological interactions):\n• Competition (organisms competing for resources)\n• Predation (predator-prey relationship)\n• Symbiosis (mutualism, commensalism, parasitism)\n• Disease\n• Decomposition\n\nAll of options B, C, D involve interactions BETWEEN living organisms → biotic.\nOnly Temperature (A) is a physical, non-living factor → abiotic.',
    h: 'Which factor is abiotic (non-living): temperature, competition, predation, or symbiosis?',
  },

  {
    yr: 2023,
    q: 'Which type of reproduction involves the fusion of gametes from two parents?',
    o: ['Sexual reproduction', 'Asexual reproduction', 'Binary fission', 'Budding'],
    a: 0,
    e: 'Sexual reproduction involves the fusion of male and female gametes (fertilisation) from two parents, producing offspring with genetic variation.',
    full: 'Types of reproduction:\n\nSexual reproduction:\n• Involves two parents\n• Produces gametes (sperm and egg) through meiosis\n• Gametes fuse (fertilisation) → zygote\n• Offspring have genetic variation\n• Examples: humans, flowering plants, frogs\n\nAsexual reproduction:\n• Involves ONE parent only\n• No gamete fusion\n• Offspring are genetically identical to parent (clones)\n• Types: Binary fission (bacteria), budding (hydra, yeast), fragmentation, spore formation, vegetative propagation\n\nBinary fission: One cell splits into two equal cells (bacteria)\nBudding: Outgrowth develops into a new organism (hydra)\n\nThe question — fusion of gametes from TWO parents — is Sexual reproduction ✓',
    h: 'Which type of reproduction requires gametes from two parents to fuse?',
  },

  {
    yr: 2023,
    q: 'Which of the following is a characteristic feature of Kingdom Plantae?',
    o: [
      'Presence of chloroplasts',
      'Ability to perform photosynthesis',
      'Lack of cell walls',
      'Heterotrophic mode of nutrition',
    ],
    a: 0,
    e: 'Chloroplasts are the defining organelles of plants — they contain chlorophyll and are the site of photosynthesis. They are found in all green plant cells.',
    full: 'Kingdom Plantae characteristics:\n✓ Have chloroplasts (containing chlorophyll)\n✓ Cell walls made of cellulose\n✓ Autotrophic (photosynthesis) — self-feeding\n✓ Eukaryotic\n✓ Mostly multicellular\n✓ Non-motile\n\nWhy option A is better than B:\nBoth A and B are actually correct for plants. However, the "characteristic FEATURE" (structural) is the PRESENCE OF CHLOROPLASTS (A) — photosynthesis (B) is what they DO with them. JAMB typically selects the structural characteristic.\n\nWhy C and D are wrong:\n• Plants DO have cell walls (made of cellulose) — so C is wrong\n• Plants are AUTOTROPHIC (self-feeding via photosynthesis), not heterotrophic — so D is wrong\n\nEduPadi verified answer: A — presence of chloroplasts.',
    h: 'Which structural organelle is the definitive feature of all plant cells?',
  },

  {
    yr: 2023,
    q: 'Which of the following best describes the concept of trophic levels in an ecosystem?',
    o: [
      'The levels of ecological interactions within an ecosystem',
      'The levels of energy flow within an ecosystem',
      'The levels of nutrient cycling within an ecosystem',
      'The levels of biological diversity within an ecosystem',
    ],
    a: 1,
    e: 'Trophic levels represent the positions in a food chain and describe how energy flows from producers through successive consumers in an ecosystem.',
    full: 'Trophic levels:\n• Trophic = relating to feeding/nutrition\n• Each level represents a step in the transfer of energy through an ecosystem\n\nTrophic level sequence:\n1. Producers (plants) — capture solar energy via photosynthesis\n2. Primary consumers (herbivores) — eat plants\n3. Secondary consumers (carnivores) — eat herbivores\n4. Tertiary consumers — eat secondary consumers\n5. Decomposers — break down dead organisms at all levels\n\n~10% rule: Only ~10% of energy transfers from one trophic level to the next (90% lost as heat).\n\nTrophic levels describe ENERGY FLOW — not interactions (A), nutrient cycling (C), or biodiversity (D).\n\nAnswer: B — levels of energy flow within an ecosystem.',
    h: 'Trophic levels describe how what moves from producers through consumers in an ecosystem?',
  },

  {
    yr: 2023,
    q: 'Which of the following is NOT a method of reproduction in animals?',
    o: ['Asexual reproduction', 'Budding', 'Sexual reproduction', 'Sporulation'],
    a: 3,
    e: 'Sporulation (spore formation) is a reproductive method used by bacteria, fungi, and some protozoa — NOT animals. Animals reproduce sexually or by limited forms of asexual reproduction like budding.',
    full: 'Animal reproduction methods:\n• Sexual reproduction ✓ — most animals\n• Budding ✓ — hydra, some sponges (limited asexual reproduction in animals)\n• Fragmentation ✓ — starfish, flatworms\n• Parthenogenesis ✓ — some reptiles, bees\n\nNOT found in animals:\n• Sporulation ✗ — production of spores; used by bacteria (endospores), fungi (conidia, basidiospores), algae, protozoa (Plasmodium). NOT a method of animal reproduction.\n\nAnswer: D — Sporulation is NOT a method of reproduction in animals.',
    h: 'Which reproductive method (spore formation) belongs to fungi/bacteria but NOT animals?',
  },

  {
    yr: 2023,
    q: 'Which of the following are components of the skeletal system in humans?',
    o: [
      'Cartilage and blood vessels',
      'Ligaments and tendons',
      'Muscles and nerves',
      'Bones and joints',
    ],
    a: 3,
    e: 'The skeletal system is composed primarily of bones (providing structure, protection, mineral storage) and joints (where bones meet, enabling movement).',
    full: 'Human skeletal system components:\n• Bones — 206 bones in adults; structural framework, protection, mineral storage, blood cell production\n• Joints — where two or more bones meet; allow movement (synovial, fibrous, cartilaginous)\n• Cartilage — often listed as a skeletal component too, but the PRIMARY components are bones + joints\n\nOther options:\n• A: Cartilage + blood vessels — blood vessels are NOT skeletal components\n• B: Ligaments + tendons — ligaments connect bone to bone; tendons connect muscle to bone. Both are connective tissue around the skeleton but not the skeleton itself\n• C: Muscles + nerves — muscular and nervous systems, not skeletal\n• D: Bones + joints ✓ — the core components of the skeletal system',
    h: 'What are the two main structural components that make up the skeletal system?',
  },

  {
    yr: 2023,
    q: 'Which of the following is an example of conserving resources in an ecosystem?',
    o: [
      'Excessive use of chemical fertilisers in agriculture',
      'Introducing invasive species to an ecosystem',
      'Implementing sustainable fishing practices',
      'Cutting down trees for timber production',
    ],
    a: 2,
    e: 'Sustainable fishing practices manage fish populations to prevent depletion — allowing stocks to regenerate. This is an example of conservation.',
    full: 'Conservation = using resources in a way that allows them to be sustained over time.\n\nOption analysis:\n• A: Excessive chemical fertilisers — pollutes waterways, kills beneficial organisms, depletes soil. NOT conservation.\n• B: Introducing invasive species — disrupts native ecosystems, causes extinction of native species. NOT conservation.\n• C: Sustainable fishing practices ✓ — fishing within sustainable limits, using fish quotas, avoiding spawning seasons. Allows fish populations to recover. This IS conservation.\n• D: Cutting down trees — deforestation; destroys habitats. NOT conservation.\n\nSustainable fishing is one of the clearest examples of applying ecological principles to conserve a living resource.',
    h: 'Which practice protects fish populations by fishing within limits they can recover from?',
  },
    
    {
      yr: 2024,
      q: 'The powerhouse of the cell is the',
      o: ['Nucleus', 'Mitochondria', 'Ribosome', 'Golgi body'],
      a: 1,
      e: 'Mitochondria produce ATP through cellular respiration.',
      full: 'Every living cell needs energy to perform its functions — dividing, growing, moving, making proteins. That energy comes in the form of a molecule called ATP (adenosine triphosphate), which works like a rechargeable battery for the cell.\n\nMitochondria are the organelles where ATP is manufactured through a process called cellular respiration. They take in glucose and oxygen and convert them into ATP, releasing carbon dioxide and water as by-products. Because they are the primary energy producers of the cell, they earned the nickname "the powerhouse of the cell."\n\nThe nucleus stores DNA and controls the cell\'s activities. Ribosomes make proteins. The Golgi body packages and ships proteins. None of these produce ATP.',
      h: "Which organelle produces the cell's energy currency?",
    },
    {
      yr: 2024,
      q: 'Universal blood donor is group',
      o: ['A', 'B', 'AB', 'O'],
      a: 3,
      e: 'Blood group O negative lacks A and B antigens that could cause reactions.',
      full: "When blood is transfused into a patient, the recipient's immune system checks for antigens on the surface of the incoming red blood cells. If it finds unfamiliar antigens, it launches an immune attack — a potentially fatal transfusion reaction.\n\nBlood group O negative red blood cells have neither A antigens nor B antigens on their surface. This means a patient of ANY blood group cannot recognise them as foreign — there is nothing to trigger an immune attack. That is why O negative is called the universal donor.\n\nBlood group AB positive is the universal RECIPIENT — people with AB+ can receive blood from any group because their immune system already tolerates both A and B antigens.",
      h: 'Which group has NO antigens that can cause rejection?',
    },
    {
      yr: 2023,
      q: 'Photosynthesis takes place in the',
      o: ['Mitochondria', 'Chloroplast', 'Nucleus', 'Vacuole'],
      a: 1,
      e: 'Chloroplasts contain chlorophyll and are the site of photosynthesis.',
      full: "Chlorophyll is the green pigment that absorbs sunlight and uses it to drive the chemical reactions of photosynthesis. It is found inside organelles called chloroplasts, which are present mainly in the cells of green plant leaves.\n\nMitochondria are found in both plants and animals and are the site of respiration, not photosynthesis. The nucleus contains DNA and controls the cell's activities. The vacuole stores water and waste products.\n\nChloroplasts are unique to plants (and some algae) — animal cells do not have them, which is why animals cannot photosynthesise and must eat food to obtain energy.",
      h: 'Which organelle contains chlorophyll?',
    },
    {
      yr: 2024,
      q: 'Green plants make food through',
      o: ['Respiration', 'Transpiration', 'Photosynthesis', 'Digestion'],
      a: 2,
      e: 'Photosynthesis uses sunlight, CO2 and water to produce glucose and oxygen.',
      full: "Plants make their own food through photosynthesis — a chemical process that takes place inside chloroplasts. The raw materials are carbon dioxide (absorbed from the air through tiny pores called stomata) and water (absorbed from the soil through roots). Sunlight provides the energy needed to drive the reaction.\n\nThe products are glucose — the plant's food — and oxygen, which is released into the air as a by-product. This is why plants are essential for life on Earth: they produce the oxygen we breathe while removing CO2 from the atmosphere.\n\nRespiration is the reverse process — it releases energy from glucose. Transpiration is water loss. Digestion is food breakdown in animals.",
      h: 'Photo = light. Synthesis = making.',
    },
    {
      yr: 2023,
      q: 'NOT a function of the liver',
      o: [
        'Detoxification',
        'Production of bile',
        'Filtration of blood',
        'Secretion of insulin',
      ],
      a: 3,
      e: 'Insulin is secreted by the pancreas, not the liver.',
      full: 'The liver is a remarkable organ with over 500 functions. It detoxifies harmful substances in the blood, produces bile (which helps digest fats), stores glycogen (for blood sugar regulation), makes blood-clotting proteins, and filters old red blood cells.\n\nHowever, insulin — the hormone that lowers blood glucose levels — is produced by specialised cells called beta cells in the islets of Langerhans within the pancreas. The pancreas is a separate organ located behind the stomach.\n\nConfusing the pancreas and the liver is a very common mistake. Remember: the liver stores and releases glucose, but the pancreas produces the insulin that controls how glucose is used.',
      h: "The liver doesn\'t produce blood sugar hormones.",
    },
    {
      yr: 2022,
      q: 'Osmosis is movement of water from',
      o: [
        'Low to high concentration',
        'High to low water potential',
        'Low to high pressure',
        'High to low temperature',
      ],
      a: 1,
      e: 'Osmosis is movement from high water potential to low water potential through a semi-permeable membrane.',
      full: 'Water potential is a measure of the tendency of water molecules to move from one place to another. Pure water has the highest water potential. Adding dissolved substances (solutes) lowers water potential.\n\nOsmosis is the specific movement of water molecules across a semi-permeable membrane (a membrane that lets water through but not dissolved substances) from where water potential is HIGH (more dilute solution) to where it is LOW (more concentrated solution).\n\nThis is how plant cells absorb water from the soil — the cell contents are more concentrated than the soil water, creating a water potential gradient that drives water in. It is also why eating salty food dehydrates you — the high salt concentration in food draws water out of cells.',
      h: 'Water moves DOWN its potential gradient.',
    },
    {
      yr: 2024,
      q: 'The genetic material in most organisms is',
      o: ['RNA', 'Protein', 'DNA', 'Lipid'],
      a: 2,
      e: 'DNA carries genetic information in most organisms.',
      full: 'DNA (deoxyribonucleic acid) is the molecule that stores and transmits genetic information. It contains instructions for building proteins, controlling cell functions, and passing characteristics from parents to offspring.\n\nRNA (ribonucleic acid) plays a role in reading and using the instructions in DNA to make proteins, but it is not the primary storage molecule. Proteins are built FROM the instructions in DNA — they are the products, not the blueprint. Lipids (fats) are structural and energy-storage molecules with no genetic information role.\n\nIn viruses, RNA can be the genetic material, but in virtually all living organisms — bacteria, plants, fungi, and animals — DNA is the genetic material.',
      h: 'What molecule stores genetic information?',
    },
    {
      yr: 2023,
      q: 'Which part of the brain controls balance?',
      o: ['Cerebrum', 'Cerebellum', 'Medulla oblongata', 'Hypothalamus'],
      a: 1,
      e: 'The cerebellum coordinates voluntary movements and maintains balance.',
      full: 'The brain has several distinct regions with specific functions. The cerebrum (the large folded outer region) handles conscious thought, memory, language, sensory processing, and voluntary movement commands. The medulla oblongata controls involuntary functions like breathing, heart rate, and swallowing. The hypothalamus regulates body temperature, hunger, thirst, and hormones.\n\nThe cerebellum — literally "little brain" — sits at the back and bottom of the brain. Its job is to coordinate smooth, precise movements and maintain posture and balance. It receives signals from the muscles and sensory organs and fine-tunes motor commands so that movements are fluid, not jerky.\n\nDamage to the cerebellum causes loss of coordination, unsteady walking, and tremors.',
      h: 'Cerebellum means little brain — specialises in coordination.',
    },
    {
      yr: 2022,
      q: 'The basic unit of life is',
      o: ['Tissue', 'Organ', 'Cell', 'Organism'],
      a: 2,
      e: 'The cell is the smallest structural and functional unit of living organisms.',
      full: 'Life is organised in levels of increasing complexity: cells → tissues → organs → organ systems → organisms. The cell is the foundation of this hierarchy — the smallest unit that can perform all the basic functions of life: obtaining energy, responding to stimuli, reproducing, and maintaining homeostasis.\n\nA tissue is a group of similar cells working together (like muscle tissue or nerve tissue). An organ is made of multiple tissue types working together (like the heart). An organism is the complete living individual.\n\nViruses are smaller than cells but are debated as to whether they are truly "alive" — they cannot reproduce without hijacking a host cell. For JAMB purposes, the cell is the basic unit of life.',
      h: 'Smallest unit that can carry out all life functions.',
    },
    {
      yr: 2024,
      q: 'Anaerobic respiration in yeast produces',
      o: [
        'CO2 and water',
        'Ethanol and CO2',
        'Lactic acid only',
        'Oxygen and glucose',
      ],
      a: 1,
      e: 'Yeast fermentation produces ethanol and carbon dioxide.',
      full: 'When oxygen is unavailable, yeast switches from aerobic respiration to anaerobic respiration — also called fermentation. Instead of fully breaking down glucose to carbon dioxide and water (as in aerobic respiration), fermentation only partially breaks it down.\n\nThe products are ethanol (alcohol) and carbon dioxide gas. This is the biological basis of the brewing and baking industries. In brewing, the ethanol is the desired product. In baking, the CO2 is the desired product — it causes bread dough to rise.\n\nIn human muscle cells, a different form of anaerobic respiration produces lactic acid (not ethanol) when oxygen runs out during intense exercise. That is why you feel muscle burn during a hard sprint — but that is human muscle, not yeast.',
      h: 'Fermentation in brewing produces alcohol.',
    },
    {
      yr: 2023,
      q: 'Hormone for fight or flight response',
      o: ['Insulin', 'Oestrogen', 'Adrenaline', 'Thyroxine'],
      a: 2,
      e: 'Adrenaline is released by adrenal glands during stress.',
      full: "The fight or flight response is the body's emergency system. When you face a threat — whether a dangerous situation or an exam you're not prepared for — your brain signals the adrenal glands (small glands that sit on top of your kidneys) to release adrenaline (also called epinephrine).\n\nAdrenaline rapidly prepares your body for action: heart rate increases to pump more blood to muscles, breathing quickens, pupils dilate for better vision, blood glucose rises for quick energy, and non-essential functions (like digestion) slow down.\n\nInsulin controls blood sugar. Oestrogen is a female sex hormone. Thyroxine regulates metabolism. None of these produce the fight or flight response.",
      h: "Which hormone is released when you're scared or excited?",
    },
    {
      yr: 2022,
      q: 'Example of asexual reproduction',
      o: ['Fertilisation', 'Budding', 'Pollination', 'Mating'],
      a: 1,
      e: 'Budding is asexual reproduction where a new organism grows from a bud on the parent.',
      full: 'Asexual reproduction involves only one parent and produces offspring genetically identical to that parent. Budding is one type — a small outgrowth (bud) forms on the parent organism, grows, and eventually detaches to become a new independent organism.\n\nYeast (a fungus) reproduces by budding. Hydra (a simple aquatic animal) also reproduces this way. The offspring is a clone of the parent.\n\nFertilisation, pollination, and mating all involve two parents (male and female gametes combining) — these are all forms of sexual reproduction. Only budding is a single-parent asexual process among the options.',
      h: 'Asexual means one parent.',
    },
    {
      yr: 2024,
      q: 'Function of haemoglobin',
      o: [
        'Fight infection',
        'Transport oxygen',
        'Produce energy',
        'Digest food',
      ],
      a: 1,
      e: 'Haemoglobin is an iron-containing protein in red blood cells that binds and transports oxygen.',
      full: 'Haemoglobin is a protein found in red blood cells. Each haemoglobin molecule contains four iron-containing units called haem groups. Oxygen binds to these iron atoms in the lungs, where oxygen concentration is high, forming oxyhaemoglobin.\n\nAs the blood travels to tissues where oxygen concentration is lower, haemoglobin releases the oxygen for cells to use in respiration. The red blood cells then carry carbon dioxide back to the lungs for exhalation.\n\nWhite blood cells fight infection. Red blood cells carry oxygen thanks to haemoglobin — but haemoglobin itself is the specific molecule doing the carrying. Haemoglobin does not produce energy directly, nor does it digest food.',
      h: 'What makes red blood cells useful for the body?',
    },
    {
      yr: 2023,
      q: 'Fungi belong to kingdom',
      o: ['Plantae', 'Animalia', 'Fungi', 'Protista'],
      a: 2,
      e: 'Fungi are classified in their own kingdom.',
      full: 'For a long time, fungi were classified as plants because they do not move. But fungi are fundamentally different from plants in several key ways: they cannot photosynthesise (they have no chlorophyll), their cell walls are made of chitin (not cellulose like plant cells), and they obtain nutrition by absorbing organic matter from their environment.\n\nFungi are also different from animals — they are mostly multicellular (except yeast), have cell walls, and do not ingest food. And they are more complex than Protista (single-celled organisms).\n\nBecause fungi do not fit neatly into any other kingdom, they have been given their own kingdom — Fungi. This kingdom includes mushrooms, moulds, yeasts, and mildews.',
      h: 'Fungi have their own kingdom named after them.',
    },
    {
      yr: 2022,
      q: 'Removing metabolic waste from the body is called',
      o: ['Digestion', 'Excretion', 'Secretion', 'Absorption'],
      a: 1,
      e: 'Excretion removes metabolic waste products from the body.',
      full: 'Metabolism is the sum of all chemical reactions happening inside living organisms. These reactions produce waste products as by-products — carbon dioxide from respiration, urea from protein breakdown, water from various reactions.\n\nExcretion is specifically the removal of these METABOLIC waste products from the body. The lungs excrete CO2, the kidneys excrete urea in urine, and the skin excretes some salts and water in sweat.\n\nDigestion is the breakdown of food into absorbable nutrients. Secretion is the release of useful substances (like enzymes or hormones) from cells or glands — the opposite of excretion. Absorption is taking nutrients into the blood from the digestive system.',
      h: 'Removing METABOLIC waste specifically.',
    },
    {
      yr: 2024,
      q: 'The process by which plants lose water is called',
      o: ['Photosynthesis', 'Transpiration', 'Respiration', 'Excretion'],
      a: 1,
      e: 'Transpiration is the process by which plants lose water vapour through stomata.',
      full: 'Plants absorb water from the soil through their roots, which travels up through the stem to the leaves. In the leaves, this water evaporates from the cell surfaces and exits through tiny pores called stomata, mainly on the underside of leaves. This process of water loss is called transpiration.\n\nTranspiration serves important functions: it creates a tension that pulls water up from the roots (the transpiration stream), it cools the leaf surface, and it enables gas exchange. However, in very hot or dry conditions, stomata close to reduce water loss, which also reduces CO2 uptake and slows photosynthesis.\n\nThink of transpiration as the plant version of sweating.',
      h: 'Think of it as plants sweating.',
    },
    {
      yr: 2023,
      q: 'Which blood cells are responsible for immunity?',
      o: ['Red blood cells', 'Platelets', 'White blood cells', 'Plasma'],
      a: 2,
      e: 'White blood cells (leucocytes) are responsible for immune defence against pathogens.',
      full: "The blood contains three main cellular components: red blood cells (erythrocytes), white blood cells (leucocytes), and platelets (thrombocytes). Each has a distinct function.\n\nWhite blood cells are the immune system's soldiers. There are several types — neutrophils engulf and destroy bacteria, lymphocytes produce antibodies, and macrophages consume foreign particles and dead cells. Together they protect the body from infection by bacteria, viruses, fungi, and parasites.\n\nRed blood cells carry oxygen using haemoglobin. Platelets help blood to clot and stop bleeding. Plasma is the liquid component carrying nutrients, hormones, and waste. None of these are responsible for immune defence — only white blood cells are.",
      h: 'Which cells fight infection?',
    },
    {
      yr: 2022,
      q: 'The site of protein synthesis in a cell is the',
      o: ['Nucleus', 'Mitochondria', 'Ribosome', 'Vacuole'],
      a: 2,
      e: 'Ribosomes are the sites where proteins are synthesised using mRNA instructions.',
      full: 'Protein synthesis is one of the most important processes in any living cell — proteins carry out virtually every function of life. The process involves two steps: transcription (DNA → mRNA in the nucleus) and translation (mRNA → protein at the ribosome).\n\nRibosomes read the messenger RNA (mRNA) sequence and use it as instructions to assemble amino acids into a protein chain. Ribosomes are found floating freely in the cytoplasm or attached to the rough endoplasmic reticulum.\n\nThe nucleus stores the DNA blueprint. Mitochondria generate energy. The vacuole stores water and waste. Only ribosomes are the actual protein-building machines.',
      h: 'Which organelle reads mRNA to build proteins?',
    },
    {
      yr: 2024,
      q: 'AIDS is caused by',
      o: ['Bacteria', 'Virus', 'Fungi', 'Protozoa'],
      a: 1,
      e: 'AIDS is caused by HIV (Human Immunodeficiency Virus).',
      full: 'AIDS stands for Acquired Immunodeficiency Syndrome — a condition where the immune system is so severely damaged that the body cannot fight ordinary infections and cancers. AIDS is caused by the Human Immunodeficiency Virus (HIV).\n\nHIV attacks and destroys CD4+ T cells — a critical component of the immune system. As CD4+ cell counts fall, the body becomes increasingly vulnerable to opportunistic infections (infections that healthy immune systems would easily resist).\n\nHIV is transmitted through infected blood, sexual contact, sharing needles, or from mother to child during birth or breastfeeding. HIV/AIDS is a viral infection, not bacterial (B), fungal (C), or protozoan (D).',
      h: 'HIV = Human Immunodeficiency ___',
    },
    {
      yr: 2023,
      q: 'The process of cell division for growth is called',
      o: ['Meiosis', 'Mitosis', 'Fertilisation', 'Budding'],
      a: 1,
      e: 'Mitosis produces two genetically identical daughter cells for growth and repair.',
      full: 'Cell division occurs by two main processes. Mitosis produces two daughter cells that are genetically IDENTICAL to the parent cell — same number of chromosomes, same DNA. It is used for growth, repair of damaged tissues, and asexual reproduction.\n\nMeiosis produces four daughter cells that are genetically DIFFERENT from the parent cell — half the number of chromosomes (haploid). It is used only to produce sex cells (gametes): sperm and eggs in animals, pollen and ovules in plants.\n\nFertilisation is the fusion of two gametes. Budding is a form of asexual reproduction in yeast and hydra. For normal body growth and repair, mitosis is the process.',
      h: 'Mitosis = identical copies. Meiosis = sex cells.',
    },
    {
      yr: 2022,
      q: 'Which part of the eye controls the amount of light entering?',
      o: ['Retina', 'Cornea', 'Iris', 'Lens'],
      a: 2,
      e: 'The iris controls the size of the pupil, regulating how much light enters the eye.',
      full: 'The eye is a complex optical organ with multiple layers. The retina at the back contains light-sensitive cells (rods and cones) that detect light. The cornea is the transparent outer layer that refracts (bends) incoming light. The lens focuses light onto the retina.\n\nThe iris is the coloured part of the eye — it contains circular and radial muscle fibres that control the size of the pupil (the dark hole in the centre). In bright light, the iris contracts, making the pupil smaller to reduce the amount of light entering. In dim light, the iris relaxes, making the pupil larger to let in more light.\n\nThis automatic adjustment is called the pupillary reflex and protects the retina from damage caused by excess light.',
      h: 'Which coloured part of the eye expands and contracts?',
    },
    {
      yr: 2024,
      q: 'Malaria is caused by',
      o: ['Bacteria', 'Virus', 'Plasmodium', 'Fungi'],
      a: 2,
      e: 'Malaria is caused by Plasmodium parasites transmitted through Anopheles mosquito bites.',
      full: 'Malaria is one of the most significant infectious diseases in sub-Saharan Africa. It is caused by Plasmodium — a single-celled protozoan parasite. There are several species, but Plasmodium falciparum is the most deadly and most common in Nigeria.\n\nThe parasite is transmitted when a female Anopheles mosquito bites an infected person, takes in Plasmodium with the blood, and then bites another person, injecting the parasite into their bloodstream. The parasite travels to the liver, matures, then attacks red blood cells — causing the characteristic cycles of fever, chills, and sweating.\n\nMalaria is not caused by bacteria, viruses, or fungi. It is a parasitic protozoan disease.',
      h: 'Which protozoan parasite causes malaria?',
    },
    {
      yr: 2023,
      q: 'Photosynthesis produces',
      o: ['CO2 and water', 'Glucose and oxygen', 'ATP only', 'Lactic acid'],
      a: 1,
      e: 'Photosynthesis: 6CO2 + 6H2O + light energy produces glucose and O2.',
      full: 'Photosynthesis is the process by which green plants and algae convert light energy into chemical energy stored in glucose. The overall equation is:\n\n6CO₂ + 6H₂O + light energy → C₆H₁₂O₆ + 6O₂\n\nSix molecules of carbon dioxide and six molecules of water, using light energy, produce one molecule of glucose (C₆H₁₂O₆) and six molecules of oxygen gas. The oxygen is released into the atmosphere as a by-product — which is why plants are essential to sustaining oxygen levels on Earth.\n\nThe reactants are CO₂ and water. The products are glucose and oxygen. Carbon dioxide and water are CONSUMED, not produced.',
      h: 'What do plants make using sunlight?',
    },
    {
      yr: 2022,
      q: 'Enzymes are made of',
      o: ['Lipids', 'Carbohydrates', 'Proteins', 'Nucleic acids'],
      a: 2,
      e: 'Enzymes are biological catalysts made of protein.',
      full: 'A catalyst is a substance that speeds up a chemical reaction without being consumed in the process. Enzymes are biological catalysts — they speed up the thousands of chemical reactions that occur inside living cells, making life possible at normal body temperatures.\n\nEnzymes are made of protein — long chains of amino acids folded into precise three-dimensional shapes. The shape of the active site (the part of the enzyme where the reaction occurs) determines which specific reaction the enzyme catalyses. This is the lock-and-key model of enzyme action.\n\nEnzymes are highly specific (each catalyses only one reaction), sensitive to temperature and pH, and reusable. Without enzymes, most biochemical reactions would be too slow to sustain life.',
      h: 'Enzymes are biological molecules made of which macromolecule?',
    },
    {
      yr: 2024,
      q: 'Which nutrient provides the most energy per gram?',
      o: ['Carbohydrates', 'Proteins', 'Fats', 'Vitamins'],
      a: 2,
      e: 'Fats provide 9 kcal per gram, compared to 4 kcal for carbohydrates and proteins.',
      full: "The three macronutrients that provide energy are carbohydrates, proteins, and fats (lipids). Each provides a different amount of energy per gram:\n\nCarbohydrates: 4 kcal per gram — the body's preferred quick-release energy source.\nProteins: 4 kcal per gram — primarily used for building and repairing tissues, but can provide energy.\nFats: 9 kcal per gram — more than double the energy density of the others, making them the most concentrated energy store.\n\nThis is why fatty foods are high-calorie. Vitamins do not provide energy at all — they are micronutrients needed in tiny amounts for specific biochemical functions.",
      h: 'Which macronutrient is most energy-dense?',
    },
    {
      yr: 2023,
      q: 'The heart is made of which type of muscle?',
      o: ['Skeletal', 'Smooth', 'Cardiac', 'Striated'],
      a: 2,
      e: 'The heart is made of cardiac muscle, which contracts involuntarily and never fatigues.',
      full: 'The body has three types of muscle tissue: skeletal (voluntary, striated — the muscles you consciously control), smooth (involuntary, non-striated — in the walls of organs like the stomach and intestines), and cardiac (involuntary, striated — found only in the heart).\n\nCardiac muscle is unique in several ways: it is involuntary (you cannot stop your heart from beating through conscious effort), it is striated like skeletal muscle (giving it strength), and crucially — it never fatigues. The heart beats approximately 100,000 times a day, every day of your life, without rest.\n\nThis tireless nature of cardiac muscle is due to its high density of mitochondria (for constant energy supply) and intercalated discs that enable coordinated electrical impulses across all heart cells simultaneously.',
      h: 'Which muscle type is unique to the heart?',
    },
    {
      yr: 2022,
      q: 'Chromosomes are found in the',
      o: ['Cytoplasm', 'Mitochondria', 'Nucleus', 'Ribosome'],
      a: 2,
      e: 'Chromosomes carrying DNA are located in the nucleus of the cell.',
      full: 'The nucleus is the control centre of the cell, often called the "brain" of the cell. It contains the cell\'s genetic material in the form of chromosomes — tightly coiled structures made of DNA wrapped around proteins called histones.\n\nHuman cells (except red blood cells and mature sperm/egg) contain 46 chromosomes arranged in 23 pairs. During cell division, the chromosomes become visible under a microscope as distinct X-shaped structures.\n\nChromosomes are not found in the cytoplasm (the fluid surrounding organelles), not in the mitochondria (which have their own small circular DNA, but not chromosomes), and not in ribosomes (which read the instructions encoded in chromosomes).',
      h: "Where is the cell's genetic material stored?",
    },
    {
      yr: 2024,
      q: 'The function of the stomata in plants is to',
      o: [
        'Absorb water',
        'Allow gas exchange',
        'Produce glucose',
        'Store food',
      ],
      a: 1,
      e: 'Stomata are pores on leaves that allow gas exchange and water vapour out.',
      full: 'Stomata (singular: stoma) are microscopic pores found mainly on the underside of leaves. Each stoma is surrounded by a pair of guard cells that control whether the stoma is open or closed.\n\nWhen stomata are open, they allow: carbon dioxide to enter the leaf for photosynthesis, oxygen produced by photosynthesis to exit, and water vapour to escape (transpiration). This gas exchange is essential for plant life.\n\nDuring the day in sunlight, stomata are typically open for gas exchange. At night or during water stress (drought), they close to conserve water — but this also reduces CO₂ uptake and slows photosynthesis. The balance between gas exchange and water conservation is a fundamental challenge for plant life.',
      h: 'Small pores on leaves — what do they do?',
    },
    {
      yr: 2023,
      q: 'Blood clotting involves which blood component?',
      o: ['Red blood cells', 'White blood cells', 'Platelets', 'Plasma'],
      a: 2,
      e: 'Platelets (thrombocytes) are responsible for blood clotting to stop bleeding.',
      full: 'When a blood vessel is damaged, the body must quickly seal the breach to prevent excessive blood loss. Platelets — also called thrombocytes — are tiny cell fragments (not full cells) produced in bone marrow. They circulate in the blood and are activated when they encounter a damaged vessel wall.\n\nActivated platelets become sticky and clump together at the damage site, forming a temporary plug. They also release chemicals that trigger a cascade of reactions involving clotting proteins (like fibrinogen converting to fibrin) to form a proper blood clot — a mesh of fibres that seals the wound.\n\nPeople with too few platelets (thrombocytopenia) bleed excessively even from minor injuries.',
      h: 'Which blood component patches wounds?',
    },
    {
      yr: 2022,
      q: 'The kidneys are part of which system?',
      o: [
        'Digestive system',
        'Respiratory system',
        'Excretory system',
        'Nervous system',
      ],
      a: 2,
      e: 'The kidneys filter blood and produce urine as part of the excretory system.',
      full: 'The kidneys are paired bean-shaped organs located in the lower back. Their primary function is to filter waste products and excess substances from the blood, producing urine which is then excreted from the body.\n\nBlood enters each kidney through the renal artery. Inside the kidney, millions of tiny filtering units called nephrons remove urea (a waste product of protein metabolism), excess water, salts, and other substances. The filtered fluid becomes urine, which flows to the bladder.\n\nThis makes the kidneys a central organ of the excretory system. The digestive system breaks down food. The respiratory system handles gas exchange. The nervous system controls body functions. Only the excretory system is responsible for removing metabolic waste from the blood.',
      h: 'Which system removes waste products from the blood?',
    },
  ];
